/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "/nIA");
/******/ })
/************************************************************************/
/******/ ({

/***/ "+E39":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("S82l")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "+ZMJ":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("lOnJ");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "+g5I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_css__ = __webpack_require__("f9Jw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_ejs__ = __webpack_require__("i4xY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_ejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main_ejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_f_core_event__ = __webpack_require__("gzOS");


/**
 * Title module.
 * @module video/Title
 */





/**
 * title组件
 */

var Title = function () {
    /**
     * Creates an instance of Title.
     * @param {string} title 显示的内容
     */
    function Title(_ref) {
        var title = _ref.title,
            danmakuSet = _ref.danmakuSet;

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Title);

        /**
         * 默认弹幕开启
         */
        this.danmuStatus = 'open';
        if (typeof danmakuSet != 'undefined') {
            this.danmuStatus = danmakuSet.isOpen == 1 ? 'open' : 'close';
        };
        this.init({ title: title });
    }

    /**
     * 初始化
     *
     * @param {object} options
     * @param {string} options.title 要显示的内容
     */


    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Title, [{
        key: 'init',
        value: function init(options) {
            this.initDom();
            this.initCompontent(options.title);
            this.initEvent();
        }

        /**
         * 初始化组件
         *
         * @param {any} content
         */

    }, {
        key: 'initCompontent',
        value: function initCompontent(content) {
            this.title.html(content);
        }

        /**
         * 初始化dom
         */

    }, {
        key: 'initDom',
        value: function initDom() {
            this.el = $(__WEBPACK_IMPORTED_MODULE_3__main_ejs___default()())[0];
            this.title = $(this.el).find('#js_siderTop_title');
            this.baifen = $(this.el).find('#js_siderTop_scale');
            this.control = $(this.el).find('.siderTopControl');
            this.time = $(this.el).find('#js_siderTop_time');

            /**
             * 弹幕按钮
             */
            this.vB_switch = $(this.el).find('.v_switch');
        }

        /**
         * 初始化事件
         */

    }, {
        key: 'initEvent',
        value: function initEvent() {
            var _this = this;

            /**
             * 弹幕开关
             */
            this.vB_switch.on('click', function () {
                if (_this.danmuStatus == 'open') {
                    _this.changeDanmu('close');
                    _this.trigger('close');
                } else {
                    _this.changeDanmu('open');
                    _this.trigger('open');
                }
            });

            this.baifen.on('click', function (e) {
                var ev = e || window.event;
                var target = ev.target || ev.srcElement;
                if (target.nodeName.toLowerCase() == 'li') {
                    if (target.className == 'current') return;
                    _this.trigger('changeVideoSize', target);
                }
            });

            this.control.on('click', function (e) {
                var ev = e || window.event;
                var target = ev.target || ev.srcElement;
                if (target.nodeName.toLowerCase() == 'li') {
                    if (target.className == 'current') return;
                    // console.log(target);
                    var tag = target.getAttribute('data-tag');
                    // console.log(tag);
                    switch (tag) {
                        /**
                         * 重新获取数据
                         */
                        case 'replay':
                            break;

                        /**
                         * 换节目
                         */
                        case 'menu':
                            _this.trigger('listshow', 'list');
                            break;

                        /**
                         * 下载
                         */
                        case 'down':
                            _this.trigger('listshow', 'download');
                            break;

                        /**
                         * 分享
                         */
                        case 'share':
                            _this.trigger('listshow', 'share');
                            break;

                        default:
                            break;
                    }
                }
            });
        }

        /**
         * 切换弹幕状态
         *
         * @param {string} status 状态
         */

    }, {
        key: 'changeDanmu',
        value: function changeDanmu(status) {
            if (status === 'open') {
                this.vB_switch.addClass('v_switchon');
                this.danmuStatus = 'open';
            } else {
                this.vB_switch.removeClass('v_switchon');
                this.danmuStatus = 'close';
            }
        }

        /**
         * 显示时间
         */

    }, {
        key: 'showTime',
        value: function showTime() {
            this.time.html(new Date().formatNowTime('hh:mm'));
        }

        /**
         * 隐藏组件
         */

    }, {
        key: 'hide',
        value: function hide() {
            this.el.style.display = 'none';
        }

        /**
         * 显示组件
         */

    }, {
        key: 'show',
        value: function show() {
            this.el.style.display = 'block';
        }

        /**
         * 渲染组件
         *
         * @param {HTMLELEMENT} parentNode
         */

    }, {
        key: 'renderTo',
        value: function renderTo(parentNode) {
            parentNode.appendChild(this.el);
        }

        /**
         * 销毁组件
         */

    }, {
        key: 'destory',
        value: function destory() {
            this.el.parentNode.removeChild(this.el);
        }
    }]);

    return Title;
}();

__WEBPACK_IMPORTED_MODULE_4_f_core_event__["a" /* default */].mixTo(Title);
/* harmony default export */ __webpack_exports__["a"] = (Title);

/***/ }),

/***/ "+tPU":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("xGkn");
var global = __webpack_require__("7KvD");
var hide = __webpack_require__("hJx8");
var Iterators = __webpack_require__("/bQp");
var TO_STRING_TAG = __webpack_require__("dSzd")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ "//Fk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("U5ju"), __esModule: true };

/***/ }),

/***/ "/bQp":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "/nIA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_css__ = __webpack_require__("u+wB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_f_core_event__ = __webpack_require__("gzOS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_f_component_video_auth__ = __webpack_require__("63mF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_f_component_video_pc__ = __webpack_require__("tHOs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_f_component_video_vStat__ = __webpack_require__("NBD/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_canUseMse__ = __webpack_require__("7Co+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_version__ = __webpack_require__("oN26");











/**
 * 整个播放器模块
 */

var wideo = function () {
    /**
     * Creates an instance of wideo.
     * @param {object} obj
     * @param {object} obj.playermsg 当前视频信息
     * @param {object} obj.videoinfo 当前视频信息-地址
     * @param {object} obj.recommend 后推荐数据
     * @param {object} obj.sedata 视频列表数据
     */
    function wideo(_ref) {
        var playermsg = _ref.playermsg,
            videoinfo = _ref.videoinfo,
            recommend = _ref.recommend,
            sedata = _ref.sedata,
            isAuth = _ref.isAuth,
            isMse = _ref.isMse,
            showTestInfo = _ref.showTestInfo;

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, wideo);

        this.playermsg = playermsg;
        this.videoinfo = videoinfo;
        this.recommend = recommend;
        this.sedata = sedata;
        this.isAuth = isAuth || 'auth';
        this.isMse = isMse && true;
        this.showTestInfo = showTestInfo || false;
        var vStat = new __WEBPACK_IMPORTED_MODULE_6_f_component_video_vStat__["a" /* default */](videoinfo);
        window.gid = vStat.createUid();
        window.randomNum = vStat.createNum();
        this.init();
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(wideo, [{
        key: 'init',
        value: function init() {
            var canUseObj = new __WEBPACK_IMPORTED_MODULE_7_canUseMse__["a" /* default */]();
            this.canUseMse = canUseObj.judgement(); // 判断浏览器能否支持mse
            this.first = true; // 是否为第一次播放
            this._errcode = false;
            this.initComponent();
            this.initEvent();
        }

        /**
         * 初始化组件
         */

    }, {
        key: 'initComponent',
        value: function initComponent() {
            // 初始化正片      依赖 videoinfo

            this.initLoadingImg();
        }
    }, {
        key: 'initPcVideo',
        value: function initPcVideo(_this) {
            var __gid = window.gid;
            _this.pcvideo = new __WEBPACK_IMPORTED_MODULE_5_f_component_video_pc__["a" /* recodeVideo */]({
                videoinfo: _this.videoinfo,
                playermsg: _this.playermsg,
                recommend: _this.recommend,
                sedata: _this.sedata,
                isAuth: _this.isAuth
            });

            var mp4urlgid = _this.pcvideo.srcVideoUrl + '?' + Object(__WEBPACK_IMPORTED_MODULE_4_f_component_video_auth__["a" /* default */])({ videoinfo: videoinfo, __gid: __gid, version: __WEBPACK_IMPORTED_MODULE_8_version__["a" /* default */] });
            _this.pcvideo.src(mp4urlgid);

            _this.pcvideo.hide();

            _this.initPcVideoEvent();
        }

        /**
         * 初始化loading图
         */

    }, {
        key: 'initLoadingImg',
        value: function initLoadingImg() {
            var img = '\n            <div class="loading" style="width:100%;height:100%;position:absolute;top:0;left:0;">\n            <div class="loadingbanner"></div>\n            </div>\n        ';
            $('#js_video_container').html(img);
        }

        /**
         * 初始化事件
         */

    }, {
        key: 'initEvent',
        value: function initEvent() {
            var _this = this;

            _this.initPcVideo(_this);
            // pcvideo.src('http://ips.ifeng.com/video19.ifeng.com/video01/2007/10/27/2d07c660-7748-4266-a5a1-214763920bf2.flv');
            _this.pcvideo.show();
            _this.pcvideo.play();
            _this.trigger('start');

            /**
             * 开始播放
             */
            $('.videobox').on('click', '#js_videopause_container', function (e) {
                var vi = document.getElementById('player');

                if (vi.currentTime > 0) {
                    _this.pcvideo.play();
                    $('#js_videopause_container').hide();
                }
            });
        }
    }, {
        key: 'initPcVideoEvent',
        value: function initPcVideoEvent() {
            var _this = this;

            /**
             * 重播
             */
            _this.pcvideo.on('replay', function () {
                $('.videoPlayer .loading').show();
            });

            /**
             * 正片能播放时
             */
            _this.pcvideo.on('canplay', function () {
                if ($('.videoPlayer .loading')) {
                    $('.videoPlayer .loading').hide();
                }
            });

            /**
             * 播放中
             */
            _this.pcvideo.on('timeupdate', function (currentTime) {
                // if (currentTime === 0) return;
            });

            /**
             * 播放出现错误时
             */
            _this.pcvideo.on('error', function (code, currentTime) {
                // console.log(_this.adTag);
                /**
                 * 广告播完了 或者没有广告才可以显示错误
                 */
                if (_this.adTag) {
                    _this.pcvideo.recommend.initShow();
                    _this.pcvideo.error.show();
                    // core.hide();
                    _this.pcvideo.control.hide();
                }

                /**
                 * 没发过_errcode才可以发送错误
                 */
                if (_this._errcode === false) {
                    vStat.sendVplayer('44000' + code);
                    if (!currentTime) {
                        vStat.sendVplayer('301040');
                    }
                    _this._errcode = true;
                    _this.errShow = true;
                }
            });

            /**
             * 开始播放
             */
            _this.pcvideo.on('play', function () {
                if (_this.advideo && _this.advideo.AdPause) {
                    _this.advideo.AdPause.hide();
                }
            });

            /**
             * 播放暂停
             */
            _this.pcvideo.on('pause', function () {
                _this.advideo && _this.advideo.pauseAdShow();
            });
        }
    }]);

    return wideo;
}();

__WEBPACK_IMPORTED_MODULE_3_f_core_event__["a" /* default */].mixTo(wideo);
window.wideo = wideo;

/***/ }),

/***/ "1VYS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BrowserSupport_js__ = __webpack_require__("5vQn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getBrowser_js__ = __webpack_require__("1y9/");


/**
 * 判断浏览器是否可以使用mes
 * 先判断MSE属性的支持性 再判断设备类型 再判断白名单
 */



var canUseMse = function () {
    function canUseMse() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, canUseMse);

        this.BrowserSupport = new __WEBPACK_IMPORTED_MODULE_2__BrowserSupport_js__["a" /* default */]();
        this.BrowerInfo = new __WEBPACK_IMPORTED_MODULE_3__getBrowser_js__["a" /* default */]();
        console.log('------', this.BrowerInfo.get());
    }
    /**
     * @returns {Boolean} flag 是否可以用MSE的标志位
     */


    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(canUseMse, [{
        key: 'judgement',
        value: function judgement() {
            var flag = false;
            var device = this.BrowerInfo.getDevice();
            if (this.BrowserSupport.ifSupportMse() && device.type == 'pc' && this.BrowerInfo.get()) {
                // 判断是否在白名单中
                flag = true;
            }
            return flag;
        }
    }]);

    return canUseMse;
}();

/* harmony default export */ __webpack_exports__["a"] = (canUseMse);

/***/ }),

/***/ "1dQT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/**
 * 获取浏览器的兼容性
 */
var BrowserSupport = function () {
    function BrowserSupport() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, BrowserSupport);

        this.s = {
            video: this.ifSupportVideo(),
            MSE: this.ifSupportMse(),
            websocket: this.ifSupportSocket(),
            getUserMedeia: this.ifSupportUserMedia(),
            connection: this.ifSupportConnection(),
            candidate: this.ifSupportCandidate(),
            session: this.ifSupportSession()
        };
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(BrowserSupport, [{
        key: 'get',
        value: function get() {
            return this.s;
        }
        /**
         * 是否支持video
         */

    }, {
        key: 'ifSupportVideo',
        value: function ifSupportVideo() {
            var videoElement = document.createElement('video');
            if (videoElement && videoElement.canPlayType) {
                return true; // 是否支持video属性
            }
            return false;
        }
        /**
         * 是否支持MSE
         */

    }, {
        key: 'ifSupportMse',
        value: function ifSupportMse() {
            var mse = window['MediaSource'] || window['WebKitMediaSource'];
            if (mse && mse.isTypeSupported) {
                return true;
            }
            return false;
        }
        /**
         * 是否支持socket
         */

    }, {
        key: 'ifSupportSocket',
        value: function ifSupportSocket() {
            if (window.WebSocket) {
                return true; // 是否支持websocket
            }
            return false;
        }
        /**
         * 是否支持获取媒体属性
         */

    }, {
        key: 'ifSupportUserMedia',
        value: function ifSupportUserMedia() {
            if (navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia) {
                return true;
            }
            return false;
        }
        /**
         * 是否支持webrtc的connect
         */

    }, {
        key: 'ifSupportConnection',
        value: function ifSupportConnection() {
            if (window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection || window.PeerConnection || window.webkitPeerConnection00) {
                return true;
            }
            return false;
        }
        /**
         * 是否支持candidate
         */

    }, {
        key: 'ifSupportCandidate',
        value: function ifSupportCandidate() {
            if (window.RTCIceCandidate || window.mozRTCIceCandidate || window.webkitRTCSessionDescription) {
                return true;
            }
            return false;
        }
        /**
         * 是否支持webrct的session
         */

    }, {
        key: 'ifSupportSession',
        value: function ifSupportSession() {
            if (window.RTCSessionDescription || window.mozRTCSessionDescription || window.webkitRTCSessionDescription) {
                return true;
            }
            return false;
        }
    }]);

    return BrowserSupport;
}();

/* harmony default export */ __webpack_exports__["a"] = (BrowserSupport);

/***/ }),

/***/ "1uPB":
/***/ (function(module, exports) {


if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"videosiderRight\" id=\"js_siderRight\">\n    <div class=\"videosiderRightBg\"></div>\n    <div class=\"videosiderRightContent\">\n        <div class=\"siderRightShare\" id=\"js_siderRight_share\">\n            <div class=\"shareTip\">分享到微信</div>\n            <img src=\"http://qrcode.ifeng.com/2016/08/01/1fed05e73fed1a4a4353702af9ef39a0.png\" id=\"js_siderRight_shareImg\" />\n            <ul class=\"shareBtns js_siderShare_trigger\">\n                <li class=\"btn1\" data-tag=\"sinateew\"></li>\n                <li class=\"btn2\" data-tag=\"qqteew\"></li>\n                <li class=\"btn3\" data-tag=\"qqzone\"></li>\n            </ul>\n            <div class=\"copyTip\">复制转帖</div>\n            <textarea id=\"js_copy_text\" style=\"width: 0px;height: 0px;opacity: 0\"></textarea>\n            <ul class=\"copyBtns js_siderCopy_trigger\">\n                <li class=\"btn1\" data-tag=\"url\" data-text=\"播放地址\">播放地址</li>\n                <li class=\"btn2\" data-tag=\"mp4\" data-text=\"Mp4地址\">Flash地址</li>\n                <li class=\"btn3\" data-tag=\"html\" data-text=\"Html地址\">Html代码</li>\n            </ul>\n        </div>\n        <div class=\"siderRightDown\" id=\"js_siderRight_down\">\n            <a href=\"http://v.ifeng.com/apps/index.shtml\" target=\"_blank\">\n                <img src=\"http://y3.ifengimg.com/a/2015/0831/download.jpg\" alt=\"\" title=\"凤凰新闻客户端\">\n            </a>\n            <div class=\"downTip\">下载客户端观看</div>\n        </div>\n        <div class=\"siderRightList\" id=\"js_siderRight_menu\">\n            <div class=\"listPosition\" id=\"js_listPosition\">\n                <ul id=\"js_siderRight_list\">\n                </ul>\n                <div class=\"scrollbar\">\n                    <div class=\"scroller\" id=\"js_siderRight_scroller\"></div>\n                </div>\n            </div>\n        </div>\n        <div class=\"videosiderRightClose\">\n            <div class=\"closeBtn\" data-tag=\"siderRightclose\" id=\"js_siderRight_close\"></div>\n        </div>\n    </div>\n</div>")
  }
  return __output.join("");

}

/***/ }),

/***/ "1y9/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/**
 * 获取浏览器的信息
 */
var BrowserInfo = function () {
    function BrowserInfo() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, BrowserInfo);
    }
    /**
     * 返回浏览器的信息
     */


    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(BrowserInfo, [{
        key: 'get',
        value: function get() {
            var userAgent = navigator.userAgent.toLowerCase();
            var _version = void 0,
                _browserVersion = void 0,
                browser = {};

            try {
                _browserVersion = userAgent.match(/(?:firefox|opera|safari|chrome|msie|micromessenger)[\/: ]([\d.]+)/);
                if (_browserVersion) {
                    _browserVersion = _browserVersion[1];
                } else {
                    _browserVersion = '0';
                }

                /* 获得浏览器的名称及版本信息 */
                browser = {
                    version: _browserVersion,
                    safari: /version.+safari/.test(userAgent) || /safari[\/ ]+([\d.]+)/.test(userAgent),
                    chrome: /chrome|crios|crmo/.test(userAgent),
                    firefox: /firefox/.test(userAgent),
                    ie: /msie/.test(userAgent) || /trident/.test(userAgent), // IE
                    edge: /edge/.test(userAgent),
                    opera: /opera/.test(userAgent), // opera
                    uc: /ucbrowser\/([\d.]+)/.test(userAgent),
                    au: /mxbrowser/i.test(userAgent) || /mxios/i.test(userAgent), // 遨游浏览器
                    lb: /liebaofast/.test(userAgent), // 猎豹浏览器
                    qq: /mqqbrowser/.test(userAgent), // qq浏览器器
                    sg: /se 2.+x/.test(userAgent) || /sogou/.test(userAgent), // 搜狗浏览器
                    wx: /micromessenger/i.test(userAgent), // 微信
                    batapp: /baiduboxapp/.test(userAgent), // 手机百度
                    bat: /baidubrowser/.test(userAgent) // 百度浏览器
                };

                _version = browser.version.split('.')[0];

                if (browser.uc) {
                    _version = userAgent.match(/ucbrowser\/([\d.]+)/) ? userAgent.match(/ucbrowser\/([\d.]+)/)[1] : _version;
                    // return 'UC_' + _version;
                    return true;
                }

                if (browser.au) {
                    if (userAgent.match(/mxbrowser\/([\d.]+)/)) {
                        // android
                        _version = userAgent.match(/mxbrowser\/([\d.]+)/)[1];
                    } else if (userAgent.match(/mxios\/([\d.]+)/)) {
                        //ios
                        _version = userAgent.match(/mxios\/([\d.]+)/)[1];
                    } else {
                        _version = _version;
                    }

                    // return 'AU_' + _version;
                    return true;
                }

                if (browser.lb) {
                    _version = userAgent.match(/liebaofast\/([0-9.]+)/) ? userAgent.match(/liebaofast\/([0-9.]+)/)[1] : _version;
                    // return 'LB_' + _version;
                    return true;
                }

                // if (browser.mqq) {
                //     _version = userAgent.match(/qq\/([\d.]+)/) ? userAgent.match(/qq\/([\d.]+)/)[1] : _version;
                //     return 'MQQ_' + _version;
                // }

                if (browser.qq && !browser.wx) {
                    _version = userAgent.match(/qqbrowser\/([\d.]+)/) ? userAgent.match(/qqbrowser\/([\d.]+)/)[1] : _version;
                    // return 'QQ_' + _version;
                    return true;
                }

                //QZONEJSSDK/6.7.2.1 QQJSSDK/1.2 Mozilla/5.0 (iPhone; CPU iPhone OS 9_3_2 like Mac OS X) AppleWebKit/601.1.46 (KHTML, like Gecko) Mobile/13F69 Qzone/V1_IPH_QZ_6.7.2_1_APP_A NewVersion
                // if (browser.qzone) {
                //     //诡异的ua
                //     _version = userAgent.match(/qz_([\d.]+)/i) ? userAgent.match(/qz_([\d.]+)/i)[1] : _version;
                //     return 'QZONE_' + _version;
                // }

                // if (browser.wx) {
                //     _version = userAgent.match(/micromessenger\/([\d.]+)/)
                //         ? userAgent.match(/micromessenger\/([\d.]+)/)[1]
                //         : _version;
                //     return 'WX_' + _version;
                // }

                // if (browser.bat) {
                //     _version = userAgent.match(/baidubrowser\/([\d.]+)/)
                //         ? userAgent.match(/baidubrowser\/([\d.]+)/)[1]
                //         : _version;
                //     // return 'BAT_' + _version;
                //     return true;
                // }

                // ios          baiduboxapp/0_7.0.5.7_enohpi_6311_046
                // android      baiduboxapp/7.5.1
                // if (browser.batapp) {
                //     _version = userAgent.match(/baiduboxapp\/([\d._]+)/)
                //         ? userAgent.match(/baiduboxapp\/([\d._]+)/)[1]
                //         : _version;
                //     if (_version.indexOf('_') > -1) {
                //         _version = _version.split('_')[1];
                //     }
                //     return 'BATAPP_' + _version;
                // }

                // if (browser.sg) {
                //     _version = userAgent.match(/sogoumobilebrowser\/([\d.]+)/i)
                //         ? userAgent.match(/sogoumobilebrowser\/([\d.]+)/i)[1]
                //         : _version;
                //     return 'SG_' + _version;
                // }

                if (browser.firefox) {
                    // return 'FF_' + _version;
                    return true;
                }

                if (browser.opera) {
                    // return 'OP_' + _version;
                    return true;
                }

                //ios CriOs/52.0.14.258
                if (browser.chrome) {
                    _version = userAgent.match(/(?:chrome|crios|crmo)\/([0-9.]+)/) ? userAgent.match(/(?:chrome|crios|crmo)\/([0-9.]+)/)[1] : _version;
                    if (/bidubrowser/.test(userAgent) || /se 2.+x/.test(userAgent)) {
                        // 搜狗和百度暂时不支持
                        return false;
                    }
                    // return 'CM_' + _version;
                    return true;
                }

                if (browser.safari) {
                    if (userAgent.match(/android/)) {
                        // return 'WK_' + userAgent.match(/webkit\/([\d.]+)/)[1];
                        return false;
                    } else {
                        try {
                            if (userAgent.match(/(?:version)[\/: ]([\d.]+)/)) {
                                _version = userAgent.match(/(?:version)[\/: ]([\d.]+)/)[1];
                            }
                        } catch (exs) {}

                        // return 'SF_' + _version;
                        return true;
                    }
                }

                // if (browser.ie) {
                //     if (userAgent.indexOf('rv:11') > -1) {
                //         _version = '11';
                //     }

                //     return 'IE_' + _version;
                // }

                if (browser.edge) {
                    return true;
                }
            } catch (ex) {
                return false;
            }

            return false;
        }
        /**
         * 获取设备类型
         */

    }, {
        key: 'getDevice',
        value: function getDevice() {
            var device = { type: 'pc' };
            var win = window;
            var detect = function detect(ua) {
                // 一大批基于ua进行判断的正则。
                var oTemp = {};
                var os = oTemp.os = {};
                var browser = oTemp.browser = {};
                var webkit = ua.match(/WebKit\/([\d.]+)/);
                var android = ua.match(/(Android)\s+([\d.]+)/);
                var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
                var iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
                var webos = ua.match(/(webOS|hpwOS)[\s\/]([\d.]+)/);
                var touchpad = webos && ua.match(/TouchPad/);
                var kindle = ua.match(/Kindle\/([\d.]+)/);
                var silk = ua.match(/Silk\/([\d._]+)/);
                var blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/);
                var bb10 = ua.match(/(BB10).*Version\/([\d.]+)/);
                var rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/);
                var playbook = ua.match(/PlayBook/);
                var chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/);
                var firefox = ua.match(/Firefox\/([\d.]+)/);
                var bIsWM = ua.match(/Windows Phone/);

                // Todo: clean this up with a better OS/browser seperation:
                // - discern (more) between multiple browsers on android
                // - decide if kindle fire in silk mode is android or not
                // - Firefox on Android doesn't specify the Android version
                // - possibly devide in os, device and browser hashes

                browser.webkit = !!webkit;

                if (browser.webkit) {
                    browser.version = webkit[1];
                }

                // 是否是windows phone
                if (bIsWM) {
                    os.wphone = true;
                }

                if (android) {
                    os.android = true;
                    os.version = android[2];
                }

                if (iphone) {
                    os.ios = true;
                    os.iphone = true;
                    os.version = iphone[2].replace(/_/g, '.');
                }

                if (ipad) {
                    os.ios = true;
                    os.ipad = true;
                    os.version = ipad[2].replace(/_/g, '.');
                }

                if (webos) {
                    os.webos = true;
                    os.version = webos[2];
                }

                if (touchpad) {
                    os.touchpad = true;
                }

                if (blackberry) {
                    os.blackberry = true;
                    os.version = blackberry[2];
                }

                if (bb10) {
                    os.bb10 = true;
                    os.version = bb10[2];
                }

                if (rimtabletos) {
                    os.rimtabletos = true;
                    os.version = rimtabletos[2];
                }

                if (playbook) {
                    browser.playbook = true;
                }

                if (kindle) {
                    os.kindle = true;
                    os.version = kindle[1];
                }

                if (silk) {
                    browser.silk = true;
                    browser.version = silk[1];
                }

                if (!silk && os.android && ua.match(/Kindle Fire/)) {
                    browser.silk = true;
                }

                if (chrome) {
                    browser.chrome = true;
                    browser.version = chrome[1];
                }

                if (firefox) {
                    browser.firefox = true;
                    browser.version = firefox[1];
                }

                os.tablet = !!(ipad || playbook || android && !ua.match(/Mobile/) || firefox && ua.match(/Tablet/));
                os.phone = !!(!os.tablet && (android || iphone || webos || blackberry || bb10 || chrome && ua.match(/Android/) || chrome && ua.match(/CriOS\/([\d.]+)/) || firefox && ua.match(/Mobile/)) || bIsWM);

                return oTemp;
            };

            var deviceConfig = detect(navigator.userAgent);
            device.config = deviceConfig;

            if (deviceConfig.os.tablet) {
                device.type = 'pad';
            }

            if ( /* weighing === 2 || */deviceConfig.os.phone) {
                device.type = 'mobile';
            }

            var screenW = win.screen.width;
            var screenH = win.screen.height;
            var innerW = win.innerWidth;
            var innerH = win.innerHeight;

            // 获取设备的宽度和高度，
            // 在安卓设备中，device-width和device-height无法准确获取，
            // 这里使用通过一个取巧的方式来通过计算点密度反推设备宽高，
            // 不过这里还是不能证明能够获取正确的设备宽高。
            if (deviceConfig.os.ios || device.type === 'pc') {
                device.width = screenW;
                device.height = screenH;
            } else {
                var ratioW = screenW / innerW;
                var ratioH = screenH / innerH;
                var ratio = ratioW < ratioH ? ratioW : ratioH;
                device.width = Math.floor(screenW / ratio);
                device.height = Math.floor(screenH / ratio);
            }

            // doc.title = device.type + ":" + device.width + ":" + device.height;
            return device;
        }
    }]);

    return BrowserInfo;
}();

/* harmony default export */ __webpack_exports__["a"] = (BrowserInfo);

/***/ }),

/***/ "2KxR":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "2Tst":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__browserSupport_js__ = __webpack_require__("DfDH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getBrowser_js__ = __webpack_require__("2u5i");




/**
 * 判断浏览器是否可以使用mes
 * 先判断MSE属性的支持性 再判断设备类型 再判断白名单
 */

var canUseMse = function () {
    function canUseMse() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, canUseMse);

        this.BrowserSupport = new __WEBPACK_IMPORTED_MODULE_2__browserSupport_js__["a" /* default */]();
        this.BrowerInfo = new __WEBPACK_IMPORTED_MODULE_3__getBrowser_js__["a" /* default */]();
        //console.log('------', this.BrowerInfo.get());
    }
    /**
     * @returns {Boolean} flag 是否可以用MSE的标志位
     */


    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(canUseMse, [{
        key: 'judgement',
        value: function judgement() {
            var flag = false;
            var device = this.BrowerInfo.getDevice();
            if (this.BrowserSupport.ifSupportMse() && device.type == 'pc' && this.BrowerInfo.canUseBrowser()) {
                // 判断是否在白名单中
                flag = true;
            }
            return flag;
        }
    }]);

    return canUseMse;
}();

/* harmony default export */ __webpack_exports__["a"] = (canUseMse);

/***/ }),

/***/ "2u5i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/**
 * 获取浏览器的信息
 */
var BrowserInfo = function () {
    function BrowserInfo() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, BrowserInfo);
    }
    /**
     * 返回浏览器的信息
     */


    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(BrowserInfo, [{
        key: 'canUseBrowser',
        value: function canUseBrowser() {
            var userAgent = navigator.userAgent.toLowerCase();
            var _version = void 0,
                _browserVersion = void 0,
                browser = {};

            try {
                _browserVersion = userAgent.match(/(?:firefox|opera|safari|chrome|msie|micromessenger)[\/: ]([\d.]+)/);
                if (_browserVersion) {
                    _browserVersion = _browserVersion[1];
                } else {
                    _browserVersion = '0';
                }

                /* 获得浏览器的名称及版本信息 */
                browser = {
                    version: _browserVersion,
                    safari: /version.+safari/.test(userAgent) || /safari[\/ ]+([\d.]+)/.test(userAgent),
                    chrome: /chrome|crios|crmo/.test(userAgent),
                    firefox: /firefox/.test(userAgent),
                    ie: /msie/.test(userAgent) || /trident/.test(userAgent), // IE
                    edge: /edge/.test(userAgent),
                    opera: /opera/.test(userAgent), // opera
                    uc: /ucbrowser\/([\d.]+)/.test(userAgent),
                    au: /mxbrowser/i.test(userAgent) || /mxios/i.test(userAgent), // 遨游浏览器
                    lb: /liebaofast/.test(userAgent), // 猎豹浏览器
                    qq: /mqqbrowser/.test(userAgent), // qq浏览器器
                    sg: /se 2.+x/.test(userAgent) || /sogou/.test(userAgent), // 搜狗浏览器
                    wx: /micromessenger/i.test(userAgent), // 微信
                    batapp: /baiduboxapp/.test(userAgent), // 手机百度
                    bat: /baidubrowser/.test(userAgent) // 百度浏览器
                };

                _version = browser.version.split('.')[0];

                if (browser.uc) {
                    _version = userAgent.match(/ucbrowser\/([\d.]+)/) ? userAgent.match(/ucbrowser\/([\d.]+)/)[1] : _version;
                    // return 'UC_' + _version;
                    return true;
                }

                if (browser.au) {
                    if (userAgent.match(/mxbrowser\/([\d.]+)/)) {
                        // android
                        _version = userAgent.match(/mxbrowser\/([\d.]+)/)[1];
                    } else if (userAgent.match(/mxios\/([\d.]+)/)) {
                        //ios
                        _version = userAgent.match(/mxios\/([\d.]+)/)[1];
                    } else {
                        _version = _version;
                    }

                    // return 'AU_' + _version;
                    return true;
                }

                if (browser.lb) {
                    _version = userAgent.match(/liebaofast\/([0-9.]+)/) ? userAgent.match(/liebaofast\/([0-9.]+)/)[1] : _version;
                    // return 'LB_' + _version;
                    return true;
                }

                // if (browser.mqq) {
                //     _version = userAgent.match(/qq\/([\d.]+)/) ? userAgent.match(/qq\/([\d.]+)/)[1] : _version;
                //     return 'MQQ_' + _version;
                // }

                if (browser.qq && !browser.wx) {
                    _version = userAgent.match(/qqbrowser\/([\d.]+)/) ? userAgent.match(/qqbrowser\/([\d.]+)/)[1] : _version;
                    // return 'QQ_' + _version;
                    return true;
                }

                //QZONEJSSDK/6.7.2.1 QQJSSDK/1.2 Mozilla/5.0 (iPhone; CPU iPhone OS 9_3_2 like Mac OS X) AppleWebKit/601.1.46 (KHTML, like Gecko) Mobile/13F69 Qzone/V1_IPH_QZ_6.7.2_1_APP_A NewVersion
                // if (browser.qzone) {
                //     //诡异的ua
                //     _version = userAgent.match(/qz_([\d.]+)/i) ? userAgent.match(/qz_([\d.]+)/i)[1] : _version;
                //     return 'QZONE_' + _version;
                // }

                // if (browser.wx) {
                //     _version = userAgent.match(/micromessenger\/([\d.]+)/)
                //         ? userAgent.match(/micromessenger\/([\d.]+)/)[1]
                //         : _version;
                //     return 'WX_' + _version;
                // }

                // if (browser.bat) {
                //     _version = userAgent.match(/baidubrowser\/([\d.]+)/)
                //         ? userAgent.match(/baidubrowser\/([\d.]+)/)[1]
                //         : _version;
                //     // return 'BAT_' + _version;
                //     return true;
                // }

                // ios          baiduboxapp/0_7.0.5.7_enohpi_6311_046
                // android      baiduboxapp/7.5.1
                // if (browser.batapp) {
                //     _version = userAgent.match(/baiduboxapp\/([\d._]+)/)
                //         ? userAgent.match(/baiduboxapp\/([\d._]+)/)[1]
                //         : _version;
                //     if (_version.indexOf('_') > -1) {
                //         _version = _version.split('_')[1];
                //     }
                //     return 'BATAPP_' + _version;
                // }

                // if (browser.sg) {
                //     _version = userAgent.match(/sogoumobilebrowser\/([\d.]+)/i)
                //         ? userAgent.match(/sogoumobilebrowser\/([\d.]+)/i)[1]
                //         : _version;
                //     return 'SG_' + _version;
                // }

                if (browser.firefox) {
                    // return 'FF_' + _version;
                    return true;
                }

                if (browser.opera) {
                    // return 'OP_' + _version;
                    return true;
                }

                //ios CriOs/52.0.14.258
                if (browser.chrome) {
                    _version = userAgent.match(/(?:chrome|crios|crmo)\/([0-9.]+)/) ? userAgent.match(/(?:chrome|crios|crmo)\/([0-9.]+)/)[1] : _version;
                    if (/bidubrowser/.test(userAgent) || /se 2.+x/.test(userAgent)) {
                        // 搜狗和百度暂时不支持
                        return false;
                    }
                    // return 'CM_' + _version;
                    return true;
                }

                if (browser.safari) {
                    if (userAgent.match(/android/)) {
                        // return 'WK_' + userAgent.match(/webkit\/([\d.]+)/)[1];
                        return false;
                    } else {
                        try {
                            if (userAgent.match(/(?:version)[\/: ]([\d.]+)/)) {
                                _version = userAgent.match(/(?:version)[\/: ]([\d.]+)/)[1];
                            }
                        } catch (exs) {}

                        // return 'SF_' + _version;
                        return true;
                    }
                }

                // if (browser.ie) {
                //     if (userAgent.indexOf('rv:11') > -1) {
                //         _version = '11';
                //     }

                //     return 'IE_' + _version;
                // }

                if (browser.edge) {
                    return true;
                }
            } catch (ex) {
                return false;
            }

            return false;
        }
        /**
         * 获取设备类型
         */

    }, {
        key: 'getDevice',
        value: function getDevice() {
            var device = { type: 'pc' };
            var win = window;
            var detect = function detect(ua) {
                // 一大批基于ua进行判断的正则。
                var oTemp = {};
                var os = oTemp.os = {};
                var browser = oTemp.browser = {};
                var webkit = ua.match(/WebKit\/([\d.]+)/);
                var android = ua.match(/(Android)\s+([\d.]+)/);
                var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
                var iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
                var webos = ua.match(/(webOS|hpwOS)[\s\/]([\d.]+)/);
                var touchpad = webos && ua.match(/TouchPad/);
                var kindle = ua.match(/Kindle\/([\d.]+)/);
                var silk = ua.match(/Silk\/([\d._]+)/);
                var blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/);
                var bb10 = ua.match(/(BB10).*Version\/([\d.]+)/);
                var rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/);
                var playbook = ua.match(/PlayBook/);
                var chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/);
                var firefox = ua.match(/Firefox\/([\d.]+)/);
                var bIsWM = ua.match(/Windows Phone/);

                // Todo: clean this up with a better OS/browser seperation:
                // - discern (more) between multiple browsers on android
                // - decide if kindle fire in silk mode is android or not
                // - Firefox on Android doesn't specify the Android version
                // - possibly devide in os, device and browser hashes

                browser.webkit = !!webkit;

                if (browser.webkit) {
                    browser.version = webkit[1];
                }

                // 是否是windows phone
                if (bIsWM) {
                    os.wphone = true;
                }

                if (android) {
                    os.android = true;
                    os.version = android[2];
                }

                if (iphone) {
                    os.ios = true;
                    os.iphone = true;
                    os.version = iphone[2].replace(/_/g, '.');
                }

                if (ipad) {
                    os.ios = true;
                    os.ipad = true;
                    os.version = ipad[2].replace(/_/g, '.');
                }

                if (webos) {
                    os.webos = true;
                    os.version = webos[2];
                }

                if (touchpad) {
                    os.touchpad = true;
                }

                if (blackberry) {
                    os.blackberry = true;
                    os.version = blackberry[2];
                }

                if (bb10) {
                    os.bb10 = true;
                    os.version = bb10[2];
                }

                if (rimtabletos) {
                    os.rimtabletos = true;
                    os.version = rimtabletos[2];
                }

                if (playbook) {
                    browser.playbook = true;
                }

                if (kindle) {
                    os.kindle = true;
                    os.version = kindle[1];
                }

                if (silk) {
                    browser.silk = true;
                    browser.version = silk[1];
                }

                if (!silk && os.android && ua.match(/Kindle Fire/)) {
                    browser.silk = true;
                }

                if (chrome) {
                    browser.chrome = true;
                    browser.version = chrome[1];
                }

                if (firefox) {
                    browser.firefox = true;
                    browser.version = firefox[1];
                }

                os.tablet = !!(ipad || playbook || android && !ua.match(/Mobile/) || firefox && ua.match(/Tablet/));
                os.phone = !!(!os.tablet && (android || iphone || webos || blackberry || bb10 || chrome && ua.match(/Android/) || chrome && ua.match(/CriOS\/([\d.]+)/) || firefox && ua.match(/Mobile/)) || bIsWM);

                return oTemp;
            };

            var deviceConfig = detect(navigator.userAgent);
            device.config = deviceConfig;

            if (deviceConfig.os.tablet) {
                device.type = 'pad';
            }

            if ( /* weighing === 2 || */deviceConfig.os.phone) {
                device.type = 'mobile';
            }

            var screenW = win.screen.width;
            var screenH = win.screen.height;
            var innerW = win.innerWidth;
            var innerH = win.innerHeight;

            // 获取设备的宽度和高度，
            // 在安卓设备中，device-width和device-height无法准确获取，
            // 这里使用通过一个取巧的方式来通过计算点密度反推设备宽高，
            // 不过这里还是不能证明能够获取正确的设备宽高。
            if (deviceConfig.os.ios || device.type === 'pc') {
                device.width = screenW;
                device.height = screenH;
            } else {
                var ratioW = screenW / innerW;
                var ratioH = screenH / innerH;
                var ratio = ratioW < ratioH ? ratioW : ratioH;
                device.width = Math.floor(screenW / ratio);
                device.height = Math.floor(screenH / ratio);
            }

            // doc.title = device.type + ":" + device.width + ":" + device.height;
            return device;
        }
    }]);

    return BrowserInfo;
}();

/* harmony default export */ __webpack_exports__["a"] = (BrowserInfo);

/***/ }),

/***/ "3Eo+":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "3fs2":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("RY/4");
var ITERATOR = __webpack_require__("dSzd")('iterator');
var Iterators = __webpack_require__("/bQp");
module.exports = __webpack_require__("FeBl").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "3kBm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_f_core_event__ = __webpack_require__("gzOS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__video__ = __webpack_require__("c0Wv");


/**
 * Core module.
 * @module video/Core
 */




var _videos = {};

var currentVideo = '';
var index = 0;
var uuid = function uuid() {
    return 'video_' + index++;
};

/**
 * 字符串首字母转为大写
 *
 * @param {string} string
 * @return {string} 首字母大写的字符串
 */
var toTitleCase = function toTitleCase(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

/**
 * 给dom设置属性
 *
 * @param {any} el
 * @param {any} name
 * @param {any} val
 * @return {undefined}
 */
var setAttribute = function setAttribute(el, name, val) {
    return el.setAttribute(name, val);
};

/**
 * 加载video
 *
 * @param {dom} el
 * @return {undefined}
 */
var loadVideo = function loadVideo(el) {
    if (typeof el.load === 'function') {
        // wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
        (function () {
            try {
                el.load();
            } catch (e) {
                // satisfy linter
            }
        })();
    }
};

/**
 * 重置video
 *
 * @param {dom} el
 * @return {undefined}
 */
var resetVideo = function resetVideo(el) {
    if (!el) {
        return;
    }

    var sources = el.querySelectorAll('source');
    var i = sources.length;

    while (i--) {
        el.removeChild(sources[i]);
    }

    // remove any src reference.
    // not setting `src=''` because that throws an error
    el.removeAttribute('src');
    loadVideo(el);
};

/**
 * 创建video
 *
 * @param {object} options
 * @property {boolean} options.inline 是否内联播放
 * @property {boolean} options.muted 是否预加载
 * @property {boolean} options.controls 是否显示控制条
 * @property {boolean} options.autoplay 是否自动播放
 * @property {string} options.poster 封面图地址
 * @property {string} options.width 视频宽度
 * @return {HTMLElement} video元素
 */
var createVideo = function createVideo(options) {
    var el = document.createElement('video');

    setAttribute(el, 'id', 'player');

    // if (options.preload) {
    //     setAttribute(el, 'preload', 'auto');
    // } else {
    //     setAttribute(el, 'preload', 'meta');
    // }

    // setAttribute(el, 'preload', 'none');

    // el.className = 'c-video__meta';
    if (options.inline) {
        setAttribute(el, 'playsinline', 'playsinline');
        setAttribute(el, 'webkit-playsinline', 'webkit-playsinline');
    }
    if (options.muted) {
        setAttribute(el, 'muted', 'muted');
    }
    if (options.controls) {
        setAttribute(el, 'controls', 'true');
    }
    if (options.autoplay) {
        setAttribute(el, 'autoplay', 'autoplay');
    }
    if (options.poster) {
        setAttribute(el, 'poster', options.poster);
    }
    // setAttribute(el, 'src', options.src);
    loadVideo(el);
    el.width = options.width;
    return el;
};

/**
 * 缓存video
 *
 * @param {object} core
 */
var regVideo = function regVideo(core) {
    if (typeof _videos[core.__uuid] == 'undefined') {
        _videos[core.__uuid] = core;
    }
};

/**
 * 取消video缓存
 *
 * @param {object} core
 */
var unRegVideo = function unRegVideo(core) {
    if (typeof _videos[core.__uuid] !== 'undefined') {
        delete _videos[core.__uuid];
    }
};

/**
 * video核心core
 */

var Core = function () {
    /**
     * Creates an instance of Core.
     * @param {any} options
     */
    function Core(options) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Core);

        this.init(options);
    }

    /**
     * 初始化
     *
     * @param {object} options
     * @property {boolean} options.inline 是否内联播放
     * @property {boolean} options.muted 是否预加载
     * @property {boolean} options.controls 是否显示控制条
     * @property {boolean} options.autoplay 是否自动播放
     * @property {string} options.poster 封面图地址
     * @property {string} options.width 视频宽度
     */


    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Core, [{
        key: 'init',
        value: function init(options) {
            this.event = new __WEBPACK_IMPORTED_MODULE_2_f_core_event__["a" /* default */]();
            this.__isPlayed = false; // 是否在播放
            this.__uuid = uuid();
            regVideo(this);
            this.el = createVideo(options); // 创建video标签
            this.initEvent();
        }

        /**
         * custom Event
         * begin 当一个视频源第一次播放的时候，会触发一次此事件。
         * swtich 当使用src()播放另外一个视频的时候，会触发一次此事件，有两个参数oldsrc, newsrc
         */

    }, {
        key: 'initEvent',
        value: function initEvent() {
            var _this = this;

            $(this.el).on('play', function () {
                _this.__isPlayed = true;
            });

            $(this.el).on('pause', function () {
                _this.__isPlayed = false;
            });

            // 对视频的第一次播放进行处理
            // var begin = function(event) {
            //     if (this.__isPlayed == false) {
            //         this.__isPlayed = true;
            //         this.event.trigger('begin');
            //     }
            // }.bind(this);

            // this.on('timeupdate', begin);

            // this.on('playing', function() {
            //     // console.log('playing');
            //     currentVideo = this;
            // }.bind(this));

            // var __this = this;
            // Events.forEach(function (eventName) {
            //   (function (evnetName) {
            //     __this.on(eventName, function () {
            //       divLog(eventName, 'is fire');
            //       console.log(eventName, 'is fire');
            //     });
            //   }(eventName));
            // });
        }

        /**
         * 注册video事件或自定义事件
         *
         * @param {string} eventName
         * @param {function} callback
         */

    }, {
        key: 'on',
        value: function on(eventName, callback) {
            if (__WEBPACK_IMPORTED_MODULE_3__video__["a" /* VideoEvents */].includes(eventName)) {
                this.el.addEventListener(eventName, callback, false);
            } else {
                this.event.on(eventName, callback);
            }
        }

        /**
         * 解绑video事件或自定义事件
         *
         * @param {string} eventName
         * @param {function} callback
         */

    }, {
        key: 'off',
        value: function off(eventName, callback) {
            if (__WEBPACK_IMPORTED_MODULE_3__video__["a" /* VideoEvents */].includes(eventName)) {
                this.el.removeEventListener(eventName, callback);
            } else {
                this.event.off(eventName, callback);
            }
        }

        /**
         * 当前video暂停
         */

    }, {
        key: 'pause',
        value: function pause() {
            this.el.pause();
        }

        /**
         * 当前video播放
         */

    }, {
        key: 'play',
        value: function play() {
            var playPromise = this.el.play();
            // Catch/silence error when a pause interrupts a play request
            // on browsers which return a promise
            if (playPromise !== undefined && typeof playPromise.then === 'function') {
                playPromise.then(null, function (e) {});
            }
        }

        /**
         * 设置当前video-currentTime
         *
         * @param {number} seconds
         */

    }, {
        key: 'setCurrentTime',
        value: function setCurrentTime(seconds) {
            try {
                this.el.currentTime = seconds;
            } catch (e) {
                console.log(e, 'Video is not ready. (Video.js)');
                // this.warning(VideoJS.warnings.videoNotReady);
            }
        }

        /**
         * 加载video
         */

    }, {
        key: 'load',
        value: function load() {
            loadVideo(this.el);
        }

        /**
         * 隐藏video
         */

    }, {
        key: 'hide',
        value: function hide() {
            this.el.style.display = 'none';
        }

        /**
         * 显示video
         */

    }, {
        key: 'show',
        value: function show() {
            this.el.style.display = 'block';
        }

        /**
         * 重置video
         */

    }, {
        key: 'reset',
        value: function reset() {
            resetVideo(this.el);
            this.__isPlayed = false;
        }

        /**
         * 设置video播放源路径
         *
         * @param {string} src
         */

    }, {
        key: 'src',
        value: function src(_src) {
            if (_src === undefined) {
                return this.el.src;
            }

            this.reset();
            this.event.trigger('switch', this.el.src, _src);
            setAttribute(this.el, 'src', _src);
        }

        /**
         *
         * @param {any} argument
         */

    }, {
        key: 'initLoading',
        value: function initLoading(argument) {
            var img = '';
            img += '<div class="loading" style="width:100%;height:100%;position:absolute;top:0;left:0;">';
            img += '<div class="loadingbanner"></div>';
            img += '</div>';
            document.getElementById('js_video_container').innerHTML = img;
        }

        /**
         * 渲染video-dom
         *
         * @param {HTMLELEMENT} container
         */

    }, {
        key: 'renderTo',
        value: function renderTo(container) {
            container.appendChild(this.el);
        }

        /**
         * 销毁当前video并解绑事件
         */

    }, {
        key: 'destory',
        value: function destory() {
            var _this2 = this;

            // 解除所有事件绑定
            __WEBPACK_IMPORTED_MODULE_3__video__["a" /* VideoEvents */].forEach(function (eventName) {
                _this2.off(eventName);
            });
            this.off('begin');
            this.off('switch');

            // 重置
            this.reset();

            // 移除dom节点。
            if (this.el.parentNode) {
                this.el.parentNode.removeChild(this.el);
            }

            // 取消在全局的注册
            unRegVideo(this);
        }

        /**
         * 获取video-buffer长度
         *
         * @returns {number} bufferer.length
         */

    }, {
        key: 'getBuffered',
        value: function getBuffered() {
            var buffered = this.el.buffered;
            return buffered.length === 0 ? 0 : buffered.end(buffered.length - 1);
        }

        /**
         * 获取当前video
         *
         * @static
         * @returns {object} currentVideo
         */

    }], [{
        key: 'current',
        value: function current() {
            return currentVideo;
        }

        /**
         * 获取所有注册的video
         *
         * @static
         * @returns {object} videos
         */

    }, {
        key: 'videos',
        value: function videos() {
            return _videos;
        }
    }]);

    return Core;
}();

__WEBPACK_IMPORTED_MODULE_3__video__["b" /* videoPropertiesByGet */].forEach(function (prop) {
    Core.prototype['get' + toTitleCase(prop)] = function () {
        return this.el[prop];
    };
});

// Wrap native properties with a setter in this format:
// set + toTitleCase(name)
__WEBPACK_IMPORTED_MODULE_3__video__["c" /* videoPropertiesBySet */].forEach(function (prop) {
    Core.prototype['set' + toTitleCase(prop)] = function (v) {
        this.el[prop] = v;
    };
});

// wrap native functions with a function
[
/**
 * Pause for core
 *
 * @method Core.prototype.pause
 */
'pause'].forEach(function (prop) {
    Core.prototype[prop] = function () {
        return this.el[prop]();
    };
});

/**  */
/* harmony default export */ __webpack_exports__["a"] = (Core);

/***/ }),

/***/ "4mcu":
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "52gC":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "5vQn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/**
 * 获取浏览器的兼容性
 */
var BrowserSupport = function () {
    function BrowserSupport() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, BrowserSupport);

        this.s = {
            video: this.ifSupportVideo(),
            MSE: this.ifSupportMse(),
            websocket: this.ifSupportSocket(),
            getUserMedeia: this.ifSupportUserMedia(),
            connection: this.ifSupportConnection(),
            candidate: this.ifSupportCandidate(),
            session: this.ifSupportSession()
        };
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(BrowserSupport, [{
        key: 'get',
        value: function get() {
            return this.s;
        }
        /**
         * 是否支持video
         */

    }, {
        key: 'ifSupportVideo',
        value: function ifSupportVideo() {
            var videoElement = document.createElement('video');
            if (videoElement && videoElement.canPlayType) {
                return true; // 是否支持video属性
            }
            return false;
        }
        /**
         * 是否支持MSE
         */

    }, {
        key: 'ifSupportMse',
        value: function ifSupportMse() {
            var mse = window['MediaSource'] || window['WebKitMediaSource'];
            if (mse && mse.isTypeSupported) {
                return true;
            }
            return false;
        }
        /**
         * 是否支持socket
         */

    }, {
        key: 'ifSupportSocket',
        value: function ifSupportSocket() {
            if (window.WebSocket) {
                return true; // 是否支持websocket
            }
            return false;
        }
        /**
         * 是否支持获取媒体属性
         */

    }, {
        key: 'ifSupportUserMedia',
        value: function ifSupportUserMedia() {
            if (navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia) {
                return true;
            }
            return false;
        }
        /**
         * 是否支持webrtc的connect
         */

    }, {
        key: 'ifSupportConnection',
        value: function ifSupportConnection() {
            if (window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection || window.PeerConnection || window.webkitPeerConnection00) {
                return true;
            }
            return false;
        }
        /**
         * 是否支持candidate
         */

    }, {
        key: 'ifSupportCandidate',
        value: function ifSupportCandidate() {
            if (window.RTCIceCandidate || window.mozRTCIceCandidate || window.webkitRTCSessionDescription) {
                return true;
            }
            return false;
        }
        /**
         * 是否支持webrct的session
         */

    }, {
        key: 'ifSupportSession',
        value: function ifSupportSession() {
            if (window.RTCSessionDescription || window.mozRTCSessionDescription || window.webkitRTCSessionDescription) {
                return true;
            }
            return false;
        }
    }]);

    return BrowserSupport;
}();

/* harmony default export */ __webpack_exports__["a"] = (BrowserSupport);

/***/ }),

/***/ "5zde":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("zQR9");
__webpack_require__("qyJz");
module.exports = __webpack_require__("FeBl").Array.from;


/***/ }),

/***/ "63mF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_antiTheft__ = __webpack_require__("McAV");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__js_antiTheft__["a" /* default */]);

/***/ }),

/***/ "77Pl":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("EqjI");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "7Co+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__canUseMse_js__ = __webpack_require__("2Tst");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__canUseMse_js__["a" /* default */]);

/***/ }),

/***/ "7KvD":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "7nRM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__("c/Tr");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
};

/***/ }),

/***/ "82Mu":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7KvD");
var macrotask = __webpack_require__("L42u").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("R9M2")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if (Observer) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "880/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("hJx8");


/***/ }),

/***/ "94VQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("Yobk");
var descriptor = __webpack_require__("X8DO");
var setToStringTag = __webpack_require__("e6n0");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("hJx8")(IteratorPrototype, __webpack_require__("dSzd")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "9bBU":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("mClu");
var $Object = __webpack_require__("FeBl").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "BYgZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_css__ = __webpack_require__("ttlt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_ejs__ = __webpack_require__("1uPB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_ejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main_ejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_f_core_event__ = __webpack_require__("gzOS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_f_core_util_pc__ = __webpack_require__("QZmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_f_core_util_pc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_f_core_util_pc__);


/**
 * List module.
 * @module video/List
 */





var pcVideoUtil = new __WEBPACK_IMPORTED_MODULE_5_f_core_util_pc___default.a();

/**
 * 全屏时，列表组件
 */

var List = function () {
    /**
     * Creates an instance of List.
     * @param {object} obj
     * @param {object} obj.videoinfo video相关信息
     * @param {object} obj.sedata 列表相关数据
     * @param {object} container 容器
     */
    function List(_ref) {
        var videoinfo = _ref.videoinfo,
            _ref$sedata = _ref.sedata,
            sedata = _ref$sedata === undefined ? [] : _ref$sedata,
            container = _ref.container;

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, List);

        this.videoinfo = videoinfo;
        this.sedata = sedata;
        this.container = container;
        this.state = false;
        // this.init();
    }

    /**
     * 初始化快捷方法
     */


    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(List, [{
        key: 'initShow',
        value: function initShow() {
            if (!this.state) {
                this.state = true;
                this.init();
                this.renderTo(this.container);
            }

            this.show();
        }

        /**
         * 初始化
         */

    }, {
        key: 'init',
        value: function init() {
            this.initDom();
            this.initCompontent();
            this.getCommentCount();
            this.initEvent();
        }

        /**
         * 初始化dom
         */

    }, {
        key: 'initDom',
        value: function initDom() {
            this.el = $(__WEBPACK_IMPORTED_MODULE_3__main_ejs___default()())[0];
            // this.share = $(this.el).find('#js_siderRight_share');
            this.shareBtns = $(this.el).find('.shareBtns');
            this.copyBtns = $(this.el).find('.copyBtns');

            // this.download = $(this.el).find('#js_siderRight_down');

            // this.list = $(this.el).find('#js_siderRight_menu');

            this.listul = $(this.el).find('#js_siderRight_list');
            // js_listPosition
            // this.listdiv = this.el.getElementsByClassName('listPosition')[0];
            // js_siderRight_list

            // js_siderRight_scroller
            // this.listscroll = this.el.getElementsByClassName('scroller')[0];

            this.close = $(this.el).find('#js_siderRight_close');

            // 复制
            this.copyText = $(this.el).find('#js_copy_text');
            // 二维码
            this.js_siderRight_shareImg = $(this.el).find('#js_siderRight_shareImg');
        }

        /**
         * 初始化component
         */

    }, {
        key: 'initCompontent',
        value: function initCompontent() {
            var listStr = '';
            for (var vi = 0, vl = this.sedata.length; vi < vl; vi++) {
                var _sedata = this.sedata[vi];
                var _class = videoinfo.vid == _sedata.id ? 'class=current' : '';
                listStr += '\n                <li ' + _class + ' data-vid="' + _sedata.id + '">\n                    <a href="' + _sedata.link + '">\n                        <img src="' + _sedata.img + '" />\n                        <i></i>\n                        <span class="time">' + pcVideoUtil.formatTime(_sedata.duration || 0) + '</span>\n                        <em>' + _sedata.text + '</em>\n                    </a>\n                </li>\n            ';
            }
            this.listul.html(listStr);
        }

        /**
         * 请求微信分享二维码图片
         */

    }, {
        key: 'getCommentCount',
        value: function getCommentCount() {
            var _this = this;
            if (typeof videoinfo !== "undefined" && typeof videoinfo.vid !== "undefined") {
                //    微信分享请求二维码
                var mUrl = videoinfo.mUrl;
                $.ajax({
                    url: 'http://qrcode.ifeng.com/qrcode.php',
                    cache: true,
                    dataType: 'jsonp',
                    data: {
                        url: mUrl + '?_share=weixin'
                    },
                    success: function success(r) {
                        _this.js_siderRight_shareImg.attr('src', r.qrcode_url);
                    }
                });
            }
        }

        /**
         * 初始化自定义事件
         */

    }, {
        key: 'initEvent',
        value: function initEvent() {
            var _this = this;
            var videoinfo = _this.videoinfo;

            /**
             * 关闭按钮点击事件
             */
            this.close.on('click', function () {
                _this.hide();
            });

            /**
             * 分享按钮点击事件
             */
            this.shareBtns.on('click', function (e) {
                var ev = e || window.event;
                var target = ev.target || ev.srcElement;
                if (target.nodeName.toLowerCase() == 'li') {
                    if (target.className == 'current') return;
                    var _sendcode = null;
                    var tag = target.getAttribute('data-tag');
                    switch (tag) {
                        case 'sinateew':
                            _sendcode = 503004;
                            pcVideoUtil.sendStatisticInfoC('sina');
                            pcVideoUtil.shareVideo('sinateew');
                            break;
                        case 'qqteew':
                            _sendcode = 5030022;
                            pcVideoUtil.sendStatisticInfoC('qq');
                            pcVideoUtil.shareVideo('qqteew');
                            break;
                        case 'qqzone':
                            _sendcode = 503002;
                            pcVideoUtil.sendStatisticInfoC('qqZone');
                            pcVideoUtil.shareVideo('qqzone');
                            break;
                    }
                    /** 分享发送统计 */
                    _this.trigger('sendVplayer', _sendcode);
                }
            });

            /**
             * 复制按钮点击事件
             */
            this.copyBtns.on('click', function (e) {
                var ev = e || window.event;
                var target = ev.target || ev.srcElement;
                if (target.nodeName.toLowerCase() == 'li') {
                    if (target.className == 'current') return;
                    var tag = target.getAttribute('data-tag');
                    switch (tag) {
                        case 'url':
                            var _urlText = videoinfo.url;
                            _this.copy(_urlText, target);
                            break;
                        case 'mp4':
                            var _mp4Text = 'http://v.ifeng.com/include/exterior.swf?guid=' + videoinfo.id + '&AutoPlay=false';
                            _this.copy(_mp4Text, target);
                            break;
                        case 'html':
                            var _htmlText = '<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" codebase="http://download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=7,0,19,0" width="400" height="325"><param name="movie" value="http://v.ifeng.com/include/exterior.swf?guid=' + videoinfo.id + '&pageurl=http://www.ifeng.com&fromweb=other&AutoPlay=false" /><param name="quality" value="high" /><param name="allowScriptAccess" value="always" /><embed src="http://v.ifeng.com/include/exterior.swf?guid=' + videoinfo.id + '&pageurl=http://www.ifeng.com&fromweb=other&AutoPlay=false" quality="high"  allowScriptAccess="always" pluginspage="http://www.macromedia.com/go/getflashplayer" type="application/x-shockwave-flash" width="400" height="325"></embed></object>';
                            _this.copy(_htmlText, target);
                            break;
                    }
                }
            });
            // this.addScroll();
        }

        /**
         * 复制内容
         *
         * @param {string} txt 文本内容
         * @param {HTMLELEMENT} ele 元素载体
         */

    }, {
        key: 'copy',
        value: function copy(txt, ele) {
            // this.el.style.display = 'none';
            var preText = ele.innerHTML; // 存起来
            this.copyText.html(txt);
            this.copyText.select();
            document.execCommand('Copy');
            $(ele).html('√复制成功');
            $(ele).addClass('selected');
            setTimeout(function () {
                ele.innerHTML = preText;
                $(ele).removeClass('selected');
            }, 1000);
            var old = $(ele).siblings();

            $(old[0]).removeClass('selected').html($(old[0]).attr('data-text'));
            $(old[1]).removeClass('selected').html($(old[1]).attr('data-text'));
            console.log($(old[0]).attr('data-text'));
            console.log($(old[1]).attr('data-text'));
            this.trigger('sendVplayer', 504000);
        }

        /**
         * 隐藏组件
         */

    }, {
        key: 'hide',
        value: function hide() {
            this.el.style.display = 'none';
        }

        /**
         * 显示组件
         */

    }, {
        key: 'show',
        value: function show() {
            this.el.style.display = 'block';
        }

        /**
         * 渲染组件
         *
         * @param {HTMLELEMENT} parentNode
         */

    }, {
        key: 'renderTo',
        value: function renderTo(parentNode) {
            parentNode.appendChild(this.el);
        }
    }]);

    return List;
}();

__WEBPACK_IMPORTED_MODULE_4_f_core_event__["a" /* default */].mixTo(List);
/* harmony default export */ __webpack_exports__["a"] = (List);

/***/ }),

/***/ "C4MV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("9bBU"), __esModule: true };

/***/ }),

/***/ "CFqg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_f_core_util_pc__ = __webpack_require__("QZmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_f_core_util_pc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_f_core_util_pc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_version__ = __webpack_require__("oN26");


/**
 * Stat module.
 * @module video/Stat
 */



var pcVideoUtil = new __WEBPACK_IMPORTED_MODULE_2_f_core_util_pc___default.a();

/**
 * 统计模块
 */

var Stat = function () {
    /**
     * Creates an instance of Stat.
     * @param {object} playermsg
     */
    function Stat(playermsg) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Stat);

        this.playermsg = playermsg;
        this.init(playermsg);
    }

    /**
     * 随机唯一uid
     *
     * @returns {string} 随机唯一uid
     */


    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Stat, [{
        key: 'getRandomUid',
        value: function getRandomUid() {
            var tn = new Date().getTime() + (Math.round((1 << 12) * Math.random()) << 24);
            var sn = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZXX';
            var uuid = '';

            var fn1 = sn.charAt(parseInt(tn & 63));
            tn = tn >> 6;
            var fn2 = sn.charAt(parseInt(tn & 63));
            tn = tn >> 6;
            var fn3 = sn.charAt(parseInt(tn & 63));
            tn = tn >> 6;
            var fn4 = sn.charAt(parseInt(tn & 63));
            tn = tn >> 6;
            var fn5 = sn.charAt(parseInt(tn & 63));
            tn = tn >> 6;
            var fn6 = sn.charAt(parseInt(tn & 63));
            uuid += fn6 + fn5 + fn4 + fn3 + fn2 + fn1;

            return uuid;
        }

        /**
         * 创建uid
         *
         * @returns {string} uid
         */

    }, {
        key: 'createUid',
        value: function createUid() {
            var key = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';
            /**
             * 28位
             */
            var ramStr = parseInt(Math.random() * 268435455).toString(2);

            /**
             * 44位
             */
            var mtimeStr = new Date().getTime().toString(2);

            while (ramStr.length < 28) {
                ramStr = '0' + ramStr;
            }while (mtimeStr.length < 44) {
                mtimeStr = '0' + mtimeStr;
            }var binaryStr = ramStr + mtimeStr;

            var outStr = '';
            for (var i = 0; i < 12; i++) {
                outStr += key.charAt(parseInt(binaryStr.substr(i * 6, 6), 2));
            }

            return outStr;
        }

        /**
         * 创建随机数
         *
         * @returns {number} 随机数
         */

    }, {
        key: 'createNum',
        value: function createNum() {
            var min = 1;
            var max = 10000;
            var outNum = void 0;
            var randomNum = Math.random() * (max - min) + min;
            console.log(randomNum);
            if (randomNum >= 1 && randomNum <= 1000) {
                /**
                 * 随机数在0-1000内才发送统计
                 */
                outNum = 1;
            } else {
                outNum = 0;
            }
            return outNum;
        }

        /**
         * 初始化
         *
         * @param {object} playermsg
         */

    }, {
        key: 'init',
        value: function init(playermsg) {
            this.initParams(playermsg);
        }

        /**
         * 初始化参数
         *
         * @param {object} playermsg
         */

    }, {
        key: 'initParams',
        value: function initParams(playermsg) {
            /**
             * 发送vv统计
             */
            this.mediaurl = 'http://stadig.ifeng.com/media.js';

            /**
             * 发送抽样统计
             */
            this.playerurl = 'http://stadig.ifeng.com/vplayer.js';

            /**
             * 广告统计
             */
            this.adplayerurl = 'http://stadig.ifeng.com/apvsta.js';

            /**
             * 播放次数
             */
            this.accumulator = 'http://survey.news.ifeng.com/accumulator.php';

            this.gid = this.createUid();

            var defautlParams = this.formatmsg(playermsg);
            var mediaParams = this.formatMediamsg(playermsg);

            this.mediaParams = pcVideoUtil.extend(defautlParams, mediaParams);
            this.restore();

            var vplayerParams = this.formatPlayermsg(playermsg);
            this.playerParams = pcVideoUtil.extend(defautlParams, vplayerParams);

            var adParams = this.formatAdmsg(playermsg);
            this.adParams = pcVideoUtil.extend(defautlParams, adParams);
        }
    }, {
        key: 'sendMedia',
        value: function sendMedia(url) {
            var flag = 'is_' + url + '_send';
            if (this[flag] === true) {
                return;
            }
            this[flag] = true;

            var newparams = pcVideoUtil.extend(this.mediaParams, {
                'url': url,
                tm: new Date().getTime()
            });
            var params = [];
            for (var key in newparams) {
                params.push(key + '=' + encodeURIComponent(newparams[key]));
            }

            var scriptDom = document.createElement('script');
            scriptDom.src = this.mediaurl + '?' + params.join('&');
            document.getElementsByTagName("head")[0].appendChild(scriptDom);

            if (url == 'vv') {
                //vv时发送播放数累加accumulator
                var _scriptDom = document.createElement('script');
                _scriptDom.src = this.accumulator + '?key=' + this.playermsg.vid + '&tm=' + new Date().getTime();
                document.getElementsByTagName("head")[0].appendChild(_scriptDom);
            }
        }
    }, {
        key: 'sendVplayer',
        value: function sendVplayer(obj) {
            var vdocumentFlag = false;
            if (videoinfo.categoryId != '') {
                var ptype = videoinfo.categoryId.split('-')[0];
                if (ptype == '154') {
                    vdocumentFlag = true;
                }
            }

            if (randomNum == 0 && !vdocumentFlag) {
                return; //0:抽样统计的随机数不在0-1000之间，不发送统计;1:随机数在0-1000之间，才发送统计
            };

            var newparams = this.formatPlayermsg(obj);
            newparams = pcVideoUtil.extend(this.playerParams, newparams);
            if (obj == 100000) {
                var lan = window.navigator.language || '';
                var _browser = pcVideoUtil.getBrowser();
                var _screen = pcVideoUtil.getResolution();
                var systemInfo = pcVideoUtil.getOS() + '$false$' + lan + '$' + 1 + '$' + _screen.screenW + '$' + _screen.screenH;

                newparams.systemInfo = systemInfo;
            }
            newparams.gid = window.gid || '';
            newparams.url = window.srcVideoUrl || '';
            newparams.tm = new Date().getTime();
            newparams.err = obj;
            var params = [];
            for (var key in newparams) {
                params.push(key + '=' + encodeURIComponent(newparams[key]));
            }

            var scriptDom = document.createElement('script');
            scriptDom.src = this.playerurl + '?' + params.join('&');
            document.getElementsByTagName("head")[0].appendChild(scriptDom);
        }
    }, {
        key: 'sendAd',
        value: function sendAd(url, type) {
            var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Object();
            var ind = arguments[3];

            var newparams = pcVideoUtil.extend(this.adParams, {
                'url': url,
                'atype': type,
                'tm': new Date().getTime()
            });
            if (url == 'request') {
                //请求时，把所有广告信息发送
                var _time = data.oneadTime ? data.oneadTime.join('|') : '';

                var _aid = data.adUrl ? data.adUrl.join('|') : data.materiaUrl || '';
                newparams = pcVideoUtil.extend(newparams, {
                    'snapid': '',
                    'adur': _time,
                    'aid': _aid
                });
            } else {
                var _time = data.oneadTime ? data.oneadTime[ind] : '';
                var _aid = data.adUrl ? data.adUrl[ind] : data.materiaUrl || '';
                newparams = pcVideoUtil.extend(newparams, {
                    'snapid': '',
                    'adur': _time,
                    'aid': _aid
                });
            }
            var params = [];
            for (var key in newparams) {
                params.push(key + '=' + encodeURIComponent(newparams[key]));
            }
            var scriptDom = document.createElement('script');
            scriptDom.src = this.adplayerurl + '?' + params.join('&');
            document.getElementsByTagName("head")[0].appendChild(scriptDom);
        }
    }, {
        key: 'changeParams',
        value: function changeParams(playermsg) {
            var newParams = this.formatMediamsg(playermsg);
            this.params = pcVideoUtil.extend(this.params, newParams);
            this.restore();
        }
    }, {
        key: 'restore',
        value: function restore() {
            this.is_vv_send = false;
            this.is_cv_send = false;
        }

        /**
         * 格式化playermsg
         *
         * @param {object} playermsg
         * @returns {object} 格式化后的数据
         */

    }, {
        key: 'formatmsg',
        value: function formatmsg(playermsg) {
            var userid = void 0;
            if (pcVideoUtil.playerGetCookie('userid') === '') {
                userid = this.getRandomUid();
                pcVideoUtil.playerSetCookie('userid', userid, {
                    domain: '.ifeng.com',
                    path: '/',
                    expires: 60 * 24 * 360
                });
            } else {
                userid = pcVideoUtil.playerGetCookie('userid');
            }

            var cid = typeof playermsg.categoryId !== 'undefined' ? playermsg.categoryId : '';
            var vid = __WEBPACK_IMPORTED_MODULE_3_version__["a" /* default */];
            var cname = playermsg.columnName;

            var from = 'v_Free';
            var ptype = '';
            var loc = '';

            if (cid != '') {
                ptype = cid.split('-')[0];
                if (ptype == '154') {
                    from = 'v_Doc';
                } else if (ptype == '171') {
                    from = 'v_Biz';
                } else {
                    from = 'v_Free';
                }
            }

            // @todo 这个地方使用了外部的约定设备校验，不是很好，回头是否要封装一个方法？
            if (typeof device !== 'undefined' && typeof device.type !== 'undefined') {
                loc = device.type;
            }

            return {
                id: playermsg.vid,
                sid: pcVideoUtil.playerGetCookie('sid'),
                uid: userid,
                from: from,
                vid: vid,
                provider: playermsg.CPId,
                dur: playermsg.duration,
                se: typeof cname !== 'undefined' ? cname : cid,
                cat: cid,
                ptype: ptype,
                ref: window.location.href,
                loc: loc
            };
        }
    }, {
        key: 'formatMediamsg',
        value: function formatMediamsg(playermsg) {
            var cid = typeof playermsg.categoryId !== 'undefined' ? playermsg.categoryId : '';
            return {
                cat: cid,
                provider: playermsg.CPId
            };
        }
    }, {
        key: 'formatPlayermsg',
        value: function formatPlayermsg(playermsg) {
            var url = typeof playermsg.src !== 'undefined' ? playermsg.src + '?gid=' + this.gid : '';
            var br = typeof playermsg.br !== 'undefined' ? playermsg.br : '';
            var err = typeof playermsg.err !== 'undefined' ? playermsg.err : '';

            var obj = {};
            obj.gid = this.gid;
            if (url != '') obj.url = url;
            if (br != '') obj.br = br;
            if (err != '') obj.err = err;

            return obj;
        }
    }, {
        key: 'formatAdmsg',
        value: function formatAdmsg(playermsg) {
            var cid = typeof playermsg.categoryId !== 'undefined' ? playermsg.categoryId : '';
            var _browser = pcVideoUtil.getBrowser();
            var _screen = pcVideoUtil.getResolution();
            var systemInfo = 'PC,' + pcVideoUtil.getOS() + ',' + _browser.type + '_' + _browser.version + ',' + _screen.screenW + '*' + _screen.screenH;
            return {
                cat: cid,
                provider: playermsg.CPId,
                systemInfo: systemInfo
            };
        }
    }]);

    return Stat;
}();

/* harmony default export */ __webpack_exports__["a"] = (Stat);

/***/ }),

/***/ "CXw9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("O4g8");
var global = __webpack_require__("7KvD");
var ctx = __webpack_require__("+ZMJ");
var classof = __webpack_require__("RY/4");
var $export = __webpack_require__("kM2E");
var isObject = __webpack_require__("EqjI");
var aFunction = __webpack_require__("lOnJ");
var anInstance = __webpack_require__("2KxR");
var forOf = __webpack_require__("NWt+");
var speciesConstructor = __webpack_require__("t8x9");
var task = __webpack_require__("L42u").set;
var microtask = __webpack_require__("82Mu")();
var newPromiseCapabilityModule = __webpack_require__("qARP");
var perform = __webpack_require__("dNDb");
var promiseResolve = __webpack_require__("fJUb");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("dSzd")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  if (promise._h == 1) return false;
  var chain = promise._a || promise._c;
  var i = 0;
  var reaction;
  while (chain.length > i) {
    reaction = chain[i++];
    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
  } return true;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("xH/j")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("e6n0")($Promise, PROMISE);
__webpack_require__("bRrM")(PROMISE);
Wrapper = __webpack_require__("FeBl")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("dY0y")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "Cdx3":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("sB3e");
var $keys = __webpack_require__("lktj");

__webpack_require__("uqUo")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "D2L2":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "DUya":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__httpRequest__ = __webpack_require__("PgFv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__downloadConfig__ = __webpack_require__("JUcH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__adapter__ = __webpack_require__("pYFB");



 //下载配置模块


// 块大小
var BLOCK_SIZE = __WEBPACK_IMPORTED_MODULE_3__downloadConfig__["a" /* default */].BLOCK_SIZE;
// P2P接收数据块大小

var P2PBLOCK_SIZE = __WEBPACK_IMPORTED_MODULE_3__downloadConfig__["a" /* default */].P2PBLOCK_SIZE;
//接收数据的超时设置

var receiveDataTimeOut = __WEBPACK_IMPORTED_MODULE_3__downloadConfig__["a" /* default */].receiveDataTimeOut;

/*******************P2P模块*********************/

var moz = !!navigator.mozGetUserMedia;
var iceServer = {
    iceServers: [{
        url: 'stun:111.202.92.70:3578',
        urls: 'stun:111.202.92.70:3578'
    }]
};

// 保存已经通过连接的种子
var gGoodPeerIds = [];
// 保存已经尝试过打不通的种子
var gBadPeerIds = [];

// 查找已存在的种子
function selectPeer(peerArray, peerIds) {
    var peerIndexs = [];
    for (var i = 0; i < peerArray.length; i++) {
        for (var j = 0; j < peerIds.length; j++) {
            if (peerArray[i] == peerIds[j]) {
                peerIndexs.push(i);
            }
        }
    }
    return peerIndexs;
}

// 请求类型
var P2PHttpRequestType = {
    REQUEST_NULL: 0,
    GET_PEER: 1,
    SEND_CANDIDATE_OFFER: 2
};
// 连接信息
function PeerConnectInfo() {
    // candidate
    this.candidate = [];
    this.session_desc = null;
}

//获取到candidate
function gotLocalCandidate(that) {
    return function (evt) {
        if (evt.candidate) {
            that.mPeerConnectInfo.candidate.push(evt.candidate.candidate);
            console.log('pc.onicecandidate', that.mTimer);
        }
    };
}

function gotReceiveChannel(that) {
    return function (evt) {
        console.log('receiveChannel');
        that.receiveChannel = evt.channel;
        that.addDataChannel(peerId, that.receiveChannel);
    };
}

function channelOpen(that) {
    return function () {
        console.log('channel.onopen mTimer');
        window.clearTimeout(that.mTimer);
        that.mTimer = null;
        gGoodPeerIds.push(that.mCurrentPeerId);
        that.receiveDataTimer = setTimeout(that.checkDataLength(that), receiveDataTimeOut);
    };
}

function channelClose(that) {
    return function (event) {
        console.log('sendchannelClose');
        window.clearTimeout(that.mTimer);
        that.mTimer = null;
        if (that.dataChannel != null && that.dataChannel != undefined) {
            delete that.dataChannel;
            that.dataChannel = null;
        }
        //换种子
        //that.changePeer();
    };
}

function receiveChannelClose(that) {
    return function (event) {
        console.log('receivechannelClose');
        window.clearTimeout(that.mTimer);
        that.mTimer = null;
        if (that.dataChannel != null && that.dataChannel != undefined) {
            delete that.dataChannel;
            that.dataChannel = null;
        }
        //换种子
        //that.changePeer();
    };
}

function channelOnmessage(that) {
    return function (message) {
        console.log('recv message');
        if (that.receiveTime == 0) {
            that.receiveTime = new Date().getTime();
        }
        var arrayBuf = new Uint8Array(message.data);
        //console.log("recv message:" + message.data);
        var headInfo = new Uint32Array(message.data);
        var recvData = that.analysisData(arrayBuf, headInfo);

        if (recvData != null && recvData != undefined) {
            that.putData(recvData);
        }
    };
}

function channelError(that) {
    return function (err) {
        console.log('channelError');
        window.clearTimeout(that.mTimer);
        that.mTimer = null;
        if (that.dataChannel != null && that.dataChannel != undefined) {
            delete that.dataChannel;
            that.dataChannel = null;
        }
        //换种子
        that.changePeer();
        console.log('channel.onmessage data_channel_error ' + err);
    };
}

/*******************P2P下载数据类*********************/
function P2PDownload() {
    // url
    this.mURL = '';
    // 服务器返回的种子
    this.mPeerIds = [];
    // 块号
    this.mBlockInfo = null;
    // 当前请求种子Id
    this.mCurrentPeerId = 0;
    //保存所有与本地相连的peer connection， 键为socket id，值为PeerConnection类型
    this.peerConnection = null;
    //保存所有的data channel，键为socket id，值通过PeerConnection实例的createChannel创建
    this.dataChannel = null;
    // 连接信息
    this.mPeerConnectInfo = null;
    // 接收数据
    this.mData = new Uint8Array(BLOCK_SIZE);
    // 接收数据表
    this.mDataRecvTable = [];
    // 服务器信息
    this.mServerInfo = null;
    // 当前状态
    this.mStatus = P2PHttpRequestType.REQUEST_NULL;
    // 下载模块对象
    this.mDownloadModel = null;
    // 定时器
    this.mTimer = null;
    //http请求
    this.httpRequest = new __WEBPACK_IMPORTED_MODULE_2__httpRequest__["a" /* default */]();
    this.HttpRequestResponse = this.httpRequest.HttpRequestResponse;
    this.receiveDataTimer = null;
    this.repeatGetPeer = 0;
    //测试看p2p下载完成一块所用时间
    this.receiveTime = 0;
    this.endReceiveTime = 0;
    //信道打开重试次数
    this.channelRepeatNum = 0;
    // 是否是首次请求调度地址
    this.isFirstReqTrack = true;
}
//检查下载的数据长度
P2PDownload.prototype.checkDataLength = function (that) {
    return function () {
        var recvCount = 0;
        for (var i = 0; i < that.mDataRecvTable.length; i++) {
            if (that.mDataRecvTable[i] == 0) {
                break;
            }
            recvCount++;
        }
        if (recvCount < that.mDataRecvTable.length) {
            //长时间没有收到数据，中断本次传输
            if (that.endReceiveTime == 0) {
                that.endReceiveTime = new Date().getTime();
                that.mDownloadModel.p2pRate = recvCount * 1000 / (parseInt(that.endReceiveTime) - parseInt(that.receiveTime));
                console.error('超时下载速率字节每毫秒(kB/s):', recvCount * 1000 / (parseInt(that.endReceiveTime) - parseInt(that.receiveTime)));
                that.receiveTime = 0;
            }
            //长时间没有收到数据
            that.changePeer();
        }
    };
};

// 设置下载数据
P2PDownload.prototype.setDownloadInfo = function (downloadModel, nIndex) {
    this.mDownloadModel = downloadModel;
    this.mURL = downloadModel.seedUrl;
    this.mBlockId = downloadModel.mDataBlockArray[nIndex].mBlockId;
    this.mServerInfo = downloadModel.mServerInfo;
    this.showTestInfo = downloadModel.showTestInfo;
    this.p2pErrorNum = downloadModel.p2pErrorNum;
    this.mBlockInfo = {};
    this.mBlockInfo.mBlockId = downloadModel.mDataBlockArray[nIndex].mBlockId;
    this.mBlockInfo.mStartPos = downloadModel.mDataBlockArray[nIndex].mStartPos;
    this.mBlockInfo.mEndPos = downloadModel.mDataBlockArray[nIndex].mEndPos;
    this.requestStartPos = this.mBlockInfo.mStartPos;
    var len = this.mBlockInfo.mEndPos - this.mBlockInfo.mStartPos + 1;
    this.mDataRecvTable = new Uint8Array(parseInt(len / P2PBLOCK_SIZE) + (len % P2PBLOCK_SIZE > 0 ? 1 : 0));
    if (this.showTestInfo) {
        console.info('新建p2p下载：' + nIndex);
    }
    this.sendRequestPeer();
};

// 取消下载
P2PDownload.prototype.cancleDownload = function () {
    this.mStatus = P2PHttpRequestType.REQUEST_NULL;
    if (this.showTestInfo) {
        console.info('取消下载：' + this.mBlockId);
    }
    window.clearTimeout(this.mTimer);
    this.mTimer = null;
    this.httpRequest.stop();

    if (this.dataChannel != null && this.dataChannel != undefined) {
        this.dataChannel.removeEventListener('open', channelOpen(this));

        this.dataChannel.removeEventListener('close', channelClose(this));
        this.dataChannel.removeEventListener('message', channelOnmessage(this));

        this.dataChannel.removeEventListener('error', channelError(this));
        //this.dataChannel.close();

        this.dataChannel = null;
    }

    if (this.receiveChannel != null && this.receiveChannel != undefined) {
        this.receiveChannel.removeEventListener('open', channelOpen(this));

        this.receiveChannel.removeEventListener('close', receiveChannel(this));

        this.receiveChannel.removeEventListener('message', channelOnmessage(this));

        this.receiveChannel.removeEventListener('error', channelError(this));
        //this.receiveChannel.close();
        this.receiveChannel = null;
    }

    if (this.peerConnection != null && this.peerConnection != undefined) {
        this.peerConnection.removeEventListener('icecandidate', gotLocalCandidate(this));
        this.peerConnection.removeEventListener('datachannel', gotReceiveChannel(this));
        //this.peerConnection.close();
        this.peerConnection = null;
    }
};
// 获取已下载数据
P2PDownload.prototype.getData = function () {
    var buf = null;
    var nIndex = this.mDataRecvTable.length;
    for (var i = 0; i < this.mDataRecvTable.length; i++) {
        if (this.mDataRecvTable[i] == 0) {
            nIndex = i;
            break;
        }
    }

    if (nIndex != 0) {
        buf = new Uint8Array(nIndex * P2PBLOCK_SIZE);
        buf.set(this.mData.slice(0, nIndex * P2PBLOCK_SIZE), 0);
    }
    return buf;
};

// 发送请求种子
P2PDownload.prototype.sendRequestPeer = function () {
    var _this = this;

    if (this.mServerInfo == null || this.mServerInfo == undefined || this.mServerInfo.length <= 0) {
        return;
    }
    var postURL = this.mServerInfo;
    if (postURL.sub(postURL.length - 1, 1) != '/') {
        postURL += '/';
    }

    postURL += 'queryRes?resId=';
    postURL += this.mURL; //todo上线的时候需要编码
    postURL += '&blockNum=';
    postURL += this.mBlockInfo.mBlockId;
    //postURL += "&temp";
    this.mStatus = P2PHttpRequestType.GET_PEER;
    // 像服务器发送http请求 请求种子
    if (this.showTestInfo) {
        console.info('请求种子信息');
    }

    if (this.p2pErrorNum < 10) {
        this.httpRequest.sendRequest('get', 'json', postURL, 2000).then(function (data) {
            _this.httpRequestCallback.apply(_this, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(data));
        });
    }

    //console.log("P2P blockId:" + this.mBlockInfo.mBlockId + " getPeer:" + postURL);
};

// 创建连接
P2PDownload.prototype.createPeerConnectionFromPeerId = function (peerId) {
    // 设置连接超时
    this.peerConnection = this.createPeerConnection(peerId); //webrtc点对点连接
    this.dataChannel = this.createDataChannel(peerId);
    this.createOffer();
};

// 发送candidate和offer
P2PDownload.prototype.sendCandidateAndOffer = function () {
    var _this2 = this;

    if (this.mServerInfo == null || this.mServerInfo == undefined || this.mServerInfo.length <= 0) {
        return;
    }
    var postURL = this.mServerInfo;
    if (postURL.sub(postURL.length - 1, 1) != '/') {
        postURL += '/';
    }

    postURL += 'sendTo?peerId=';
    postURL += this.mCurrentPeerId;
    postURL += '&data=';

    var recvCount = 0;
    for (var i = 0; i < this.mDataRecvTable.length; i++) {
        if (this.mDataRecvTable[i] == 0) {
            break;
        }
        recvCount++;
    }
    if (this.showTestInfo) {
        console.log('请求偏移位置', this.mBlockInfo.mStartPos + recvCount * 1024);
    }
    this.requestStartPos = this.mBlockInfo.mStartPos + recvCount * 1024;

    var datajson = {
        requestURL: this.mURL,
        videoType: 0,
        offset: this.requestStartPos,
        blockNum: this.mBlockInfo.mBlockId,
        candidate: this.mPeerConnectInfo.candidate,
        offer: this.mPeerConnectInfo.session_desc,
        peerId: this.mCurrentPeerId
    };
    var strjson = {
        action: 'applyConnectRequest',
        data: datajson
    };
    postURL += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(strjson);

    this.mStatus = P2PHttpRequestType.SEND_CANDIDATE_OFFER;
    // 发送candidte，请求offer
    if (this.p2pErrorNum < 10) {
        this.httpRequest.sendRequest('get', 'json', postURL, 20000).then(function (data) {
            _this2.httpRequestCallback.apply(_this2, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(data));
        });
    }
    if (this.showTestInfo) {
        console.info('sendCandidateAndOffer');
        console.log('P2P blockId:' + this.mBlockInfo.mBlockId + ' sendCandidateAndOffer:' + postURL);
    }
};

// 创建连接
P2PDownload.prototype.createPeerConnection = function (peerId) {
    var that = this;
    var pc = void 0;
    if (this.showTestInfo) {
        console.log('createPeerConnection peerId:' + peerId);
    }
    // if (this.mPeerConnectInfo != null || this.mPeerConnectInfo != undefined) {
    //     this.mPeerConnectInfo = null;
    // }

    this.mPeerConnectInfo = {
        candidate: [],
        session_desc: null
    };
    try {
        pc = new __WEBPACK_IMPORTED_MODULE_4__adapter__["a" /* PeerConnection */](iceServer);
    } catch (error) {
        console.log('创建peerconnection失败，关闭p2p');
        this.downloadModel.stopP2P(this.mBlockId);
    }

    if (this.mTimer == null || this.mTimer == undefined) {
        this.mTimer = setTimeout(p2pTimerCallback(this, 'ON_CANDIDATE_RECV'), 1000);
        if (this.showTestInfo) {
            console.log('设置接收candidate超时的定时器', this.mTimer);
        }
    }
    pc.addEventListener('icecandidate', gotLocalCandidate(that));
    pc.addEventListener('datachannel', gotReceiveChannel(that));
    return pc;
};

//对某一个PeerConnection创建Data channel
P2PDownload.prototype.createDataChannel = function (peerId, label) {
    console.log('skyrtc.prototype.createDataChannel');
    var pc = void 0,
        key = void 0,
        channel = void 0;
    pc = this.peerConnection;

    if (!(pc instanceof __WEBPACK_IMPORTED_MODULE_4__adapter__["a" /* PeerConnection */])) {
        console.log('skyrtc.prototype.createDataChannel data_channel_create_error');
    }
    try {
        channel = pc.createDataChannel(label, {
            maxRetransmits: 3
        });
    } catch (error) {
        console.log('skyrtc.prototype.createDataChannel channel_create_error');
    }
    return this.addDataChannel(peerId, channel);
};

//为Data channel绑定相应的事件回调函数
P2PDownload.prototype.addDataChannel = function (peerId, channel, receive) {
    console.log('skyrtc.prototype.addDataChannel');
    var that = this;
    if (channel) {
        channel.addEventListener('open', channelOpen(that));
        if (receive) {
            channel.addEventListener('close', receiveChannel(that));
        } else {
            channel.addEventListener('close', channelClose(that));
        }

        channel.addEventListener('message', channelOnmessage(that));

        channel.addEventListener('error', channelError(that));
    }
    return channel;
};

// 将接收到的数据放入数据区
P2PDownload.prototype.putData = function (recvData) {
    this.mData.set(recvData.mData, recvData.mStartPos);
    var nIndex = parseInt(recvData.mStartPos / P2PBLOCK_SIZE);
    this.mDataRecvTable[nIndex] = 1;
    var recvCount = 0;
    for (var i = 0; i < this.mDataRecvTable.length; i++) {
        if (this.mDataRecvTable[i] == 0) {
            break;
        }
        recvCount++;
    }

    if (recvCount >= this.mDataRecvTable.length) {
        // 接收完成
        if (this.mDownloadModel != null || this.mDownloadModel != undefined) {
            console.log('p2p下载完成' + this.mBlockInfo.mBlockId);
            this.endReceiveTime = new Date().getTime();

            //let alreadyDown = this.requestStartPos - this.mBlockInfo.mStartPos;
            //console.error(this.endReceiveTime,'kb数',(this.mBlockInfo.mEndPos - this.requestStartPos)/1024)
            this.mDownloadModel.p2pRate = (this.mBlockInfo.mEndPos - this.requestStartPos) / 1024 * 1000 / (parseInt(this.endReceiveTime) - parseInt(this.receiveTime));
            if (this.showTestInfo) {
                console.info('下载数据速度kb/s：', (this.mBlockInfo.mEndPos - this.requestStartPos) / 1024 * 1000 / (parseInt(this.endReceiveTime) - parseInt(this.receiveTime)));
            }
            //停止数据长度检查
            window.clearTimeout(this.receiveDataTimer);
            this.receiveDataTimer = null;
            this.mDownloadModel.p2pRecvFinishCallback(this.mBlockId);
        }
    }
};
// 接收数据信息
// function recvDataInfo() {
//     // 数据类型
//     this.mDataType = 0;
//     // 数据长度
//     this.mDataBufferLength = 0;
//     // 实际传输数据长度
//     this.mDataLength = 0;
//     this.mSequcenceNumber = 0;
//     this.mSendOrder = 0;
//     this.mStartPos = 0;
//     this.mEndPos = 0;
//     this.mBlockId = 0;
//     this.mData = null;
// }

//解析数据
P2PDownload.prototype.analysisData = function (data, headInfo) {
    var recvData = null;
    recvData = {};
    recvData.mDataType = headInfo[0];
    recvData.mBlockId = headInfo[8];
    // 数据长度
    recvData.mDataBufferLength = headInfo[1];
    // 实际传输数据长度
    recvData.mDataLength = headInfo[2];
    if (this.mBlockInfo.mStartPos == this.requestStartPos) {
        recvData.mStartPos = headInfo[6];
    } else {
        recvData.mStartPos = headInfo[6] + this.requestStartPos - this.mBlockInfo.mStartPos;
    }
    recvData.mEndPos = headInfo[7];
    recvData.mData = new Uint8Array(recvData.mDataLength);
    recvData.mData.set(data.slice(36, recvData.mDataBufferLength), 0);
    return recvData;
};

/***********************信令交换部分*******************************/

//向所有PeerConnection发送Offer类型信令
P2PDownload.prototype.createOffer = function () {
    var i = void 0,
        m = void 0,
        pc = void 0,
        that = this,
        pcCreateOfferCbGen = function pcCreateOfferCbGen(pc, peerId) {
        return function (session_desc) {
            console.log('pcCreateOfferCbGen');
            pc.setLocalDescription(session_desc);
            that.mPeerConnectInfo.session_desc = session_desc;
        };
    },
        pcCreateOfferErrorCb = function pcCreateOfferErrorCb(error) {
        console.log(error);
    };
    if (this.peerConnection) {
        this.peerConnection.createOffer(pcCreateOfferCbGen(this.peerConnection, this.mCurrentPeerId), pcCreateOfferErrorCb);
        console.log('createOffers');
    }
};

//接收到answer类型信令后将对方的session描述写入PeerConnection中
P2PDownload.prototype.receiveAnswer = function (peerId, sdp) {
    console.log('receiveAnswer');
    if (peerId == this.mCurrentPeerId && this.peerConnection) {
        this.peerConnection.setRemoteDescription(new __WEBPACK_IMPORTED_MODULE_4__adapter__["c" /* nativeRTCSessionDescription */](sdp));
    }
};

// 定时器回调函数
function p2pTimerCallback(p2pDownloadObj, type) {
    console.log('定时器开启', type);
    return function () {
        console.info('启动定时器' + type);
        if (type == 'GET_PEER_TIMEOUT') {
            if (p2pDownloadObj.repeatGetPeer < 3) {
                p2pDownloadObj.sendRequestPeer();
                if (p2pDownloadObj.repeatGetPeer == 1) {
                    gBadPeerIds = [];
                }
            } else {
                p2pDownloadObj.mDownloadModel.p2pCreateNew(p2pDownloadObj.mBlockInfo.mBlockId);
            }
            p2pDownloadObj.repeatGetPeer++;
        } else if (type == 'ON_CANDIDATE_RECV') {
            if (p2pDownloadObj.mPeerConnectInfo.candidate.length > 0) {
                // 发送httprequest请求，发送本地candidate信息
                console.info('webrtc点对点连接收到candidate');
                p2pDownloadObj.sendCandidateAndOffer();
            } else {
                p2pDownloadObj.mTimer = setTimeout(p2pTimerCallback(p2pDownloadObj, 'ON_CANDIDATE_TIMEOUT'), 5000);
            }
        } else if (type == 'ON_CANDIDATE_TIMEOUT') {
            // 创建连接
            console.info('ON_CANDIDATE_TIMEOUT');
            if (p2pDownloadObj.mPeerConnectInfo.candidate.length > 0) {
                console.info('重新检测webrtc点对点连接收到candidate');
                p2pDownloadObj.sendCandidateAndOffer();
            } else {
                p2pDownloadObj.createPeerConnectionFromPeerId(p2pDownloadObj.mCurrentPeerId);
            }
        } else if (type == 'GET_PEER_EMPTY') {
            if (p2pDownloadObj.mDownloadModel != null && p2pDownloadObj.mDownloadModel != undefined) {
                p2pDownloadObj.mDownloadModel.p2pCreateNew(p2pDownloadObj.mBlockInfo.mBlockId);
            }
        } else if (type == 'DATA_CHANNEL_OPEN_TIMEOUT') {
            this.channelRepeatNum++;
            gBadPeerIds.push(p2pDownloadObj.mCurrentPeerId);
            // 换种子
            p2pDownloadObj.changePeer();
        }
        p2pDownloadObj.mTimer = null;
    };
}

// 获取数据
P2PDownload.prototype.httpRequestCallback = function (result, requestType, xmlhttp, startPos, endPos, errorCode) {
    if (result == this.HttpRequestResponse.RESPONSE_RETURN_SUCCESS) {
        //let jsonStr = JSON.stringify(xmlhttp.response);
        var jsonStr = xmlhttp.response;
        // 请求种子返回
        if (this.mStatus == P2PHttpRequestType.GET_PEER) {
            var requestStatus = jsonStr.status;

            console.log('P2P blockId:' + this.mBlockInfo.mBlockId + ' getPeerReturn:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsonStr));
            if (requestStatus != null && requestStatus != undefined && requestStatus != '0') {
                var strPeers = jsonStr.data;
                var peerIds = strPeers.split(',');
                // 查找是否有已经打通过的种子
                var badPeerIndex = selectPeer(peerIds, gBadPeerIds);
                if (badPeerIndex != null && badPeerIndex != undefined && badPeerIndex.length > 0) {
                    for (var i = 0; i < badPeerIndex.length; i++) {
                        peerIds.splice(badPeerIndex[i], 1);
                    }
                }

                this.mPeerIds = peerIds;
                console.log('请求种子个数为:' + this.mPeerIds.length);
                if (this.createConnect() == false) {
                    // 像服务器发送http请求 请求种子， 过一会再查询
                    if (this.mTimer == null || this.mTimer == undefined) {
                        this.mTimer = setTimeout(p2pTimerCallback(this, 'GET_PEER_TIMEOUT'), 5000);
                    }
                }
            } else {
                //请求种子返回错误状态
                if (this.mTimer == null || this.mTimer == undefined) {
                    this.mTimer = setTimeout(p2pTimerCallback(this, 'GET_PEER_EMPTY'), 2000);
                }
            }
        } else if (this.mStatus == P2PHttpRequestType.SEND_CANDIDATE_OFFER) {
            //收到_ice_candidate
            console.log('P2P blockId:' + this.mBlockInfo.mBlockId + ' recvAnswer:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsonStr));
            if (jsonStr.action == 'applyConnectResponse') {
                var _requestStatus = jsonStr.status;
                if (_requestStatus == '1') {
                    var jsonData = jsonStr.data;
                    if (jsonData != null && jsonData != undefined) {
                        console.log('applyConnectResponse:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsonStr));

                        var candidatejson = jsonData.candidate;
                        if (jsonData.peerId == this.mCurrentPeerId) {
                            this.receiveAnswer(jsonData.peerId, jsonData.answer);
                            for (var _i = 0; _i < candidatejson.length; _i++) {
                                var jsonCandidate = {
                                    candidate: candidatejson[_i]
                                };
                                var candidate = new __WEBPACK_IMPORTED_MODULE_4__adapter__["b" /* nativeRTCIceCandidate */](jsonCandidate);
                                if (this.peerConnection) {
                                    this.peerConnection.addIceCandidate(candidate);
                                }
                            }
                        }
                        //设置定时器等待datachannel联通
                        if (this.mTimer == null || this.mTimer == undefined) {
                            this.mTimer = setTimeout(p2pTimerCallback(this, 'DATA_CHANNEL_OPEN_TIMEOUT'), 5000);
                        }
                    }
                } else {
                    //请求失败换种子请求,若种子数组长度为0，重新请求种子
                    this.changePeer();
                }
            } else {
                // 收到candidte出错
                this.mDownloadModel.p2pCreateNew(this.mBlockInfo.mBlockId);
            }
        }
    } else if (result == this.HttpRequestResponse.RESPONSE_RETURN_ERROR) {
        // 请求失败
        console.info('请求失败,errorCode:' + errorCode + 'status:' + this.mStatus, this.mBlockInfo.mBlockId, this.mBlockId);
        this.p2pErrorNum += 1;
        this.mDownloadModel.p2pErrorNum = this.p2pErrorNum;
        this.mTimer = setTimeout(p2pTimerCallback(this, 'GET_PEER_EMPTY'), 2000);
    } else if (result == this.HttpRequestResponse.RESPONSE_TIMEOUT) {
        // 请求超时
        var strOutInfo = '';
        strOutInfo = '请求超时,请求类型：' + requestType;
        if (this.mStatus == P2PHttpRequestType.GET_PEER) {
            // 过一会再查询
            if (this.mTimer == null || this.mTimer == undefined) {
                this.mTimer = setTimeout(p2pTimerCallback(this, 'GET_PEER_TIMEOUT'), 5000);
            }
        } else if (this.mStatus == P2PHttpRequestType.SEND_CANDIDATE_OFFER) {
            //收到_ice_candidate
            // 换种子
            this.changePeer();
        }
        console.log(strOutInfo);
    }
};

// 换种子
P2PDownload.prototype.changePeer = function () {
    this.receiveTime = 0;
    console.log('changePeer');
    this.cancleDownload();
    // 删除当前种子
    this.deleteCurrentPeer();
    console.log('换种子之后的长度', this.mPeerIds.length);
    this.mTimer = null;
    if (this.createConnect() == false) {
        // 像服务器发送http请求 请求种子， .
        if (this.mTimer == null || this.mTimer == undefined) {
            this.mTimer = setTimeout(p2pTimerCallback(this, 'GET_PEER_TIMEOUT'), 5000);
            console.log('changePeer启动定时器，重新请求', this.mTimer);
        }
    }
};

//删除当前种子
P2PDownload.prototype.deleteCurrentPeer = function () {
    for (var i = 0; i < this.mPeerIds.length; i++) {
        if (this.mPeerIds[i] == this.mCurrentPeerId) {
            this.mPeerIds.splice(i, 1);
        }
    }
};
// 获取数据
P2PDownload.prototype.createConnect = function () {
    var bSuccess = false;
    if (this.mPeerIds.length > 0) {
        var goodPeerIndex = selectPeer(this.mPeerIds, gGoodPeerIds);
        var peerIndex = 0;
        if (goodPeerIndex != null && goodPeerIndex != undefined && goodPeerIndex.length > 0) {
            // 取出一个种子连接
            peerIndex = goodPeerIndex[0];
        }
        this.mCurrentPeerId = this.mPeerIds[peerIndex];
        // 创建连接
        console.log('创建webtrc连接');
        this.createPeerConnectionFromPeerId(this.mCurrentPeerId);
        bSuccess = true;
    }
    return bSuccess;
};

/* harmony default export */ __webpack_exports__["a"] = (P2PDownload);

/***/ }),

/***/ "DfDH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/**
 * 获取浏览器的兼容性
 */
var BrowserSupport = function () {
    function BrowserSupport() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, BrowserSupport);

        this.s = {
            video: this.ifSupportVideo(),
            MSE: this.ifSupportMse(),
            websocket: this.ifSupportSocket(),
            getUserMedeia: this.ifSupportUserMedia(),
            connection: this.ifSupportConnection(),
            candidate: this.ifSupportCandidate(),
            session: this.ifSupportSession()
        };
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(BrowserSupport, [{
        key: 'get',
        value: function get() {
            return this.s;
        }
        /**
         * 是否支持video
         */

    }, {
        key: 'ifSupportVideo',
        value: function ifSupportVideo() {
            var videoElement = document.createElement('video');
            if (videoElement && videoElement.canPlayType) {
                return true; // 是否支持video属性
            }
            return false;
        }
        /**
         * 是否支持MSE
         */

    }, {
        key: 'ifSupportMse',
        value: function ifSupportMse() {
            var mse = window['MediaSource'] || window['WebKitMediaSource'];
            if (mse && mse.isTypeSupported) {
                return true;
            }
            return false;
        }
        /**
         * 是否支持socket
         */

    }, {
        key: 'ifSupportSocket',
        value: function ifSupportSocket() {
            if (window.WebSocket) {
                return true; // 是否支持websocket
            }
            return false;
        }
        /**
         * 是否支持获取媒体属性
         */

    }, {
        key: 'ifSupportUserMedia',
        value: function ifSupportUserMedia() {
            if (navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia) {
                return true;
            }
            return false;
        }
        /**
         * 是否支持webrtc的connect
         */

    }, {
        key: 'ifSupportConnection',
        value: function ifSupportConnection() {
            if (window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection || window.PeerConnection || window.webkitPeerConnection00) {
                return true;
            }
            return false;
        }
        /**
         * 是否支持candidate
         */

    }, {
        key: 'ifSupportCandidate',
        value: function ifSupportCandidate() {
            if (window.RTCIceCandidate || window.mozRTCIceCandidate || window.webkitRTCSessionDescription) {
                return true;
            }
            return false;
        }
        /**
         * 是否支持webrct的session
         */

    }, {
        key: 'ifSupportSession',
        value: function ifSupportSession() {
            if (window.RTCSessionDescription || window.mozRTCSessionDescription || window.webkitRTCSessionDescription) {
                return true;
            }
            return false;
        }
    }]);

    return BrowserSupport;
}();

/* harmony default export */ __webpack_exports__["a"] = (BrowserSupport);

/***/ }),

/***/ "EGZi":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "EqBC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__("kM2E");
var core = __webpack_require__("FeBl");
var global = __webpack_require__("7KvD");
var speciesConstructor = __webpack_require__("t8x9");
var promiseResolve = __webpack_require__("fJUb");

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),

/***/ "EqjI":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "FeBl":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "Gu7T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__("c/Tr");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ "I76u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__httpRequest__ = __webpack_require__("PgFv");



/**
 * 统计模块
 */

var sendVplayer = function () {
    /**
     * 初始化定义统计需要发送的参数
     */
    function sendVplayer() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, sendVplayer);

        this.vStaUrl = ''; // 发送统计的地址
        this.sendVplayer = {
            type: 'CDN', // 下载类型 CDN P2P
            status: 'success', // 下载状态 failed success
            dl_bytes: 0, // 下载字节数
            group: 'ifengH5', // 分组
            block_id: 0, // 块号
            url: '', // 请求的mp4地址
            total_block: 0 // 总块号
        };
        this.httpRequest = new __WEBPACK_IMPORTED_MODULE_2__httpRequest__["a" /* default */]();
    }
    /**
     *
     * @param {Object} params 统计参数
     * @param {String} vStaUrl 发送统计的地址
     */


    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(sendVplayer, [{
        key: 'init',
        value: function init(params, vStaUrl) {
            this.vStaUrl = vStaUrl;
            this.updateParams(params);
        }
        /**
         *
         * @param {Object} params 更新统计参数
         */

    }, {
        key: 'updateParams',
        value: function updateParams(params) {
            for (var i in params) {
                this.sendVplayer[i] = params[i];
            }
        }
        /**
         *
         * @param {Object} params 发送的统计的参数
         */

    }, {
        key: 'sendCdn',
        value: function sendCdn(params) {
            this.sendVplayer.type = 'CDN';
            this.updateParams(params);
            if (this.vStaUrl) {
                this.httpRequest.sendRequestJsonp(this.vStaUrl, this.sendVplayer);
            }
        }
        /**
         *
         * @param {Object} params 发送统计的参数
         */

    }, {
        key: 'sendP2p',
        value: function sendP2p(params) {
            this.sendVplayer.type = 'P2P';
            this.updateParams(params);
            if (this.vStaUrl) {
                this.httpRequest.sendRequestJsonp(this.vStaUrl, this.sendVplayer);
            }
        }
    }]);

    return sendVplayer;
}();

/* harmony default export */ __webpack_exports__["a"] = (sendVplayer);

/***/ }),

/***/ "Ibhu":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("D2L2");
var toIObject = __webpack_require__("TcQ7");
var arrayIndexOf = __webpack_require__("vFc/")(false);
var IE_PROTO = __webpack_require__("ax3d")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "JUcH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var downloadConfig = {
    BLOCK_SIZE: 512 * 1024, // 分块单位
    FIRST_INTERVAL_BLOCK_SIZE: 512 * 1024 * 4, // 第一次请求的时候请求的vdn长度
    INTERVAL_BLOCK_SIZE: 512 * 1024 * 4, // 每次vdn请求长度
    P2PBLOCK_SIZE: 1 * 1024, // p2p一次传送大小
    P2P_DOWNLOAD_COUNT: 1, // p2p下载个数
    mServerInfo: 'http://111.202.92.78:80/inquiry_IP', //测试用trackserver服务器地址
    vStaUrl: 'http://p2p.v.ifeng.com/log.js', //发送统计服务器地址
    receiveDataTimeOut: 8000 //p2p接收数据定时
};

/* harmony default export */ __webpack_exports__["a"] = (downloadConfig);

/***/ }),

/***/ "L42u":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("+ZMJ");
var invoke = __webpack_require__("knuC");
var html = __webpack_require__("RPLV");
var cel = __webpack_require__("ON07");
var global = __webpack_require__("7KvD");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("R9M2")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "Lfvx":
/***/ (function(module, exports) {


if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  if (data.length) { 
    ; __append("\n    ")
    ;  for(var i=0; i < data.length; i++) { 
    ; __append("\n<li class=\"clearfix ")
    ;  if (data[i].peertrying) {
    ; __append("peertring")
    ;  }
    ; __append("\">\n	<div class=\"info-box\">\n		<p>块号索引：<span class=\"num\">")
    ; __append(escape(data[i].mBlockId))
    ; __append("</span></p>\n		<p>总字节数：<span class=\"total-num\">")
    ; __append(escape(data[i].mEndPos-data[i].mStartPos+1))
    ; __append("</span></p>\n		<p>p2p已下载字节数：")
    ; if (data[i].P2PDataLength){
    ; __append(escape(data[i].P2PDataLength))
    ; }
    ; __append("</p>\n		<p>VDN已下载字节数：")
    ; if (data[i].P2PDataLength) {
    ; __append(escape(data[i].mDataLength - data[i].P2PDataLength))
    ; } else {
    ; __append(escape(data[i].mDataLength))
    ;  }
    ; __append("</p>\n		<p>是否有从VDN下载：</p>\n		<p>状态：</p>\n		<p>p2p连接重试次数：0</p>\n		<p>vdn连接重试次数：0</p>\n	</div>\n	<div class=\"left vdn\" style=\"width:")
    ;  if (data[i].P2PDataLength) {
    ; __append(escape((data[i].mDataLength-data[i].P2PDataLength)/(data[i].mEndPos-data[i].mStartPos+1)*100+'%'))
    ;  } else {
    ; __append(escape(data[i].mDataLength/(data[i].mEndPos-data[i].mStartPos+1)*100+'%'))
    ;  }
    ; __append("\"></div>\n	<div class=\"right peer\" style=\"width:")
    ;  if (data[i].P2PDataLength) {
    ; __append(escape((data[i].P2PDataLength)/(data[i].mEndPos-data[i].mStartPos+1)*100+'%'))
    ;  } else {
    ; __append("0%")
    ;  }
    ; __append("\"></div>\n	<div class=\"playing\"></div>\n</li>\n    ")
    ;  } 
    ; __append("\n")
    ;  } 
    ; __append("\n")
  }
  return __output.join("");

}

/***/ }),

/***/ "M6a0":
/***/ (function(module, exports) {



/***/ }),

/***/ "MU5D":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("R9M2");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "McAV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_sign__ = __webpack_require__("mDxz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_formatParams__ = __webpack_require__("NMSG");



var antiTheft = function antiTheft(_ref) {
    var videoinfo = _ref.videoinfo,
        _gid = _ref._gid,
        version = _ref.version;

    var videoUrl = void 0;
    var sver = '';
    var start = '';
    var end = '';

    var _formatParams = Object(__WEBPACK_IMPORTED_MODULE_1__utils_formatParams__["a" /* default */])(videoinfo, _gid, version),
        vid = _formatParams.vid,
        uid = _formatParams.uid,
        from = _formatParams.from,
        pver = _formatParams.pver,
        se = _formatParams.se,
        cat = _formatParams.cat,
        ptype = _formatParams.ptype,
        platform = _formatParams.platform,
        sourceType = _formatParams.sourceType,
        dt = _formatParams.dt,
        gid = _formatParams.gid;

    var _genSign = Object(__WEBPACK_IMPORTED_MODULE_0__utils_sign__["a" /* default */])({ gid: gid, pver: pver, sver: sver, tm: Date.now(), uid: uid, vid: vid }),
        sign = _genSign.sign,
        tm = _genSign.tm;

    var paramArr = [];
    paramArr.push('vid=' + vid);
    paramArr.push('uid=' + uid);
    paramArr.push('from=' + from);
    paramArr.push('pver=' + pver);
    paramArr.push('sver=' + sver);
    paramArr.push('se=' + se);
    paramArr.push('cat=' + cat);
    paramArr.push('ptype=' + ptype);
    paramArr.push('platform=' + platform);
    paramArr.push('sourceType=' + sourceType);
    paramArr.push('dt=' + dt);
    paramArr.push('gid=' + gid);
    paramArr.push('sign=' + sign);
    // paramArr.push(`start=${start}`);
    // paramArr.push(`end=${end}`);
    paramArr.push('tm=' + tm);

    videoUrl = paramArr.join('&');
    return videoUrl;
};

/* harmony default export */ __webpack_exports__["a"] = (antiTheft);

/***/ }),

/***/ "Mhyx":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("/bQp");
var ITERATOR = __webpack_require__("dSzd")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "MmMw":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("EqjI");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "NBD/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stat_js__ = __webpack_require__("CFqg");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__stat_js__["a" /* default */]);

/***/ }),

/***/ "NMSG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uid__ = __webpack_require__("sozY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gid__ = __webpack_require__("vNqB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_f_core_util_pc__ = __webpack_require__("QZmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_f_core_util_pc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_f_core_util_pc__);



var pcVideoUtil = new __WEBPACK_IMPORTED_MODULE_2_f_core_util_pc___default.a();

/**
 * 格式化视频防盗链相关机制
 * @param {object} videoinfo
 * @param {string} gid
 * @return {object}
 */
function formatParams(videoinfo) {
    var gid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object(__WEBPACK_IMPORTED_MODULE_1__gid__["a" /* default */])();
    var version = arguments[2];

    var uid = '';
    var vid = videoinfo.vid,
        categoryId = videoinfo.categoryId,
        createdate = videoinfo.createdate,
        columnName = videoinfo.columnName;


    if (pcVideoUtil.playerGetCookie('userid') === '') {
        uid = Object(__WEBPACK_IMPORTED_MODULE_0__uid__["a" /* default */])();
        pcVideoUtil.playerSetCookie('userid', uid, {
            domain: '.ifeng.com',
            path: '/',
            expires: 60 * 24 * 360
        });
    } else {
        uid = pcVideoUtil.playerGetCookie('userid');
    }

    var cat = typeof categoryId !== 'undefined' ? categoryId : '';
    var dt = new Date(createdate).getTime();
    var from = 'v_Free';
    var pver = version || 'vHTML5Player_v2.0.0';
    var platform = 'pc';
    var sourceType = 'h5';
    var ptype = '';
    if (cat != '') {
        ptype = cat.split('-')[0];
        if (ptype == '154') {
            from = 'v_Doc';
        } else if (ptype == '171') {
            from = 'v_Biz';
        } else {
            from = 'v_Free';
        }
    }

    return {
        vid: vid,
        uid: uid,
        from: from,
        pver: pver,
        se: columnName,
        cat: cat,
        ptype: ptype,
        platform: platform,
        dt: dt,
        gid: gid,
        sourceType: sourceType
    };
}

/* harmony default export */ __webpack_exports__["a"] = (formatParams);

/***/ }),

/***/ "NWt+":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("+ZMJ");
var call = __webpack_require__("msXi");
var isArrayIter = __webpack_require__("Mhyx");
var anObject = __webpack_require__("77Pl");
var toLength = __webpack_require__("QRG4");
var getIterFn = __webpack_require__("3fs2");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "O4g8":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "O6zL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ON07":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("EqjI");
var document = __webpack_require__("7KvD").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "PPPt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toArray__ = __webpack_require__("7nRM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__p2p__ = __webpack_require__("DUya");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__httpRequest__ = __webpack_require__("PgFv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__staP2P__ = __webpack_require__("I76u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__downloadConfig__ = __webpack_require__("JUcH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__consoleInfo_tpl__ = __webpack_require__("Lfvx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__consoleInfo_tpl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__consoleInfo_tpl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__testInfoContainer_tpl__ = __webpack_require__("sq16");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__testInfoContainer_tpl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__testInfoContainer_tpl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__browserSupport_js__ = __webpack_require__("1dQT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__canUseMse_js__ = __webpack_require__("1VYS");





 //http请求模块
 //发送p2p统计的模块
 //下载配置模块
 //todo待删除 测试dom模板
 //todo待删除 测试dom模板



var canUseObj = new __WEBPACK_IMPORTED_MODULE_11__canUseMse_js__["a" /* default */]();
console.log(canUseObj.judgement());

function showPlaying(index) {
    var testInfoDom = document.getElementById('info-container');
    if (testInfoDom) {
        var _testInfoDom$getEleme = testInfoDom.getElementsByClassName('playing'),
            _testInfoDom$getEleme2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toArray___default()(_testInfoDom$getEleme),
            playingDom = _testInfoDom$getEleme2.slice(0);

        playingDom.forEach(function (dom) {
            dom.style.display = 'none';
        });
        if (testInfoDom.getElementsByTagName('li').length) {
            testInfoDom.getElementsByTagName('li')[index].getElementsByClassName('playing')[0].style.display = 'block';
        }
    }
    var video = document.getElementById('video');
    if (video && video.buffered && video.buffered.length) {
        var end = video.buffered.end(0);
        var bufferInfoDom = document.getElementById('buffer-info');
        bufferInfoDom.innerHTML = end;
    }
}
function updateTestInfo(that) {
    var testInfoDom = document.getElementById('info-container');
    if (testInfoDom) {
        var mDataBlockArray = that.mDataBlockArray;
        var sum = 0;
        var total = that.mSize;
        for (var i = 0, len = mDataBlockArray.length; i < len; i++) {
            var obj = mDataBlockArray[i];
            if (obj.P2PDataLength) {
                sum += obj.P2PDataLength;
            }
        }
        var shareRate = sum / total * 100;
        shareRate = shareRate.toFixed(2);
        document.getElementsByClassName('p2pshare-rate')[0].innerHTML = 'P2P分享率为：' + shareRate + '%';
        testInfoDom.innerHTML = __WEBPACK_IMPORTED_MODULE_8__consoleInfo_tpl___default()({ data: mDataBlockArray });
        getRate(that);
        showPlaying(that.playingIndex);
    }
}

function getRate(that) {
    var downloadInfoDom = document.getElementById('download-info');
    var sum = 0;
    var totalTemp = 0;
    var totalVdn = 0;
    var total = that.mSize;
    var mDataBlockArray = that.mDataBlockArray;
    for (var i = 0, len = mDataBlockArray.length; i < len; i++) {
        var obj = mDataBlockArray[i];
        if (obj.P2PDataLength) {
            sum += obj.P2PDataLength;
        }
        if (obj.mDataLength) {
            totalTemp += obj.mDataLength;
        }
    }
    totalVdn = totalTemp - sum;
    downloadInfoDom.innerHTML = '<span class="cdn">cdn\u4E0B\u8F7D\u91CF\uFF1A' + (totalVdn / 1024).toFixed(2) + 'KB</span><span class="p2p">p2p\u4E0B\u8F7D\u91CF\uFF1A' + (sum / 1024).toFixed(2) + 'KB</span>';
    return { cdn: totalVdn, p2p: sum };
}

function setTestContainer(t) {
    var testInfoDom = document.createElement('div');
    testInfoDom.id = 'ifeng-test-info-container';
    var browserSupport = new __WEBPACK_IMPORTED_MODULE_10__browserSupport_js__["a" /* default */]();
    var info = browserSupport.get();
    testInfoDom.innerHTML = __WEBPACK_IMPORTED_MODULE_9__testInfoContainer_tpl___default()({ s: info });
    document.querySelector('body').appendChild(testInfoDom);
    var containerDom = document.getElementById('ifeng-test-info-container');
    var cdnSpeedDom = document.getElementById('http-speed-number');
    var p2pSpeedDom = document.getElementById('p2p-speed-number');
    //画曲线的脚本
    var head = document.getElementsByTagName('head')[0];
    var js = document.createElement('script');
    var src = 'http://p3.ifengimg.com/a/2017/1120/smoothie.js';
    var smoothie = void 0;
    js.setAttribute('src', src);
    js.onload = js.onreadystatechange = function () {
        if (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete') {
            t.smoothie = smoothie = new SmoothieChart({
                grid: { strokeStyle: 'rgb(0, 0, 0)', fillStyle: 'rgb(0, 0, 0)' },
                labels: { fillStyle: 'rgb(0, 0, 0)', disabled: true }
            });
            smoothie.streamTo(document.getElementById('show-rate-box'));
            var line1 = t.line1 = new TimeSeries();
            var line2 = t.line2 = new TimeSeries();
            smoothie.addTimeSeries(line1, {
                strokeStyle: 'rgb(255, 0, 0)',
                fillStyle: 'rgba(255, 255, 255, 0)',
                lineWidth: 3
            });
            smoothie.addTimeSeries(line2, {
                strokeStyle: 'rgb(0, 255, 0)',
                fillStyle: 'rgba(255, 255, 255, 0)',
                lineWidth: 3
            });
            setInterval(function () {
                var temp = getRate(t);
                var rate = (temp.cdn - t.lastDownloadNum) / 1024;
                rate = rate.toFixed(2);
                line1.append(new Date().getTime(), rate);
                line2.append(new Date().getTime(), t.p2pRate);
                p2pSpeedDom.innerHTML = '<span> ' + t.p2pRate.toFixed(2) + ' Kbps</span>';
                t.p2pRate = 0;
                t.lastDownloadNum = temp.cdn;
                cdnSpeedDom.innerHTML = '<span> ' + rate + ' Kbps</span>';
            }, 1000);
        }
    };
    head.appendChild(js);
    $('#info-container').on('mouseover', 'li', function () {
        $('.info-box').hide();
        $(this).find('.info-box').show();
    }).on('mouseout', 'li', function () {
        $('.info-box').hide();
    });
}

var bufferSlice = function bufferSlice() {
    // Uint8Array IE和safari不支持slice方法
    if (!Uint8Array.prototype.slice) {
        Uint8Array.prototype.slice = function (a, b) {
            var Uint8ArraySlice = new Uint8Array(this.buffer.slice(a, b));
            return Uint8ArraySlice;
        };
    }
};

var downloadModel = function () {
    function downloadModel(_ref) {
        var _ref$showTestInfo = _ref.showTestInfo,
            showTestInfo = _ref$showTestInfo === undefined ? false : _ref$showTestInfo;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, downloadModel);

        // url
        this.mURL = '';
        // 下载数据数组
        this.mDataBlockArray = [];
        // 还没下载完成的block id数组
        this.mNotDownloadBlockId = [];
        // 文件大小
        this.mSize = 0;
        // P2P下载数据Map
        this.mP2PDownloadMap = {};
        this.mP2PDownloadBlockMaxNum = 0;
        // 读取位置
        this.mReadPos = 0;
        // 第一块大小
        this.mFirstBlockSize = 0;
        // 是否正在VDN请求
        this.mVDNRequesting = false;
        // TrackServer服务器IP和端口
        this.mServerInfo = 'http://111.202.92.68:8081';
        // 返回数据回调函数（暂时取数据）
        this.mReturnDataCallback = null;
        // http请求
        this.httpRequest = new __WEBPACK_IMPORTED_MODULE_5__httpRequest__["a" /* default */]();
        // http请求的状态码
        this.HttpRequestResponse = this.httpRequest.HttpRequestResponse;
        //是否主动推送数据的标志位
        this.giveData = true;
        //发送统计参数的地址
        this.vStaUrl = __WEBPACK_IMPORTED_MODULE_7__downloadConfig__["a" /* default */].vStaUrl;
        //分的总块数
        this.totalBlockNum = 0;
        //发送统计的方法
        this.VstaP2P = new __WEBPACK_IMPORTED_MODULE_6__staP2P__["a" /* default */]();
        //请求种子的MP4地址
        this.seedUrl = '';
        this.trackServerUrl = __WEBPACK_IMPORTED_MODULE_7__downloadConfig__["a" /* default */].mServerInfo;
        //正在播放的块号
        this.playingIndex = 0;
        //是否关闭p2p标志位，关闭p2p请求的情况主要包括创建PeerConnectInfo失败
        this.stopP2PFlag = false;
        // 请求错误的次数
        this.errorNum = 0;
        // 是否显示错误信息标志位
        this.showTestInfo = showTestInfo;
        // 上一次的下载量，给统计的数据用
        this.lastDownloadNum = 0;
        // p2p请求出错技术器
        this.p2pErrorNum = 0;
        // p2p 下载速率
        this.p2pRate = 0;

        var t = this;
        // 是否显示测试信息标志位
        if (showTestInfo && typeof setTestContainer == 'function') {
            // 创建放置测试信息的盒子放置到页面中
            setTestContainer(this);
        }
    }
    /**
     *
     * @param {Object} 初始化参数
     * @param {String} obj.mURL - 视频mp4地址
     * @param {String} obj.mServerInfo - track服务器地址
     * @param {String} obj.seedUrl - 种子视频mp4地址，需要在视频的mp4地址后面加入固定的参数
     * @param {String} obj.trackServerUrl - 请求track服务器地址接口
     * @param {Function} obj.mReturnDataCallback - 返回数据的回调函数
     */


    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(downloadModel, [{
        key: 'init',
        value: function init(params) {
            for (var i in params) {
                this[i] = params[i];
            }
            bufferSlice();
            // 发送head请求
            this.sendHeadRequest();
            // 请求track服务器地址
            // this.reqTrackServerUrl();
        }
        /**
         * 请求trackserve服务地址
         */

    }, {
        key: 'reqTrackServerUrl',
        value: function reqTrackServerUrl() {
            var _this = this;

            // 请求trackserver服务的地址
            this.httpRequest.sendRequest('get', null, this.trackServerUrl, 3000).then(function (data) {
                var response = data[2].response;
                var arr = response.split('[/IP]');
                if (arr.length) {
                    var ip = arr[0].split('[IP]')[1];
                    var port = arr[1].split('[/PORT]')[0].split('[PORT]')[1];
                    var httpUrl = 'http://' + ip + ':8081';
                    _this.mServerInfo = httpUrl;
                    // 像服务器发送http请求 请求种子
                }
            });
        }
        /**
         * 请求MP4文件大小并初始化统计对象
         */

    }, {
        key: 'sendHeadRequest',
        value: function sendHeadRequest() {
            var _this2 = this;

            this.httpRequest.sendRequest('head', null, this.mURL, 3000).then(function (data) {
                _this2.httpRequestCallback.apply(_this2, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
                _this2.seedUrl = encodeURIComponent(_this2.mURL + '?bs20170421=524288&flen=' + _this2.mSize); //种子MP4地址
                // this.seedUrl = encodeURIComponent(
                //     `http://ips.ifeng.com/video19.ifeng.com/video09/2017/11/21/4744099-102-008-0914.mp4?bs20170421=524288&flen=8684225`,
                // );
            }).then(function (data) {
                //初始化统计对象
                var initStaParams = {
                    url: _this2.mURL,
                    total_block: _this2.totalBlockNum
                };
                _this2.VstaP2P.init(initStaParams, _this2.vStaUrl); //初始化统计参数
                if (_this2.showTestInfo && typeof updateTestInfo === 'function') {
                    updateTestInfo(_this2);
                }
            });
        }
        /**
         * 请求成功之后的处理回调函数
         * @params {String} result - 请求成功、失败、超时状态位
         * @params {String} requestType - 请求类型 head get
         * @params {Object} xmlhttp
         * @params {Int} startPos - 请求开始字节
         * @params {Int} endPos - 请求结束字节
         * @params {String} errorCode - 请求发省错误时的错误码，请求被取消的错误码是0
         */

    }, {
        key: 'httpRequestCallback',
        value: function httpRequestCallback(result, requestType, xmlhttp, startPos, endPos, errorCode) {
            var nIndex = this.getIndex(startPos || this.mReadPos); // 块号
            //初始化统计参数
            var initStaParams = {
                status: 'success', // 状态
                block_id: nIndex, // 块号
                dl_bytes: parseInt(endPos) - parseInt(startPos) + 1 // 本次下载的字节数
            };

            if (result == this.HttpRequestResponse.RESPONSE_RETURN_SUCCESS) {
                this.errorNum = 0;
                if (requestType == 'head') {
                    var size = xmlhttp.getResponseHeader('Content-Length'); // 获取MP4文件长度
                    if (size <= 0) {
                        console.log('请求头文件大小值错误，size:', size);
                    } else {
                        this.mSize = size;
                        this.splitBlock(); //划分数据块
                        // let startReadPos = this.mReadPos;
                        this.vdnDownload(); // 开启vdn下载数据
                    }
                } else if (requestType == 'get') {
                    var buf = new Uint8Array(xmlhttp.response);
                    if (buf != null || buf != undefined) {
                        console.log(buf.length, this.mDataBlockArray[nIndex].mDataLength, this.mDataBlockArray[nIndex].mDataLength < endPos - startPos);
                        var item = this.mDataBlockArray[nIndex];
                        // 防止拖动的过程中重复点击请求同一块数据，同时返回造成buffer被撑爆
                        if (item.mDataLength < item.mEndPos - item.mStartPos) {
                            item.mData.set(buf, item.mDataLength);
                            item.mDataLength += buf.length;
                            if (this.showTestInfo) {
                                console.log('收到数据 blockNum:' + item.mBlockId + ' 长度：' + buf.length + ' startPos:' + startPos + 'endPos:' + endPos);
                            }

                            if (endPos >= item.mEndPos) {
                                // 下载数据完整，从未下载列表中删除
                                this.deleteUnloadBlock(item.mBlockId);
                            }
                            //发送cdn下载成功统计
                            this.VstaP2P.sendCdn(initStaParams);
                            this.mVDNRequesting = false;
                            // 将数据主动推送给video模块
                            if (startPos > item.mStartPos && startPos > this.mReadPos) {
                                buf = new Uint8Array(item.mDataLength);
                                buf.set(item.mData, 0);
                                this.mReturnDataCallback(buf, item.mStartPos);
                            } else {
                                this.mReturnDataCallback(buf, startPos);
                            }
                            // 是否值主动推送数据模式，是更新数据的读取位置
                            if (this.giveData) {
                                this.mReadPos = endPos + 1;
                            }
                            updateTestInfo(this); //todo待删除 更新测试dom
                            // 下载新的模块
                            this.vdnDownload();
                        }
                    }
                }
            } else if (result == this.HttpRequestResponse.RESPONSE_RETURN_ERROR) {
                //请求失败
                console.error('请求失败,errorCode:' + errorCode);
                this.mVDNRequesting = false;
                this.errorNum += 1;
                if (this.errorNum < 10) {
                    // VDN重新请求
                    if (requestType === 'head') {
                        this.sendHeadRequest();
                    } else if (requestType === 'get') {
                        //发送失败统计
                        initStaParams.status = 'failed';
                        initStaParams.dl_bytes = 0;
                        this.VstaP2P.sendCdn(initStaParams);
                        this.vdnDownload();
                    }
                }
            } else if (result == this.HttpRequestResponse.RESPONSE_NOT_SUPORT_RANGE) {
                //server不支持range
                console.log('server不支持range');
                initStaParams.status = 'failed';
                initStaParams.dl_bytes = 0;
                this.VstaP2P.sendCdn(initStaParams);
                this.mVDNRequesting = false;
            } else if (result == this.HttpRequestResponse.RESPONSE_TIMEOUT) {
                //请求超时
                var strOutInfo = '';
                strOutInfo = '请求超时,请求类型：' + requestType;
                if (requestType == 'get') {
                    strOutInfo += ',startPos:' + startPos + ',endPos:' + endPos;
                }
                console.log(strOutInfo);
                this.mVDNRequesting = false;

                // // VDN重新请求
                if (requestType == 'head') {
                    this.sendHeadRequest();
                } else if (requestType == 'get') {
                    initStaParams.status = 'failed';
                    initStaParams.dl_bytes = 0;
                    this.VstaP2P.sendCdn(initStaParams);
                    this.vdnDownload();
                }
            }
        }
        /**
         * 将MP4划分块 每一块的大小是512k 剩余的加到第一块中，除了第一块所有块的大小均为512k
         */

    }, {
        key: 'splitBlock',
        value: function splitBlock() {
            var BLOCK_SIZE = __WEBPACK_IMPORTED_MODULE_7__downloadConfig__["a" /* default */].BLOCK_SIZE; // 每一个分块的大小

            var lastSize = this.mSize % BLOCK_SIZE; // 不能整除的剩余块大小
            var blockCount = parseInt(this.mSize / BLOCK_SIZE); // 总共的分块数
            var pos = 0;
            //视频大小小于512K
            if (blockCount == 0 && lastSize != 0) {
                blockCount = 1;
            }
            this.totalBlockNum = blockCount; //视频划分的总块数
            var strOut = '\u6587\u4EF6\u5927\u5C0F\uFF1A' + (this.mSize / 1024 / 1024).toFixed(2) + 'M,\u5E73\u5747\u6BCF\u5757\u5927\u5C0F' + BLOCK_SIZE / 1024 + 'KB,\u672C\u89C6\u9891\u5171\u5206\u4E3A' + blockCount + '\u5757,\u6700\u540E\u4E00\u5757\u5927\u5C0F\uFF1A' + lastSize + 'B';
            if (this.showTestInfo && document.getElementById('videoInfo')) {
                document.getElementById('videoInfo').innerHTML = '\n                <table border="1">\n                    <tr>\n                        <th>\u6587\u4EF6\u5927\u5C0F\uFF1A</th>\n                        <td>' + (this.mSize / 1024 / 1024).toFixed(2) + 'M</td>\n                    </tr>\n                    <tr>\n                        <th>\u6BCF\u5757\u5927\u5C0F\uFF1A</th>\n                        <td>' + BLOCK_SIZE / 1024 + 'KB</td>\n                    </tr>\n                    <tr>\n                        <th>\u5206\u5757\u6570\uFF1A</th>\n                        <td>' + blockCount + '\u5757</td>\n                    </tr>\n                    <tr>\n                        <th>\u7B2C\u4E00\u5757\u7684\u5927\u5C0F\u4E3A\uFF1A</th>\n                        <td>' + lastSize + 'B</td>\n                    </tr>\n                </table>';
            }
            // console.info(strOut);
            for (var i = 0; i < blockCount; i++) {
                var datablock = {};
                datablock.mStartPos = pos;
                datablock.mEndPos = datablock.mStartPos + BLOCK_SIZE - 1;
                if (i == 0) {
                    datablock.mEndPos += lastSize;
                    if (datablock.mEndPos + 1 > this.mSize) {
                        datablock.mEndPos = this.mSize - 1;
                    }
                    this.mFirstBlockSize = datablock.mEndPos + 1;
                }
                datablock.mData = new Uint8Array(datablock.mEndPos - datablock.mStartPos + 1);
                datablock.mDataLength = 0; // 已经下载的数据长度
                datablock.mBlockId = i; // 块号

                var block = {};
                block.mBlockId = i;
                block.mStartPos = datablock.mStartPos;
                block.mEndPos = datablock.mEndPos;

                this.mNotDownloadBlockId.push(block);
                this.mDataBlockArray.push(datablock);
                pos = datablock.mEndPos + 1;
            }
        }
        /**
         * 开始从vdn和p2p下载数据
         */

    }, {
        key: 'vdnDownload',
        value: function vdnDownload() {
            var _this3 = this;

            console.log('vdnstart', this.mVDNRequesting);
            if (this.mVDNRequesting) {
                return;
            }
            var INTERVAL_BLOCK_SIZE = __WEBPACK_IMPORTED_MODULE_7__downloadConfig__["a" /* default */].INTERVAL_BLOCK_SIZE;

            var nReadPos = this.mReadPos; //读取位置
            var nIndex = this.getIndex(nReadPos); //读取开始块位置
            var endIndex = this.getIndex(nReadPos + INTERVAL_BLOCK_SIZE); //读取结束块的位置
            var blockDownload = null;
            var findIndex = 0;

            for (var i = nIndex; i < this.mDataBlockArray.length && i <= endIndex; i++) {
                blockDownload = this.getUnloadBlockInfo(this.mDataBlockArray[i].mBlockId); //查找没有下载的块
                if (blockDownload != null && blockDownload != undefined) {
                    findIndex = i;
                    break;
                }
            }

            if (blockDownload != null && blockDownload != undefined) {
                // 查询当前块是否在p2p下载,是取消p2p下载
                var p2pDownloadObj = this.mP2PDownloadMap[blockDownload.mBlockId];
                if (p2pDownloadObj) {
                    this.cancleP2PDownload(p2pDownloadObj);
                }

                //VDN下载 发送vdn请求
                if (findIndex < this.mDataBlockArray.length) {
                    this.mVDNRequesting = true;
                    if (this.showTestInfo) {
                        console.log('VDN Request blockNum=' + this.mDataBlockArray[findIndex].mBlockId + ' start:' + (this.mDataBlockArray[findIndex].mStartPos + this.mDataBlockArray[findIndex].mDataLength) + ' end:' + this.mDataBlockArray[findIndex].mEndPos);
                    }

                    this.httpRequest.sendRequest('get', 'arraybuffer', this.mURL, 3000, this.mDataBlockArray[findIndex].mStartPos + this.mDataBlockArray[findIndex].mDataLength, this.mDataBlockArray[findIndex].mEndPos).then(function (data) {
                        _this3.httpRequestCallback.apply(_this3, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
                    });
                }
            }

            //取消p2p下载，即将被VDN下载
            for (var key in this.mP2PDownloadMap) {
                if (key < endIndex + 1) {
                    this.cancleP2PDownload(this.mP2PDownloadMap[key]);
                }
            }
            // 开启新的P2P下载
            // 开启新的P2P下载
            if (!this.stopP2PFlag) {
                this.createP2PDownload();
            }
        }
        /**
         * 获取所在位置的块号
         * @params {Int} pos - 位置
         */

    }, {
        key: 'getIndex',
        value: function getIndex(pos) {
            var nIndex = 0;
            if (pos < this.mFirstBlockSize) {
                nIndex = 0;
            } else {
                nIndex = parseInt((pos - this.mFirstBlockSize) / __WEBPACK_IMPORTED_MODULE_7__downloadConfig__["a" /* default */].BLOCK_SIZE) + 1;
            }
            if (nIndex >= this.mDataBlockArray.length) {
                nIndex = this.mDataBlockArray.length - 1;
            }
            return nIndex;
        }
        /**
         * 查找指定块是否已经下载
         * @params {Int} blockId - 块id
         */

    }, {
        key: 'getUnloadBlockInfo',
        value: function getUnloadBlockInfo(blockId) {
            var blockDownload = null;
            for (var i = 0; i < this.mNotDownloadBlockId.length; i++) {
                if (this.mNotDownloadBlockId[i].mBlockId == blockId) {
                    blockDownload = this.mNotDownloadBlockId[i];
                    break;
                }
            }
            return blockDownload;
        }
        /**
         * 块下载完成，将块从没有下载的队列中删除
         * @params {String} blockId - 块id
         */

    }, {
        key: 'deleteUnloadBlock',
        value: function deleteUnloadBlock(blockId) {
            for (var i = 0; i < this.mNotDownloadBlockId.length; i++) {
                if (this.mNotDownloadBlockId[i].mBlockId == blockId) {
                    this.mNotDownloadBlockId.splice(i, 1);
                    break;
                }
            }
        }
        /**
         * 开启新的p2p下载
         */

    }, {
        key: 'createP2PDownload',
        value: function createP2PDownload() {
            var P2P_DOWNLOAD_COUNT = __WEBPACK_IMPORTED_MODULE_7__downloadConfig__["a" /* default */].P2P_DOWNLOAD_COUNT;

            if (this.showTestInfo) {
                console.log('上次创建的p2p的最大索引数', this.mP2PDownloadBlockMaxNum);
            }

            if (this.mDataBlockArray.length > 0) {
                if (this.mP2PDownloadBlockMaxNum == this.mDataBlockArray[this.mDataBlockArray.length - 1].mBlockId) {
                    this.mP2PDownloadBlockMaxNum = 0;
                }
            }

            var maxBlockNum = this.mP2PDownloadBlockMaxNum;
            var nCount = 0;
            //正在下载的p2p的个数
            for (var key in this.mP2PDownloadMap) {
                nCount++;
            }
            maxBlockNum = parseInt(maxBlockNum) + 1;
            var nReadPos = this.mReadPos;
            var INTERVAL_BLOCK_SIZE = __WEBPACK_IMPORTED_MODULE_7__downloadConfig__["a" /* default */].INTERVAL_BLOCK_SIZE;

            var endIndex = this.getIndex(nReadPos + INTERVAL_BLOCK_SIZE);
            if (this.showTestInfo) {
                console.log('上次读取位置', endIndex);
            }
            var nIndex = this.mDataBlockArray.length;

            //数据块id在范围内，并且数据块没有被下载
            for (var i = endIndex + 1; i < this.mDataBlockArray.length; i++) {
                if (maxBlockNum <= this.mDataBlockArray[i].mBlockId && this.mDataBlockArray[i].mDataLength < this.mDataBlockArray[i].mEndPos - this.mDataBlockArray[i].mStartPos + 1 && !this.mP2PDownloadMap[i]) {
                    // if (this.showTestInfo) {
                    //     console.log(
                    //         i,
                    //         this.mDataBlockArray[i].mDataLength,
                    //         this.mDataBlockArray[i].mEndPos - this.mDataBlockArray[i].mStartPos + 1,
                    //     );
                    // }
                    nIndex = i;
                    break;
                }
            }
            // for(let i = maxBlockNum; i < this.mDataBlockArray.length; i++){
            // 	if (maxBlockNum <= this.mDataBlockArray[i].mBlockId && this.mDataBlockArray[i].mDataLength < this.mDataBlockArray[i].mEndPos - this.mDataBlockArray[i].mStartPos + 1) {
            // 		nIndex = i;
            // 		break;
            // 	}
            // }
            //剩余可创建的p2p链接的个数
            if (this.showTestInfo) {
                console.info('创建p2p之前信息', maxBlockNum, nIndex);
            }

            for (var _i = P2P_DOWNLOAD_COUNT - nCount; _i > 0; _i--) {
                if (nIndex >= this.mDataBlockArray.length || this.mNotDownloadBlockId.length < 1) {
                    break;
                }

                var p2pDownloadObj = new __WEBPACK_IMPORTED_MODULE_4__p2p__["a" /* default */]();

                this.mDataBlockArray[nIndex].peertrying = true; //todo待删除
                updateTestInfo(this); //todo待删除 更新测试dom

                this.mP2PDownloadMap[this.mDataBlockArray[nIndex].mBlockId] = p2pDownloadObj;
                if (this.showTestInfo) {
                    console.info('创建p2p', nIndex, this.mP2PDownloadMap);
                    console.log('createP2PDownload BlockId:' + this.mDataBlockArray[nIndex].mBlockId);
                }
                this.mP2PDownloadBlockMaxNum = this.mDataBlockArray[nIndex].mBlockId;
                p2pDownloadObj.setDownloadInfo(this, nIndex);
                nIndex++;
            }
        }
        /**
         * 取消正在下载的p2p
         */

    }, {
        key: 'cancleP2PDownload',
        value: function cancleP2PDownload(p2pDownloadObj) {
            if (p2pDownloadObj != null && p2pDownloadObj != undefined) {
                if (this.showTestInfo) {
                    console.log('cancleP2PDownload BlockId:' + p2pDownloadObj.mBlockId, this.mP2PDownloadMap);
                }
                delete this.mP2PDownloadMap[p2pDownloadObj.mBlockId]; // 从map中删除正在下载的p2p的id
                // 取消p2p下载
                p2pDownloadObj.cancleDownload();
                this.copyP2PDownloadData(p2pDownloadObj);

                this.mDataBlockArray[p2pDownloadObj.mBlockId].peertrying = false; //todo待删除
                updateTestInfo(this); //todo待删除

                p2pDownloadObj = null;
            }
        }
        /**
         * 拷贝已经下载的数据
         */

    }, {
        key: 'copyP2PDownloadData',
        value: function copyP2PDownloadData(p2pDownloadObj) {
            if (p2pDownloadObj != null && p2pDownloadObj != undefined) {
                // 拷贝已下载数据
                var buf = p2pDownloadObj.getData();
                if (buf != null && buf != undefined && buf.length > 0) {
                    if (this.showTestInfo) {
                        console.log('P2P下载数据长度', buf.length);
                    }
                    this.mDataBlockArray[p2pDownloadObj.mBlockId].mData.set(buf, 0);
                    this.mDataBlockArray[p2pDownloadObj.mBlockId].mDataLength = buf.length;
                    this.mDataBlockArray[p2pDownloadObj.mBlockId].P2PDataLength = buf.length; //todo待删除
                }
            }
        }
        /**
         * P2P下载完成回调
         */

    }, {
        key: 'p2pRecvFinishCallback',
        value: function p2pRecvFinishCallback(blockId) {
            var p2pDownloadObj = this.mP2PDownloadMap[blockId];
            if (p2pDownloadObj != null && p2pDownloadObj != undefined) {
                if (this.showTestInfo) {
                    console.error('finish===>' + blockId, this.mP2PDownloadMap, this.mDataBlockArray[blockId].mStartPos);
                }
                this.deleteUnloadBlock(blockId);
                this.cancleP2PDownload(p2pDownloadObj);
                // 开启新的P2P下载
                this.createP2PDownload();
                //发送统计
                var initStaParams = {
                    status: 'success',
                    block_id: blockId,
                    dl_bytes: parseInt(this.mDataBlockArray[blockId].mEndPos) - parseInt(this.mDataBlockArray[blockId].mStartPos) + 1
                };
                this.VstaP2P.sendP2p(initStaParams);
                //推送数据
                this.mReturnDataCallback(p2pDownloadObj.getData(), this.mDataBlockArray[blockId].mStartPos);
                p2pDownloadObj = null;
                this.mDataBlockArray[blockId].peertrying = false; //todo待删除
                updateTestInfo(this); //todo待删除
            }
        }
        /**
         * P2P下载出错，新建p2p
         */

    }, {
        key: 'p2pCreateNew',
        value: function p2pCreateNew(blockId) {
            var p2pDownloadObj = this.mP2PDownloadMap[blockId];
            if (p2pDownloadObj) {
                //发送统计
                var buf = p2pDownloadObj.getData();
                var initStaParams = {
                    status: 'failed',
                    block_id: blockId,
                    dl_bytes: buf ? buf.length : 0
                };
                this.VstaP2P.sendP2p(initStaParams);
            } else {
                //发送统计
                var _initStaParams = {
                    status: 'failed',
                    block_id: blockId,
                    dl_bytes: 0
                };
                this.VstaP2P.sendP2p(_initStaParams);
            }

            this.cancleP2PDownload(p2pDownloadObj);
            p2pDownloadObj = null;

            this.mDataBlockArray[blockId].peertrying = false; //todo待删除
            updateTestInfo(this); //todo待删除

            // 开启新的P2P下载
            this.createP2PDownload();
        }
        /**
         * seek数据 video控制台
         */

    }, {
        key: 'seek',
        value: function seek(pos) {
            console.log('请求位置：' + pos);
            if (this.mSize <= 0) {
                this.mReadPos = pos;
                return;
            }
            if (pos >= this.mSize) {
                pos = this.mSize;
            }

            window.clearTimeout(this.readDataTimer);

            this.mReadPos = pos;
            //取消VDN下载
            this.httpRequest.stop();

            this.mVDNRequesting = false;
            this.giveData = true;
            if (this.mReturnDataCallback != null && this.mReturnDataCallback != undefined) {
                var nIndex = this.mReadPos;
                var buf = this.getData();
                if (buf != null && buf != undefined && buf.length > 0) {
                    console.log('ReturnDataCallback=======');
                    this.mReturnDataCallback(buf, nIndex);
                    // console.log("mReadPos:"+downloadObj.mReadPos+",buf.length:"+buf.length+",writePos:"+writePos)
                    // bufTemp.set(buf, writePos);
                    // writePos += buf.length;
                }
            }
            //this.vdnDownload();
            //this.readDataTimer = setTimeout(timeCallback(this), 500);
        }
        /**
         * 从下载数据队列中取数据，开始位置为上次的读取位置
         */

    }, {
        key: 'getData',
        value: function getData() {
            var INTERVAL_BLOCK_SIZE = __WEBPACK_IMPORTED_MODULE_7__downloadConfig__["a" /* default */].INTERVAL_BLOCK_SIZE;

            var buf = null;
            // 读取位置大于视频的长度,返回null
            if (this.mReadPos + 1 >= this.mSize) {
                return buf;
            }
            var readPos = this.mReadPos + INTERVAL_BLOCK_SIZE - 1;
            //数据块小于512kb
            if (readPos >= this.mSize) {
                readPos = this.mSize - 1;
            }

            var nIndex = this.getIndex(this.mReadPos); // 读取块开始的位置
            var nEndIndex = this.getIndex(readPos); // 读取结束块的位置

            var retLength = 0;
            var readEndIndex = nEndIndex;
            for (var i = nIndex; i <= nEndIndex; i++) {
                if (this.mDataBlockArray[i].mDataLength < this.mDataBlockArray[i].mEndPos - this.mDataBlockArray[i].mStartPos) {
                    var downloadDataPos = this.mDataBlockArray[i].mStartPos + this.mDataBlockArray[i].mDataLength;
                    if (downloadDataPos < readPos) {
                        readPos = downloadDataPos;
                    }
                    readEndIndex = i;
                    break;
                }
            }
            console.log('从buffer中获取数据', nIndex, nEndIndex, '下载可以吐得数据块位置：', readEndIndex);
            retLength = readPos - this.mReadPos;
            if (readPos != 0) {
                retLength += 1;
            }

            if (retLength > 0) {
                buf = new Uint8Array(retLength);
            } else {
                this.vdnDownload();
                return buf;
            }

            var pos = 0;
            for (var _i2 = nIndex; _i2 <= readEndIndex; _i2++) {
                var startPos = 0;
                var endPos = 0;
                // 向外读取数据，读取开始块和结束块需要特殊处理，开始块的读取开始的位置不一定是0，结束块的位置不一定是数据块结束的位置（可能没下载完）
                if (_i2 == nIndex) {
                    //console.log("getData start mReadPos:" + this.mReadPos);
                    startPos = this.mReadPos - this.mDataBlockArray[_i2].mStartPos;
                }
                if (_i2 == readEndIndex) {
                    endPos = readPos - this.mDataBlockArray[_i2].mStartPos;
                } else {
                    endPos = this.mDataBlockArray[_i2].mEndPos - this.mDataBlockArray[_i2].mStartPos;
                }
                var buftemp = this.mDataBlockArray[_i2].mData.slice(startPos, endPos + 1);
                console.log('getData blockId:' + this.mDataBlockArray[_i2].mBlockId + ' start:' + startPos + ' end:' + endPos);
                buf.set(buftemp, pos);
                pos += endPos - startPos + 1;
            }

            console.log("getData end length:" + buf.length);
            this.mReadPos += retLength;
            //判断是否小于vdn间隔
            this.vdnDownload();
            return buf;
        }
        /**
         * video获取数据的接口，
         * @params {Int} pos 需要读取的开始的字节的位置
         */

    }, {
        key: 'getDataInterface',
        value: function getDataInterface(pos) {
            console.error('video模块请求getDataInterface,请求位置', this.getIndex(pos), pos, this.mSize);
            this.mReadPos = pos;
            if (this.mReturnDataCallback != null && this.mReturnDataCallback != undefined) {
                var nIndex = this.mReadPos;
                var buf = this.getData();
                if (buf != null && buf != undefined && buf.length > 0) {
                    console.log('ReturnDataCallback=======');
                    this.mReturnDataCallback(buf, nIndex);
                }
            }
        }
        /**
         * 取消vdn和p2p下载
         */

    }, {
        key: 'pause',
        value: function pause() {
            //取消VDN下载
            this.httpRequest.stop();
            this.mVDNRequesting = false;
            // 取消p2p下载
            for (var key in this.mP2PDownloadMap) {
                this.cancleP2PDownload(this.mP2PDownloadMap[key]);
            }
        }
        /**
         * video播放是更新播放位置，测试用
         */

    }, {
        key: 'updatePlayingTest',
        value: function updatePlayingTest(pos) {
            var index = this.getIndex(parseInt(pos * this.mSize));
            this.playingIndex = index;
            showPlaying(this.playingIndex);
        }
        /**
         * 停止vdn的主动下载
         */

    }, {
        key: 'stopVndDownAuto',
        value: function stopVndDownAuto() {
            //取消VDN下载
            // this.httpRequest.stop();
            // this.mVDNRequesting = false;
            this.giveData = false;
        }
        /**
         * 停止p2p下载
         */

    }, {
        key: 'stopP2P',
        value: function stopP2P(blockId) {
            this.stopP2PFlag = true;
            var p2pDownloadObj = this.mP2PDownloadMap[blockId];
            if (p2pDownloadObj) {
                //发送统计
                var buf = p2pDownloadObj.getData();
                var initStaParams = {
                    status: 'failed',
                    block_id: blockId,
                    dl_bytes: buf ? buf.length : 0
                };
                this.VstaP2P.sendP2p(initStaParams);
            } else {
                //发送统计
                var _initStaParams2 = {
                    status: 'failed',
                    block_id: blockId,
                    dl_bytes: 0
                };
                this.VstaP2P.sendP2p(_initStaParams2);
            }

            this.cancleP2PDownload(p2pDownloadObj);
            p2pDownloadObj = null;
        }
    }]);

    return downloadModel;
}();

/* harmony default export */ __webpack_exports__["a"] = (downloadModel);

/***/ }),

/***/ "PgFv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




var RequestAjax = function () {
    function RequestAjax() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, RequestAjax);

        this.HttpRequestResponse = {
            RESPONSE_RETURN_SUCCESS: 0,
            RESPONSE_RETURN_ERROR: 1,
            RESPONSE_NOT_SUPORT_RANGE: 2,
            RESPONSE_TIMEOUT: 3
        };
        this.mxmlhttptemp = [];
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(RequestAjax, [{
        key: 'sendRequest',
        value: function sendRequest(requestType, responseType, url, timeout, startPos, endPos) {
            //发送请求
            var t = this;
            var response = this.HttpRequestResponse;
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var xmlhttp = null;
                xmlhttp = new XMLHttpRequest();
                if (xmlhttp == null || xmlhttp == undefined) {
                    reject('notsupport');
                }
                t.mxmlhttptemp.push(xmlhttp); //保存请求，方便请求的取消
                xmlhttp.timeout = timeout; //设置超时
                if (responseType != null && responseType != undefined) {
                    xmlhttp.responseType = responseType; //'arraybuffer'
                }

                xmlhttp.onreadystatechange = function () {
                    if (this.readyState == 4) {
                        if (this.status == 200 || this.status == 206) {
                            var blobData = xmlhttp.response;
                            if (xmlhttp.status == 206 && (blobData == null || blobData == undefined)) {
                                resolve([response.RESPONSE_NOT_SUPORT_RANGE, requestType, xmlhttp, startPos, endPos]);
                            } else {
                                resolve([response.RESPONSE_RETURN_SUCCESS, requestType, xmlhttp, startPos, endPos]);
                            }
                        } else {
                            console.error('errorurl', url, this.status);
                            resolve([response.RESPONSE_RETURN_ERROR, requestType, xmlhttp, startPos, endPos, xmlhttp.status]);
                        }
                        t.removeByValue(t.mxmlhttptemp, this);
                    }
                };
                // 超时回调
                xmlhttp.ontimeout = function () {
                    resolve([response.RESPONSE_TIMEOUT, requestType, xmlhttp, startPos, endPos]);
                    t.removeByValue(t.mxmlhttptemp, this);
                };

                // 待联调
                var isRange = true;
                var rangeStr = 'range_bytes=';
                if (startPos != null) {
                    if (startPos < 0) {
                        startPos = 0;
                    }
                    rangeStr += startPos + '-';
                } else {
                    isRange = false;
                }

                if (endPos != null && endPos > startPos) {
                    rangeStr += endPos;
                }

                if (isRange) {
                    if (url.indexOf('?') > -1) {
                        url = url + '&' + rangeStr;
                    } else {
                        url = url + '?' + rangeStr;
                    }
                }

                xmlhttp.open(requestType, url, true);

                //todo待删除
                // let isRange = true;
                // let rangeStr = 'bytes=';
                // if (startPos != null) {
                //     if (startPos < 0) {
                //         startPos = 0;
                //     }
                //     rangeStr += startPos + '-';
                // } else {
                //     isRange = false;
                // }

                // if (endPos != null && endPos > startPos) {
                //     rangeStr += endPos;
                // }

                // if (isRange) {
                //     xmlhttp.setRequestHeader('Range', rangeStr);
                // }
                xmlhttp.send();
            });
        }
    }, {
        key: 'removeByValue',
        value: function removeByValue(arr, val) {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i] == val) {
                    arr.splice(i, 1);
                    break;
                }
            }
        }
    }, {
        key: 'stop',
        value: function stop() {
            for (var i = 0; i < this.mxmlhttptemp.length; i++) {
                this.mxmlhttptemp[i].abort(); //请求中止
            }
        }
    }, {
        key: 'sendRequestJsonp',
        value: function sendRequestJsonp(url, data) {
            var reqData = this.formatParams(data);
            var head = document.getElementsByTagName('head')[0];
            var script = document.createElement('script');
            script.setAttribute('src', url + '?' + reqData);
            script.onload = script.onreadystatechange = function () {
                if (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete') {
                    head.removeChild(script);
                }
            };
            head.appendChild(script);
        }
    }, {
        key: 'formatParams',
        value: function formatParams(data) {
            var arr = [];
            for (var name in data) {
                arr.push(encodeURIComponent(name) + '=' + encodeURIComponent(data[name]));
            }
            arr.push('v=' + this.random());
            return arr.join('&');
        }
    }, {
        key: 'random',
        value: function random() {
            return Math.floor(Math.random() * 10000 + 500);
        }
    }]);

    return RequestAjax;
}();

/* harmony default export */ __webpack_exports__["a"] = (RequestAjax);

/***/ }),

/***/ "PzxK":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("D2L2");
var toObject = __webpack_require__("sB3e");
var IE_PROTO = __webpack_require__("ax3d")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "QRG4":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("UuGF");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "QUAj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_css__ = __webpack_require__("mT8d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_ejs__ = __webpack_require__("or9+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_ejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main_ejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_f_core_event__ = __webpack_require__("gzOS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_f_core_util_pc__ = __webpack_require__("QZmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_f_core_util_pc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_f_core_util_pc__);


/**
 * Control module.
 * @module video/Control
 */





var pcVideoUtil = new __WEBPACK_IMPORTED_MODULE_5_f_core_util_pc___default.a();

/**
 * 格式化时间补零
 * @private
 * @param {*} time
 * @return {string} 格式化后的时间
 */
var formatTime = function formatTime(time) {
    var second = 0;
    var mintue = 0;
    var hour = 0;
    second = Math.floor(time % 60);
    if (time >= 60) {
        mintue = Math.floor(time / 60);
    }
    if (mintue >= 60) {
        mintue = Math.floor(mintue % 60);
        hour = Math.floor(time / 3600);
    }
    hour = hour < 10 ? '0' + hour : hour;
    second = second < 10 ? '0' + second : second;
    mintue = mintue < 10 ? '0' + mintue : mintue;
    return hour + ':' + mintue + ':' + second;
};

/**
 * 控制条
 */

var Control = function () {
    /**
     * Creates an instance of Control.
     * @param {object} obj
     * @param {object} obj.sedata 列表相关数据
     * @memberof Control
     */
    function Control(_ref) {
        var _ref$sedata = _ref.sedata,
            sedata = _ref$sedata === undefined ? [] : _ref$sedata,
            videoinfo = _ref.videoinfo;

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Control);

        this.sedatas = sedata;
        this.videoinfo = videoinfo;
        this.isHide = true;
        this.fullStatus = 'exit'; // 非全屏
        this.playBtnstatus = 'pause';
        this.hideTimer = null;
        this.init();
    }

    /**
     * 初始化
     */


    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Control, [{
        key: 'init',
        value: function init() {
            this.initDom();
            this.initCompontent();
            this.initEvent();
        }

        /**
         * 初始化dom
         */

    }, {
        key: 'initDom',
        value: function initDom() {
            /**
             * 组件元素整体
             * @member {HTMLELEMELENT}
             */
            this.el = $(__WEBPACK_IMPORTED_MODULE_3__main_ejs___default()())[0];
            /**
             * 进度条整体
             * @member {HTMLELEMELENT}
             */
            this.progress = this.el.getElementsByClassName('js_progress_trigger')[0];

            /**
             * 进度条缓存
             * @member {HTMLELEMELENT}
             */
            this.buffered = this.el.getElementsByClassName('js_progress_trigger')[1];

            /**
             * 进度条已进行
             * @member {HTMLELEMELENT}
             */
            this.progressbar = this.el.getElementsByClassName('js_progress_trigger')[2];

            /**
             * 进度条小圆点
             * @member {HTMLELEMELENT}
             */
            this.progresicon = this.el.getElementsByClassName('js_progress_trigger')[3];

            /**
             * 音量整体
             * @member {HTMLELEMELENT}
             */
            this.volume = this.el.getElementsByClassName('js_volume_trigger')[0];

            /**
             * 音量条
             * @member {HTMLELEMELENT}
             */
            this.volumebar = this.el.getElementsByClassName('js_volume_trigger')[1];

            /**
             * 音量小钮
             * @member {HTMLELEMELENT}
             */
            this.volumeicon = this.el.getElementsByClassName('js_volume_trigger')[2];

            /**
             * 音量seek
             * @member {HTMLELEMELENT}
             */
            this.volumeProgress = this.el.getElementsByClassName('volumeProgress')[0];

            /**
             * 音量百分比显示
             * @member {HTMLELEMELENT}
             */
            this.volumeTip = $(this.el).find('#js_volume_tip');

            /**
             * 播放按钮整体
             * @member {HTMLELEMELENT}
             */
            this.videobtn = this.el.getElementsByClassName('js_videobtn_trigger');

            for (var k = 0, klen = this.videobtn.length; k < klen; k++) {
                /**
                 * 控制条区域icon
                 */
                var _videobtn = this.videobtn[k];

                var _videobtnTag = _videobtn.getAttribute('data-tag');
                switch (_videobtnTag) {
                    case 'play':
                        /**
                         * 点击播放按钮
                         */
                        this.jsplay = _videobtn;

                        break;
                    case 'pause':
                        /**
                         * 点击暂停按钮
                         */
                        this.jspause = _videobtn;

                        break;
                    case 'next':
                        /**
                         * 点击下一条按钮
                         */
                        this.jsnext = _videobtn;

                        break;
                    case 'mute':
                        /**
                         * 点击后静音按钮
                         */
                        this.mute = _videobtn;

                        break;
                    case 'aloud':
                        /**
                         * 点击后取消静音按钮
                         */
                        this.aloud = _videobtn;

                        break;
                    case 'fullscreen':
                        /**
                         * 全屏按钮
                         */
                        this.fullicon = _videobtn;

                        break;
                    case 'adaptscreen':
                        /**
                         * 退出全屏按钮
                         */
                        this.adapticon = _videobtn;

                        break;
                    case 'rate':
                        /**
                         * 切换码率按钮
                         */
                        this.rateicon = _videobtn;
                }
            }

            /**
             * 已进行时间
             */
            this.playTime = $(this.el).find('#js_video_ptime');

            /**
             * 总时间
             */
            this.totalTime = $(this.el).find('#js_video_ttime');

            /**
             * seek整体
             */
            this.seekTimeAll = $(this.el).find('#js_hover_time');

            /**
             * seek时间
             */
            this.seekTime = $(this.el).find('#js_hover_time span');

            /**
             * 大图预览
             */
            this.bigPreview = $(this.el).find('#js_hover_time div');

            /**
             * 切换码率区域
             */
            this.rate = this.el.getElementsByClassName('js_videorate_trigger');

            /**
             * 悬停时间
             */
            // this.hoverTime = this.el.getElementsByClassName('videoHoverTime');

            /**
             * 滑动音量显示
             */
            this.volumeValue = this.el.getElementsByClassName('volumeTip');

            // console.log($(this.el).find('#js_hover_time span'))
            this.videorate = $(this.el).find('.js_videorate_trigger');

            /**
             * 提示框整体
             */
            this.videoText = $(this.el).find('.videoText');

            /**
             * 提示框关闭按钮
             */
            this.videoTextClose = $(this.el).find('.videoText .js_closetext_trigger');

            /**
             * 提示框文字
             */
            this.videoTextCon = $(this.el).find('#js_video_text');

            /**
             * 码率文字
             */
            this.videoRateTxt = $(this.el).find('#js_video_rateTxt');

            /**
             * 下一条整体
             */
            this.showNext = $(this.el).find('#js_videobtn_showNext');
            // console.log(this.showNext[0])
        }

        /**
         * 初始化组件
         */

    }, {
        key: 'initCompontent',
        value: function initCompontent() {
            /**
             * 获取下一条视频在播放列表中的位置
             */
            this.videoIndex = this.getInd();

            if (this.videoIndex > -1) {
                var sedata = this.sedatas[this.videoIndex];
                this.sedata = sedata;
                if (typeof sedata != 'undefined') {
                    this.setNextDom(sedata);
                }
            }
        }

        /**
         * 初始化自定义事件
         */

    }, {
        key: 'initEvent',
        value: function initEvent() {
            var _this3 = this;

            this.event = new __WEBPACK_IMPORTED_MODULE_4_f_core_event__["a" /* default */]();
            var _this = this;

            /**
             * 鼠标在控制区域时，不隐藏控制条
             */
            pcVideoUtil.bind(_this.el, ['mouseenter', 'mousemove', 'mousedown', 'mouseup', 'click', 'touchstart', 'touchmove'], function (e) {
                _this.show();
                clearTimeout(_this.hideTimer);
                _this.hideTimer = null;
            });

            /**
             * 鼠标移出控制区域时，设置定时器
             */
            pcVideoUtil.bind(_this.el, ['mouseleave', 'touchend'], function (e) {
                if (!_this.hideTimer && _this.playBtnstatus == 'play') {
                    _this.hideTimer = setTimeout(function () {
                        _this.hide();
                    }, 2000);
                }
            });

            /**
             * 播放按钮
             */
            pcVideoUtil.bind(_this.jsplay, 'click', function (e) {
                // _this.changePlayBtnState('play');
                _this.trigger('cplay');
            });

            /**
             * 暂停按钮
             */
            pcVideoUtil.bind(_this.jspause, 'click', function (e) {
                // _this.changePlayBtnState('pause');
                _this.trigger('cpause');
            });

            /**
             * 静音
             */
            pcVideoUtil.bind(_this.mute, 'click', function (e) {
                _this.changeVolume('mute');
                _this.trigger('cmute');
            });

            /**
             * 取消静音
             */
            pcVideoUtil.bind(_this.aloud, 'click', function (e) {
                _this.changeVolume('aloud');
                _this.trigger('caloud');
            });

            /**
             * 全屏按钮
             */
            pcVideoUtil.bind(_this.fullicon, 'click', function (e) {
                _this.changeFull('full');
                _this.trigger('full');
            });

            /**
             * 退出全屏按钮
             */
            pcVideoUtil.bind(_this.adapticon, 'click', function (e) {
                _this.changeFull('exit');
                _this.trigger('exit');
            });

            /**
             * 进度seek
             */
            pcVideoUtil.bind(_this.progress, 'click', function (e) {
                var percent = _this.getPercent(e.clientX, _this.el);
                _this.trigger('cprogress', percent);
            });

            /**
             * 鼠标移入、滑过视频进度条，显示时间提示
             */
            pcVideoUtil.bind(_this.progress, ['mouseover', 'mousemove'], function (e) {
                var percent = _this.getPercent(e.clientX, _this.el);
                _this.trigger('cpseekmove', percent);
            });

            /**
             * 鼠标移出视频进度条，隐藏时间提示
             */
            pcVideoUtil.bind(_this.progress, ['mouseout', 'touchend'], function (e) {
                _this.trigger('cpseekout');
            });

            /**
             * 拖拽进度条
             */
            pcVideoUtil.bind(_this.progresicon, ['mousedown', 'touchstart'], function (e) {
                // var percent = _this.getPercent(e.clientX);
                // console.log('mousedown')
                _this.trigger('cpdown');

                var myfunction = function myfunction(e) {
                    var x = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
                    // console.log(e.clientX)
                    var percent = _this.getPercent(x, _this.el);
                    // console.log('mousemove:' + percent)

                    if (e.type === 'touchmove') {
                        _this.trigger('cprogress', percent);
                    } else {
                        _this.trigger('cpmove', percent);
                    }
                };

                pcVideoUtil.bind(document, ['mousemove', 'touchmove'], myfunction);
                pcVideoUtil.bind(document, ['mouseup', 'touchend'], function (e) {
                    console.log('touchend');
                    pcVideoUtil.removeHandler(document, 'mousemove', myfunction);
                    pcVideoUtil.removeHandler(document, 'touchmove', myfunction);
                });
            });

            /**
             * 音量条seek
             */
            pcVideoUtil.bind(_this.volumeProgress, 'click', function (e) {
                var percent = _this.getPercent(e.clientX, _this.volumeProgress);
                _this.trigger('c_v_progress', percent);
            });

            /**
             * 拖拽音量条
             */
            pcVideoUtil.bind(_this.volumeicon, 'mousedown', function (e) {
                // var percent = _this.getPercent(e.clientX);
                // console.log('mousedown')
                // _this.trigger('cpdown');

                var myfunction = function myfunction(e) {
                    // console.log(e.clientX)
                    var percent = _this.getPercent(e.clientX, _this.volume);
                    // console.log('mousemove:' + percent)
                    _this.trigger('cvmove', percent);
                };

                pcVideoUtil.bind(_this.el, 'mousemove', myfunction);
                pcVideoUtil.bind(_this.el, ['mouseup', 'mouseleave'], function (e) {
                    // console.log('mouseup')
                    pcVideoUtil.removeHandler(_this.el, 'mousemove', myfunction);
                });
            });

            /**
             * 码率切换鼠标滑过
             */
            pcVideoUtil.bind(_this.rateicon, 'mouseenter', function (e) {
                pcVideoUtil.addClass(this, 'videorateShow');
                e.stopPropagation();
            });

            /**
             * 码率切换鼠标滑出
             */
            pcVideoUtil.bind(_this.rateicon, 'mouseleave', function (e) {
                pcVideoUtil.removeClass(this, 'videorateShow');
                e.stopPropagation();
            });

            /**
             * 码率切换手指抬起
             */
            pcVideoUtil.bind(_this.rateicon, 'touchend', function (e) {
                var _this2 = this;

                clearTimeout(_this.rateTimeer);
                pcVideoUtil.addClass(this, 'videorateShow');
                _this.rateTimeer = setTimeout(function () {
                    pcVideoUtil.removeClass(_this2, 'videorateShow');
                }, 2000);
                e.stopPropagation();
            });

            /**
             * 下一条
             */
            $(this.jsnext).on('click', function () {
                if (window.sedata) {
                    _this.sedatas = window.sedata;
                    _this.initCompontent();
                    window.location.href = _this.sedata.link;
                }
            });

            $(this.jsnext).on('mouseenter', function () {
                if (window.sedata) {
                    _this.sedatas = window.sedata;
                    _this.initCompontent();
                }
            });

            /**
             * 码率切换点击
             */
            this.videorate.on('click', function (e) {
                var ev = e || window.event;
                var target = ev.target || ev.srcElement;
                if (target.nodeName.toLowerCase() == 'li') {
                    if (target.className == 'current') return;
                    // console.log(123);
                    _this.trigger('changeVideoRate', target);
                }
            });

            /**
             * 提示框关闭
             */
            this.videoTextClose.on('click', function () {
                _this3.videoTextHide();
            });

            // pcVideoUtil.bind(_this.jsnext, 'mouseenter', function(e) {
            //     _this.trigger('nextEnter');
            //     e.stopPropagation();
            // });
        }

        /**
         * 改变全屏状态样式
         *
         * @param {string} status 全屏状态
         */

    }, {
        key: 'changeFull',
        value: function changeFull(status) {
            if (status === 'full') {
                this.fullicon.style.display = 'none';
                this.adapticon.style.display = 'block';
                this.fullStatus = 'full';
            } else {
                this.fullicon.style.display = 'block';
                this.adapticon.style.display = 'none';
                this.fullStatus = 'exit';
            }
        }

        /**
         * 改变播放按钮状态
         *
         * @param {string} status 播放按钮状态
         */

    }, {
        key: 'changePlayBtnState',
        value: function changePlayBtnState(status) {
            if (status === 'play') {
                this.jsplay.style.display = 'none';
                this.jspause.style.display = 'block';
                this.playBtnstatus = 'play';
            } else {
                this.jsplay.style.display = 'block';
                this.jspause.style.display = 'none';
                this.playBtnstatus = 'pause';
                this.show();
                clearTimeout(this.hideTimer);
                // this.hideTimer = null;
            }
        }

        /**
         * 改变音量样式
         *
         * @param {string} status 音量状态
         */

    }, {
        key: 'changeVolume',
        value: function changeVolume(status) {
            if (status === 'mute') {
                this.mute.style.display = 'none';
                this.aloud.style.display = 'block';
                this.volumeType = 'mute';
            } else {
                this.mute.style.display = 'block';
                this.aloud.style.display = 'none';
                this.volumeType = 'aloud';
            }
            // pcVideoUtil.playerSetCookie('videoVolume', value, { domain: '.ifeng.com', path: '/', expires: 60 * 24 * 360 });
        }

        /**
         * 设置进行时间
         * @param {string} time 当前时间
         */

    }, {
        key: 'setCurrentTime',
        value: function setCurrentTime(time) {
            this.playTime.html(pcVideoUtil.moretime(time));
        }

        /**
         * 设置总时间
         * @param {string} time 总时间
         */

    }, {
        key: 'setTotalTime',
        value: function setTotalTime(time) {
            this.totalTime.html(pcVideoUtil.moretime(time));
        }

        /**
         * 设置悬浮时间
         * @param {string} time 悬浮时间
         */

    }, {
        key: 'setSeekTime',
        value: function setSeekTime(time) {
            this.seekTime.html(pcVideoUtil.moretime(time));
        }

        /**
         * 显示缩略图
         *
         * @param {number} time
         * @param {number} msg
         * @memberof Control
         */

    }, {
        key: 'showImgPreview',
        value: function showImgPreview(time, msg) {
            /**
             * 第几个小图
             */
            var number = Math.ceil(time / msg.time_span);

            /**
             * 一行几个
             */
            var linenumber = msg.width / msg.sub_width;

            /**
             * 一列几个
             */
            var columnnumber = msg.height / msg.sub_height;

            /**
             * 一页有几个小图
             */
            var pagenumber = linenumber * columnnumber;

            /**
             * 小图所在页数
             */
            var page = Math.ceil(number / pagenumber) - 1;

            /**
             * 小图所在行数
             */
            var line = Math.ceil((number - page * pagenumber) / linenumber) - 1;

            /**
             * 小图所在列数
             */
            var column = number - page * pagenumber - line * linenumber - 1;

            var img = msg.path.split(',');

            this.bigPreview.css({
                'width': msg.sub_width,
                'height': msg.sub_height,
                'background': 'url(' + img[page] + ') -' + column * msg.sub_width + 'px -' + line * msg.sub_height + 'px'
            });
        }

        /**
         * 悬浮时间显示
         */

    }, {
        key: 'seekTimeShow',
        value: function seekTimeShow() {
            this.seekTimeAll.addClass('videoHoverTimeShow');
        }

        /**
         * 悬浮时间隐藏
         */

    }, {
        key: 'seekTimeHide',
        value: function seekTimeHide() {
            var _this4 = this;

            /**
             * 显示进度条时间提示videoHoverTime+videoHoverTimeShow
             */
            setTimeout(function () {
                _this4.seekTimeAll.removeClass('videoHoverTimeShow');
            }, 1000);
        }

        /**
         * 悬浮音量显示
         */

    }, {
        key: 'volumeTipShow',
        value: function volumeTipShow() {
            var _this5 = this;

            clearTimeout(this.NewVolumeValueTimer);
            this.NewVolumeValueTimer = null;
            this.volumeTip.addClass('volumeValueShow');
            if (this.NewVolumeValueTimer == null) {
                this.NewVolumeValueTimer = setTimeout(function () {
                    _this5.volumeTip.removeClass('volumeValueShow');
                }, 1000);
            }
        }

        /**
         * 获取占控制条的百分比
         *
         * @param {number} end 最后的位置
         * @param {HTMLELEMENT} ele 控制条元素
         * @return {number} 占控制条的百分比
         */

    }, {
        key: 'getPercent',
        value: function getPercent(end, ele) {
            var r = ele.getBoundingClientRect();
            var left = r.left;
            var width = r.width;
            var percent = (end - left) / width;
            return percent < 0 ? 0 : percent > 1 ? 1 : percent;
        }

        /**
         * 设置已经行进度条
         *
         * @param {number} percent
         */

    }, {
        key: 'setCurrentProgress',
        value: function setCurrentProgress(percent) {
            if (percent < 0.01) percent = 0.01;
            var pp = percent * 100 > 99 ? 99 : percent * 100;
            this.progressbar.style.width = pp + '%';
        }

        /**
         * 设置已经行音量条
         *
         * @param {number} percent
         */

    }, {
        key: 'setCurrentVolume',
        value: function setCurrentVolume(percent) {
            this.volumebar.style.width = percent * 100 + '%';
        }

        /**
         * 设置音量百分比提示
         *
         * @param {number} percent
         */

    }, {
        key: 'setVolumeWarn',
        value: function setVolumeWarn(percent) {
            var num = Math.round(percent * 100);
            this.volumeTip.html(num + '%');
        }

        /**
         * 设置缓存进度条
         *
         * @param {number} percent
         */

    }, {
        key: 'setBufferProgress',
        value: function setBufferProgress(percent) {
            this.buffered.style.width = percent * 100 + '%';
        }

        /**
         * 设置seek进度条
         * @param {number} percent
         */

    }, {
        key: 'setSeekProgress',
        value: function setSeekProgress(percent) {
            this.seekTimeAll.css('left', percent * 100 + '%');
        }

        /**
         * 设置提示框文字内容
         * @param {string} html
         */

    }, {
        key: 'setVideoTextCon',
        value: function setVideoTextCon(html) {
            // body...
            this.videoTextCon.html(html);
        }

        /**
         * 设置码率文字
         * @param {string} html
         */

    }, {
        key: 'setVideoRateTxt',
        value: function setVideoRateTxt(html) {
            // body...
            this.videoRateTxt.html(html);
        }

        /**
         * 提示框整体显示
         */

    }, {
        key: 'videoTextShow',
        value: function videoTextShow() {
            this.videoText.addClass('videoTextShow');
        }

        /**
         * 提示框整体隐藏
         */

    }, {
        key: 'videoTextHide',
        value: function videoTextHide() {
            this.videoText.removeClass('videoTextShow');
        }

        /**
         * 启动全屏
         *
         * @param {HTMLELEMENT} ele
         */

    }, {
        key: 'launchFullscreen',
        value: function launchFullscreen(ele) {
            // if (this.fullStatus == 'full') return;
            if (ele.requestFullscreen) {
                ele.requestFullscreen();
            } else if (ele.mozRequestFullScreen) {
                ele.mozRequestFullScreen();
            } else if (ele.msRequestFullscreen) {
                ele.msRequestFullscreen();
            } else if (ele.oRequestFullscreen) {
                ele.oRequestFullscreen();
            } else if (ele.webkitRequestFullscreen) {
                ele.webkitRequestFullScreen();
            }
        }

        /**
         * 退出全屏
         *
         * @param {HTMLELEMENT} ele
         */

    }, {
        key: 'exitFullscreen',
        value: function exitFullscreen(ele) {
            // if (this.fullStatus == 'exit') return;
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.oRequestFullscreen) {
                document.oCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
        }

        /**
         * 获取下一条列表序号
         *
         * @return {number} 下一条列表序号
         */

    }, {
        key: 'getInd',
        value: function getInd() {
            // var a = '01f9ed9e-c569-40ac-9875-75bea17f330b';
            this.sedatas = window.sedata || this.sedatas;
            var value = -1;
            if (this.videoinfo && typeof this.sedatas !== 'undefined') {
                var guid = this.videoinfo.vid;
                var len = this.sedatas.length;
                this.sedatas.forEach(function (b, c) {
                    if (b.id == guid) {
                        value = c + 1 == len ? -1 : c + 1;
                    }
                });
            }
            return value;
        }

        /**
         * 设置下一条视频的dom内容
         *
         * @param {object} _sedata 下一条视频内容
         */

    }, {
        key: 'setNextDom',
        value: function setNextDom(_sedata) {
            pcVideoUtil.addClass(this.jsnext, 'haveNext');
            // console.log(this.showNext.find('#js_videonext_img'))
            this.showNext.find('#js_videonext_img').html('<img src="' + _sedata.img + '" width="100%" height="100%" />');
            this.showNext.find('#js_videonext_time').html(pcVideoUtil.formatTime(_sedata.duration));
            this.showNext.find('#js_videonext_abstract').html(_sedata.text);

            // document.getElementById('js_videonext_time').innerHTML = pcVideoUtil.formatTime(_sedata.duration);
            // document.getElementById('js_videonext_abstract').innerHTML = _sedata.text;
        }
    }, {
        key: 'setTime',
        value: function setTime(val, willTrigger) {
            if (val < 0) {
                val = 0;
            } else if (val > 1) {
                val = 1;
            }

            this.timeBarWidth = this.elTimeBar.offsetWidth - this.elTimeHandle.offsetWidth;
            this.elTimeHandle.style.marginLeft = this.timeBarWidth * val + 'px';
            this.elTimeBarProgress.style.width = val * 100 + '%';
            this.timeValue = val;

            if (willTrigger) {
                this.trigger('time', val);
            }
        }
    }, {
        key: 'setTimeVal',
        value: function setTimeVal(timeString) {
            this.elTimeVal.innerHTML = '- ' + formatTime(timeString);
        }
    }, {
        key: 'renderTo',
        value: function renderTo(parentNode) {
            parentNode.appendChild(this.el);
            // this.timeBarWidth = this.elTimeBar.offsetWidth - this.elTimeHandle.offsetWidth;
            // this.setTime(0, true);
        }
    }, {
        key: 'show',
        value: function show() {
            // $(this.el).stop().animate({
            //   bottom: '0px'
            // });
            pcVideoUtil.removeClass(this.el, 'videoControlHalfHide');
            // if (_this.fullFlag && !_this.rightFlag) pcVideoUtil.addClass(topdom, 'videosiderTopShow');
            this.trigger('show');
            this.isHide = false;
            // clearTimeout(this.hideTimer);
            // this.hideTimer = setTimeout(function() {
            //     this.hide();
            // }.bind(this), 3000);
        }
    }, {
        key: 'hide',
        value: function hide() {
            // $(this.el).stop().animate({
            //   bottom: '-100px'
            // });
            if (this.isHide) return;
            pcVideoUtil.addClass(this.el, 'videoControlHalfHide');
            // if (_this.fullFlag) pcVideoUtil.removeClass(topdom, 'videosiderTopShow');


            // this.el.style.visibility = 'hidden';
            this.isHide = true;
            this.trigger('hide');
        }
    }, {
        key: 'hideAll',
        value: function hideAll() {
            $(this.el).addClass('videoControlHide');
        }
    }, {
        key: 'showAll',
        value: function showAll() {
            $(this.el).removeClass('videoControlHide');
        }
    }, {
        key: 'toggle',
        value: function toggle() {
            if (this.isHide == true) {
                this.show();
            } else {
                this.hide();
            }
        }
    }, {
        key: 'resize',
        value: function resize() {
            this.timeBarWidth = this.elTimeBar.offsetWidth - this.elTimeHandle.offsetWidth;
            this.setTime(this.timeValue);
        }

        /**
         *
         * 销毁组件
         */

    }, {
        key: 'destory',
        value: function destory() {
            this.off();
            this.el.removeEventListener('click', clickFn);
            this.el.parentNode.removeChild(this.el);
        }
    }]);

    return Control;
}();

__WEBPACK_IMPORTED_MODULE_4_f_core_event__["a" /* default */].mixTo(Control);

/* harmony default export */ __webpack_exports__["a"] = (Control);

/***/ }),

/***/ "QZmx":
/***/ (function(module, exports) {

function PCVideoutil() {
    Date.prototype.formatNowTime = function (_time) {
        //格式化时间
        var o = {
            "M+": this.getMonth() + 1, //月份 
            "d+": this.getDate(), //日 
            "h+": this.getHours(), //小时 
            "m+": this.getMinutes(), //分 
            "s+": this.getSeconds(), //秒 
            "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
            "S": this.getMilliseconds() //毫秒 
        };
        if (/(y+)/.test(_time)) _time = _time.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o) {
            if (new RegExp("(" + k + ")").test(_time)) _time = _time.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }return _time;
    };
}
PCVideoutil.prototype = {
    showTextMenu: function showTextMenu(e) {
        //自定义右键菜单样式
        var clickX = e.clientX,
            clickY = e.clientY;
        var videoMenu = document.getElementById('js_video_menu');
        videoMenu.style.display = 'block';
        videoMenu.style.left = clickX - videoboxLeft + 'px';
        videoMenu.style.top = clickY - getEleOffsetTop(box) + 'px';
        e.stopPropagation();
        e.preventDefault();
    },
    hideTextMenu: function hideTextMenu() {
        //隐藏右键后的自定义菜单
        var videoMenu = document.getElementById('js_video_menu');
        videoMenu.style.display = 'none';
    },
    hasClass: function hasClass(ele, classname) {
        //检测某个元素是否含有该类名
        return ele.className.indexOf(classname);
    },
    removeClass: function removeClass(ele, classname) {
        //移除类名
        if (this.hasClass(ele, classname) > -1) {
            var reg = new RegExp('(\\s|^)' + classname + '(\\s|$)');
            ele.className = ele.className.replace(reg, ' ');
        }
    },
    addClass: function addClass(ele, classname) {
        //添加类名
        if (this.hasClass(ele, classname) < 0) {
            ele.className += ' ' + classname;
        }
    },
    getStyle: function getStyle(ele) {
        //获取元素现在的sytle
        var cur = ele.currentStyle ? ele.currentStyle : document.defaultView.getComputedStyle(ele, null);
        return cur;
    },
    delNodes: function delNodes(ele) {
        //获取后代，删除无用node
        var ele_child = ele.childNodes;
        for (var i = 0; i < ele_child.length; i++) {
            if (ele_child[i].nodeName == "#text" && !/\s/.test(ele_child.nodeValue)) {
                ele.removeChild(ele_child[i]);
            }
        }
        return ele;
    },
    removeElement: function removeElement() {
        //删除元素
        for (var i = 0, ilen = arguments.length; i < ilen; i++) {
            var _parentElement = arguments[i].parentNode;
            if (_parentElement) _parentElement.removeChild(arguments[i]);
        }
    },
    moretime: function moretime(time) {

        var seconds = Math.round(time % 60) < 10 ? '0' + Math.round(time % 60) : Math.round(time % 60);
        var minutes = parseInt(time / 60 % 60) < 10 ? '0' + parseInt(time / 60 % 60) : parseInt(time / 60 % 60);
        var hours = parseInt(time / 3600 % 24);
        var goodhours = hours < 10 ? '0' + hours : hours;
        if (hours == 0) {
            return minutes + ':' + seconds;
        } else {
            return goodhours + ':' + minutes + ':' + seconds;
        }
    },
    formatTime: function formatTime(_time) {
        //格式化时间
        var second = _time / 1,
            temp = [],
            s;

        if (second === 0) {
            return '00:00';
        }
        while (second !== 0) {
            s = second % 60;
            if (s < 10) {
                s = '0' + s;
            }
            temp.unshift(s);
            second = Math.floor(second / 60);
        }
        if (temp.length < 2) {
            temp.unshift('00');
        }
        return temp.join(':');
    },
    formatNum: function formatNum(num) {
        //格式化数字
        var _num = num < 100 ? num < 10 ? '00' + num : '0' + num : num;
        return _num;
    },
    getEleOffsetLeft: function getEleOffsetLeft(obj) {
        //获取元素相对于浏览器窗口最左边的距离
        var l = obj.offsetLeft;
        while (obj.offsetParent != null) {
            obj = obj.offsetParent;
            l += obj.offsetLeft;
        }
        return l;
    },
    getEleOffsetTop: function getEleOffsetTop(obj) {
        //获取元素相对于浏览器窗口最顶部的距离
        var l = obj.offsetTop;
        while (obj.offsetParent != null) {
            obj = obj.offsetParent;
            l += obj.offsetTop;
        }
        return l;
    },
    bind: function bind(ele, type, fn) {
        //给元素绑定相应事件
        if (typeof type == 'string') {
            ele.addEventListener ? ele.addEventListener(type, fn, false) : ele.attachEvent ? ele.attachEvent('on' + type, fn) : el['on' + type] = fn;
        } else {
            for (var i in type) {
                ele.addEventListener ? ele.addEventListener(type[i], fn, false) : ele.attachEvent ? ele.attachEvent('on' + type[i], fn) : ele['on' + type[i]] = fn;
            }
        }
    },
    removeHandler: function removeHandler(element, type, handler) {
        if (element.removeEventListener) {
            element.removeEventListener(type, handler, false);
        } else if (element.detachEvent) {
            element.detachEvent("on" + type, handler);
        } else {
            element["on" + type] = null;
        }
    },
    extend: function extend() {
        var result = {};
        for (var i = 0, iLen = arguments.length; i < iLen; i++) {
            var o = arguments[i];
            for (var key in o) {
                result[key] = o[key];
            }
        }
        return result;
    },
    playerSetCookie: function playerSetCookie(name, value, path, domain, expires, secure) {
        //设置cookie
        var doFn = encodeURIComponent;
        var cStrArr = [];
        cStrArr.push(name + '=' + doFn(value));
        if (expires) {
            var date = new Date();
            date.setTime(date.getTime() + expires * 1000 * 60);
            cStrArr.push('; expires=' + date.toGMTString());
        }
        cStrArr.push(path ? '; path=' + path : '');
        cStrArr.push(domain ? '; domain=' + domain : '');
        cStrArr.push(secure ? '; secure' : '');
        document.cookie = cStrArr.join('');
    },
    playerGetAll: function playerGetAll() {
        var cookieArr = [];
        if (document.cookie !== '') {
            var cStrArr = document.cookie.split(';');
            for (var i = 0, l = cStrArr.length; i < l; i++) {
                var cStr = cStrArr[i];
                var index = cStr.indexOf('=');
                var name = cStr.substring(0, index).replace(/[ ]/g, "");
                var value = cStr.substring(index + 1);
                var cookie = {};
                cookie.name = name;
                cookie.value = value;
                cookieArr.push(cookie);
            }
        }
        return cookieArr;
    },
    playerGetCookie: function playerGetCookie(name) {
        //获取cookie
        var cookieArr = this.playerGetAll();
        for (var i = 0, l = cookieArr.length; i < l; i++) {
            var cookie = cookieArr[i];
            if (cookie.name === name) {
                var doFn = decodeURIComponent;
                return doFn(cookie.value);
            }
        }
        return '';
    },
    showFlashPlayer: function showFlashPlayer() {
        //显示flash播放器，隐藏video播放器，用于两者间的转换
        document.getElementById('playercontainer').style.display = 'none';
        document.getElementById('vPlayer_box').style.display = 'block';
        document.getElementById('playercontainer').parentNode.removeChild(document.getElementById('playercontainer'));
    },
    ifIE: function ifIE() {
        //判断是否为ie浏览器
        var ieFlag = !!window.ActiveXObject || "ActiveXObject" in window ? true : false;
        return ieFlag;
    },
    ifFlash: function ifFlash() {
        //判断是否为flash播放器，用于flash和video的切换
        var flashFlag = this.playerGetCookie('ifFlag');
        return false;
    },
    getOS: function getOS() {
        var sUserAgent = navigator.userAgent,
            _platform = navigator.platform,
            isWin = _platform == 'Win32' || _platform == 'Windows',
            isMac = _platform == 'Mac68K' || _platform == 'MacPPC' || _platform == 'Macintosh' || _platform == 'MacIntel';
        if (isMac) return 'Mac';
        var isUnix = _platform == 'X11' && !isWin && !isMac;
        if (isUnix) return 'Unix';
        var isLinux = String(_platform).indexOf('Linux') > -1;
        if (isLinux) return 'Linux';
        if (isWin) {
            var isWin2K = sUserAgent.indexOf('Windows') > -1 || sUserAgent.indexOf('Windows 2000') > -1;
            if (isWin2K) return "Win2000";
            var isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1;
            if (isWinXP) return "WinXP";
            var isWin2003 = sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
            if (isWin2003) return "Win2003";
            var isWinVista = sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
            if (isWinVista) return "WinVista";
            var isWin7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
            if (isWin7) return "Win7";
        }
        return "other";
    },
    getBrowser: function getBrowser() {
        var explorer = window.navigator.userAgent.toLowerCase();
        if (explorer.indexOf("msie") >= 0) {
            //ie
            var ver = explorer.match(/msie ([\d.]+)/)[1];
            return {
                type: "IE",
                version: ver
            };
        } else if (explorer.indexOf("firefox") >= 0) {
            //firefox
            var ver = explorer.match(/firefox\/([\d.]+)/)[1];
            return {
                type: "Firefox",
                version: ver
            };
        } else if (explorer.indexOf("chrome") >= 0) {
            //chrome
            var ver = explorer.match(/chrome\/([\d.]+)/)[1];
            return {
                type: "Chrome",
                version: ver
            };
        } else if (explorer.indexOf("opera") >= 0) {
            //opera
            var ver = explorer.match(/opera.([\d.]+)/)[1];
            return {
                type: "Opera",
                version: ver
            };
        } else if (explorer.indexOf("safari") >= 0) {
            //safari
            var ver = explorer.match(/version\/([\d.]+)/)[1];
            return {
                type: "Safari",
                version: ver
            };
        } else {
            return {
                type: "",
                version: ver
            };
        }
    },
    getResolution: function getResolution() {
        return {
            screenW: screen.width,
            screenH: screen.height
        };
    },
    getCookie: function getCookie(name) {
        var cStrArr = document.cookie.split(';');
        for (var i = 0, l = cStrArr.length; i < l; i++) {
            var cStr = cStrArr[i];
            var index = cStr.indexOf('=');
            var cname = cStr.substring(0, index).replace(/[ ]/g, "");
            var value = cStr.substring(index + 1);
            if (cname === name) {
                return decodeURIComponent(value);
            }
        }
        return '';
    },

    setCookie: function setCookie(name, value) {
        var cStrArr = [];

        cStrArr.push(name + '=' + encodeURIComponent(value));
        var date = new Date();
        date.setTime(date.getTime() + 24 * 60 * 1000 * 60 * 7);
        cStrArr.push('; expires=' + date.toGMTString());
        cStrArr.push('; path=/');
        cStrArr.push('; domain=.ifeng.com');

        document.cookie = cStrArr.join('');
    },
    getRandomUid: function getRandomUid() {
        var date = new Date().getTime(),
            uid = '',
            fn = '',
            sn = '';

        fn = (Math.random() * 2147483648 | 0).toString(36);
        sn = Math.round(Math.random() * 10000);
        uid = date + '_' + fn + sn;
        return uid;
    },
    getCurrentViedoInfo: function getCurrentViedoInfo() {
        var result = videoinfo;
        var o = {};
        o.img = encodeURIComponent(result.videoLargePoster);
        o.title = encodeURIComponent(result.name);
        o.url = encodeURIComponent(result.url);
        o.guid = result.guid;
        return o;
    },
    shareVideo: function shareVideo(sTag, type) {
        var info = this.getCurrentViedoInfo();
        var _tp = new Date().getTime();
        var url;
        var appkey;
        var site;

        switch (sTag) {
            case "sinateew":

                // 这个请求是405。。
                // ifeng.util.getScript('http://api.t.sina.com.cn/friendships/create/1806128454.xml?source=168486312');
                url = "http://v.t.sina.com.cn/share/share.php?" + "appkey=168486312&url=" + info.url + encodeURIComponent("?tp=" + _tp + "#_share=sina") + "&title=" + info.title + "&source=ifeng&sourceUrl=http://v.ifeng.com/&content=utf8&ralateUid=1806128454" + "&pic=" + info.img;

                window.open(url, "", "toolbar=0,status=0,resizable=1,width=440,height=430" + ",left=" + (screen.width - 440) / 2 + ",top=" + (screen.height - 430) / 2);
                break;

            case "qqzone":
                window.open("http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" + info.url + encodeURIComponent("?tp=" + _tp + "#_share=qqZone"));
                break;

            case "qqteew":
                appkey = encodeURIComponent("f8ca1cd768da4529ab190fae9f1bf21d");
                site = "http://v.ifeng.com";
                //http://connect.qq.com/widget/shareqq/index.html?title=&url=&desc=&pics=&site=&callback=?userId=0
                //http://connect.qq.com/intro/sharetoqq/index.html?title='实拍台军拒统利器宣传片 毫不避讳台独姿态'&url=http://v.ifeng.com/test/wx_test.shtml&desc=按发送方师傅上发生地方&pics=&site=ddd
                url = "http://connect.qq.com/widget/shareqq/index.html?title=" + info.title + "&url=" + info.url + encodeURIComponent("?tp=" + _tp + "#_share=qq") + "&appkey=" + appkey + "&site=" + site + "&pic=" + info.img;
                window.open(url);
                break;
            case "renren":
                url = "http://share.renren.com/share/buttonshare.do?" + "link=" + info.url + encodeURIComponent("?tp=" + _tp + "#_share=" + type) + "&title=" + info.title;
                window.open(url);
                break;

            case "ifengteew":
                url = "http://t.ifeng.com/interface.php?_c=share&_a=share" + "&sourceUrl=" + info.url + encodeURIComponent("?tp=" + _tp + "#_share=" + type) + "&title=" + info.title + "&pic=" + info.img + "&source=" + encodeURIComponent("凤凰视频") + "&type=1";
                window.open(url, "", "toolbar=0,status=0,resizable=1,width=640,height=481" + ",left=" + (screen.width - 440) / 2 + ",top=" + (screen.height - 480) / 2);

                break;

            case "kaixin":
                url = "http://www.kaixin001.com/repaste/share.php?" + "rurl=" + info.url + encodeURIComponent("?tp=" + _tp + "#_share=" + type) + "&rtitle=" + info.title;
                window.open(url);
                break;

            case "sohuteew":
                url = "http://t.sohu.com/third/post.jsp?" + "url=" + info.url + encodeURIComponent("?tp=" + _tp + "#_share=" + type) + "&title=" + info.title + "&content=utf-8" + "&pic=" + info.img;
                window.open(url, "", "toolbar=0,status=0,resizable=1,width=660,height=470" + ",left=" + (screen.width - 660) / 2 + ",top=" + (screen.height - 470) / 2);
                break;

            case "163":
                url = "http://t.163.com/article/user/checkLogin.do?" + "link=http://www.ifeng.com" + "&source=" + encodeURIComponent("凤凰网") + "&info=" + info.title + info.url + encodeURIComponent("?tp=" + _tp + "#_share=" + type) + "&" + new Date().getTime();
                window.open(url, "", "height=330,width=550,toolbar=no,menubar=no,scrollbars=no,resizable=yes,location=no,status=no" + ",top=" + (screen.height - 280) / 2 + ",left=" + (screen.width - 550) / 2);
                break;

            case "feixin":
                url = "http://space.fetion.com.cn/api/share?" + "Source=" + encodeURIComponent("凤凰视频") + "&Title=" + info.title + "&url=" + info.url + encodeURIComponent("?tp=" + _tp + "#_share=" + type) + "&IsEditTitle=false";
                window.open(url);
                break;

            // 对网址有验证，所以内网地址通不过
            case "51com":
                url = "http://share.51.com/share/out_share_video.php?" + "from=" + encodeURIComponent("凤凰视频") + "&title=" + info.title + "&vaddr=" + info.url + encodeURIComponent("?tp=" + _tp + "#_share=" + type) + "&IsEditTitle=false&charset=utf-8";
                window.open(url);
                break;

            // 对网址有验证，所以内网地址通不过
            case "baiduI":
                url = "http://tieba.baidu.com/i/app/open_share_api?" + "link=" + info.url + encodeURIComponent("?tp=" + _tp + "#_share=" + type);
                window.open(url);
                break;

            case "weixin":
                url = "http://v.ifeng.com/weixin.shtml?title=" + info.title + "&link=" + info.url;
                window.open(url, "分享到微信", "height=984,width=850,toolbar=no,menubar=no,scrollbars=no,resizable=yes,location=no,status=no" + ",top=" + (screen.height - 280) / 2 + ",left=" + (screen.width - 550) / 2);
                break;

            default:

                break;
        }
    },
    sendStatisticInfoC: function sendStatisticInfoC(type) {
        var statistic = {};
        statistic.datatype = 'share';
        statistic.value = type;

        var userid;

        if (this.getCookie('userid') === '') {
            userid = this.getRandomUid();
            this.setCookie('userid', userid);
        } else {
            userid = this.getCookie('userid');
        }

        // var doms = F.query('script');
        statistic.ref = window.location.host;

        var sid = this.getCookie('sid');
        statistic.sid = sid;

        if (typeof videoinfo != 'undefined') {
            var categoryPath = videoinfo.categoryPath;
            if (categoryPath) {
                var info = "http://v.ifeng.com/" + categoryPath + "/,,,";
            } else {
                var info = "http://v.ifeng.com/,,,";
            }
        }
        statistic.ci = info;
        statistic.pt = 'vtype=player';
        statistic.time = new Date().getTime();;
        statistic.uri = window.location.href;

        this.sendStatisticInfoM(statistic);
        return statistic;
    },
    sendStatisticInfoM: function sendStatisticInfoM(param) {
        var statisticUrl = "http://stadig.ifeng.com/actsta.js";
        $.ajax({
            url: statisticUrl,
            data: param,
            cache: true,
            dataType: 'script'
        });
    }

};

module.exports = PCVideoutil;

/***/ }),

/***/ "R9M2":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "RPLV":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("7KvD").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "RY/4":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("R9M2");
var TAG = __webpack_require__("dSzd")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "S82l":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "SfB7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("+E39") && !__webpack_require__("S82l")(function () {
  return Object.defineProperty(__webpack_require__("ON07")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "TcQ7":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("MU5D");
var defined = __webpack_require__("52gC");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "U5ju":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("M6a0");
__webpack_require__("zQR9");
__webpack_require__("+tPU");
__webpack_require__("CXw9");
__webpack_require__("EqBC");
__webpack_require__("jKW+");
module.exports = __webpack_require__("FeBl").Promise;


/***/ }),

/***/ "UI+c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_DownloadModel__ = __webpack_require__("PPPt");




/**
 * MSE初始化类
 *
 */

var MSE = function () {
    /**
     * Creates an instance of MSE.
     * @param {any} {video, }
     */
    function MSE(_ref) {
        var video = _ref.video,
            mp4Url = _ref.mp4Url,
            segmentSize = _ref.segmentSize,
            showTestInfo = _ref.showTestInfo;

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MSE);

        /**
         * mse
         */
        this.mediaSource = null;
        this.video = video;
        this.autoplay = true;
        this.downloadObj = new __WEBPACK_IMPORTED_MODULE_2__modules_DownloadModel__["a" /* default */]({ showTestInfo: showTestInfo });
        this.mp4box = new MP4Box();
        this.movieInfo = null;
        this.mp4Url = mp4Url;
        this.segmentSize = segmentSize;
        this.bitrate = null;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(MSE, [{
        key: 'init',
        value: function init() {
            this.reset();
        }
    }, {
        key: 'reset',
        value: function reset() {
            // this.stop();
            this.resetMediaSource();
        }
    }, {
        key: 'start',
        value: function start() {
            this.mp4box.start();
        }

        /**
         * 播放
         */

    }, {
        key: 'play',
        value: function play() {
            this.autoplay = true;
            console.log('play');
            // this.video.play();
        }
    }, {
        key: 'pause',
        value: function pause() {
            this.downloadObj.pause();
        }

        /**
         * 开始加载
         */

    }, {
        key: 'load',
        value: function load() {
            var _this = this;

            // debugger
            console.log('load');
            var ms = this.video.ms;

            if (ms.readyState !== 'open') {
                setTimeout(this.load.bind(this), 300);
                return;
            }

            this.downloadObjInit();

            this.mp4box.onMoovStart = function () {
                //console.info('Application', 'Starting to parse movie information');
            };
            this.mp4box.onReady = function (info) {
                // console.info('Application', 'Movie information received');
                //console.log(info)
                _this.bitrate = info.duration;
                _this.movieInfo = info;
                if (info.isFragmented) {
                    ms.duration = info.fragment_duration / info.timescale;
                } else {
                    ms.duration = info.duration / info.timescale;
                }

                if (_this.autoplay) {
                    _this.initializeAllSourceBuffers();
                }
            };

            this.mp4box.onSegment = function (id, user, buffer, sampleNum) {
                var sb = user;
                // saveBuffer(buffer, 'track-' + id + '-segment-' + sb.segmentIndex + '.m4s');
                sb.segmentIndex++;
                sb.pendingAppends.push({
                    id: id,
                    buffer: buffer,
                    sampleNum: sampleNum
                });
                console.info('Application', 'Received new segment for track ' + id + ' up to sample #' + sampleNum + ', segments pending append: ' + sb.pendingAppends.length + '---' + sb.segmentIndex);
                _this.onUpdateEnd.call(sb, _this.mp4box, _this.video, true, false);
            };

            this.mp4box.onerror = function (e) {
                console.log(e);
            };
        }
    }, {
        key: 'getRate',
        value: function getRate() {
            return this.bitrate;
        }
    }, {
        key: 'initializeAllSourceBuffers',
        value: function initializeAllSourceBuffers() {
            if (this.movieInfo) {
                var info = this.movieInfo;
                for (var i = 0; i < info.tracks.length; i++) {
                    var track = info.tracks[i];
                    this.addBuffer(this.video, track);
                    // let checkBox = document.getElementById("addTrack" + track.id);
                    // checkBox.checked = true;
                }
                this.initializeSourceBuffers();
            }
        }

        // 切换视频源

    }, {
        key: 'changeRate',
        value: function changeRate() {
            this.video.ms = this.mediaSource;
            this.mediaSource.addEventListener('sourceopen', this.onSourceOpen.bind(this));
            this.mediaSource.addEventListener('sourceclose', this.onSourceClose.bind(this));
            this.downloadObj.pause();
            this.setVideoSrc();
        }

        /**
         * 重置MSE
         */

    }, {
        key: 'resetMediaSource',
        value: function resetMediaSource() {
            this.mediaSource = null;
            this.mediaSource = new MediaSource();
            this.video.ms = this.mediaSource;
            this.mediaSource.addEventListener('sourceopen', this.onSourceOpen.bind(this));
            this.mediaSource.addEventListener('sourceclose', this.onSourceClose.bind(this));
            this.downloadObj.pause();
            this.setVideoSrc();
        }
    }, {
        key: 'setVideoSrc',
        value: function setVideoSrc() {
            this.video.src = window.URL.createObjectURL(this.mediaSource);
        }
    }, {
        key: 'addBuffer',
        value: function addBuffer(video, mp4track) {
            var sb = void 0;
            var ms = video.ms;
            var mp4box = this.mp4box;
            var track_id = mp4track.id;
            var codec = mp4track.codec;
            var mime = 'video/mp4; codecs="' + codec + '"';
            var kind = mp4track.kind;
            var trackDefault = void 0;
            var trackDefaultSupport = typeof TrackDefault !== 'undefined';
            var html5TrackKind = '';
            if (codec == 'wvtt') {
                if (!kind.schemeURI.startsWith('urn:gpac:')) {
                    html5TrackKind = 'subtitles';
                } else {
                    html5TrackKind = 'metadata';
                }
            } else {
                if (kind && kind.schemeURI === 'urn:w3c:html5:kind') {
                    html5TrackKind = kind.value || '';
                }
            }
            if (trackDefaultSupport) {
                // mp4track.type = 'video';
                if (mp4track.type === 'video' || mp4track.type === 'audio') {
                    trackDefault = new TrackDefault(mp4track.type, mp4track.language, mp4track.name, [html5TrackKind], track_id);
                } else {
                    trackDefault = new TrackDefault('text', mp4track.language, mp4track.name, [html5TrackKind], track_id);
                }
            }
            if (MediaSource.isTypeSupported(mime)) {
                try {
                    console.info('MSE - SourceBuffer #' + track_id, "Creation with type '" + mime + "'");
                    sb = ms.addSourceBuffer(mime); // 创建mediasource
                    if (trackDefaultSupport) {
                        sb.trackDefaults = new TrackDefaultList([trackDefault]);
                    }
                    sb.addEventListener('error', function (e) {
                        console.error('MSE SourceBuffer #' + track_id, e);
                    });
                    sb.ms = ms;
                    sb.id = track_id;
                    mp4box.setSegmentOptions(track_id, sb, {
                        nbSamples: parseInt(this.segmentSize)
                    });
                    sb.pendingAppends = [];
                    console.log('sb.buffered===========>', sb.buffered);
                } catch (e) {
                    console.error('MSE - SourceBuffer #' + track_id, "Cannot create buffer with type '" + mime + "'" + e);
                }
            }
        }
    }, {
        key: 'initializeSourceBuffers',
        value: function initializeSourceBuffers() {
            var initSegs = this.mp4box.initializeSegmentation();
            for (var i = 0; i < initSegs.length; i++) {
                var sb = initSegs[i].user;
                if (i === 0) {
                    sb.ms.pendingInits = 0;
                }
                sb.addEventListener('updateend', this.onInitAppended.bind(this));
                console.info('MSE - SourceBuffer #' + sb.id, 'Appending initialization data');
                sb.appendBuffer(initSegs[i].buffer);
                // saveBuffer(initSegs[i].buffer, 'track-' + initSegs[i].id + '-init.mp4');
                sb.segmentIndex = 0;
                sb.ms.pendingInits++;
            }
        }
    }, {
        key: 'onInitAppended',
        value: function onInitAppended(e) {
            console.log('updateedn================');
            var sb = e.target;
            if (sb.ms.readyState === 'open') {
                MSE.updateBufferedString(sb, 'Init segment append ended', this.video.currentTime);
                sb.sampleNum = 0;
                sb.removeEventListener('updateend', this.onInitAppended.bind(this));
                sb.addEventListener('updateend', this.onUpdateEnd.bind(sb, this.mp4box, this.video, true, true));
                /* In case there are already pending buffers we call onUpdateEnd to start appending them*/
                this.onUpdateEnd.call(sb, this.mp4box, this.video, false, true);
                sb.ms.pendingInits--;
                if (this.autoplay && sb.ms.pendingInits === 0) {
                    this.start();
                }
            }
        }
    }, {
        key: 'onUpdateEnd',
        value: function onUpdateEnd(mp4box, video, isNotInit, isEndOfAppend) {
            if (isEndOfAppend === true) {
                if (isNotInit === true) {
                    MSE.updateBufferedString(this, 'Update ended', video.currentTime);
                }
                if (this.sampleNum) {
                    mp4box.releaseUsedSamples(this.id, this.sampleNum);
                    delete this.sampleNum;
                }
            }
            if (this.ms.readyState === 'open' && this.updating === false && this.pendingAppends.length > 0) {
                var obj = this.pendingAppends.shift();
                console.info('MSE - SourceBuffer #' + this.id, 'Appending new buffer, pending: ' + this.pendingAppends.length, this);
                this.sampleNum = obj.sampleNum;
                this.appendBuffer(obj.buffer);
            }
        }

        /**
         *
         */

    }, {
        key: 'downloadObjInit',
        value: function downloadObjInit() {
            this.downloadObj.init({
                mURL: this.mp4Url,
                mReturnDataCallback: this.downloadDataCallback.bind(this)
            });
        }
    }, {
        key: 'downloadDataCallback',
        value: function downloadDataCallback(buffer, start) {
            if (buffer) {
                console.log('start====================================> ' + start, buffer.buffer);
                buffer.buffer.fileStart = start;
                this.mp4box.appendBuffer(buffer.buffer);
                this.mp4box.start();
                // this.video.play();
            }
        }
    }, {
        key: 'onSourceClose',
        value: function onSourceClose(e) {
            var ms = e.target;
            if (this.video.error) {
                console.error('MSE', 'Source closed, video error: ' + this.video.error.code);
            } else {
                console.info('MSE', 'Source closed, no error');
            }
        }
    }, {
        key: 'onSourceOpen',
        value: function onSourceOpen(e) {
            var ms = e.target;
            console.info('MSE', 'Source opened');
            // console.debug('MSE', ms);
        }
    }], [{
        key: 'updateBufferedString',
        value: function updateBufferedString(sb, string, currentTime) {
            var rangeString = void 0;
            if (sb.ms.readyState === 'open') {
                rangeString = MSE.printRanges(sb.buffered);
                //console.info("MSE - SourceBuffer #" + sb.id, string + ", updating: " + sb.updating + ", currentTime: " + MSE.getDurationString(currentTime, 1) + ", buffered: " + rangeString + ", pending: " + sb.pendingAppends.length);
            }
        }
    }, {
        key: 'printRanges',
        value: function printRanges(ranges) {
            var length = ranges.length;
            if (length > 0) {
                var str = '';
                for (var i = 0; i < length; i++) {
                    if (i > 0) str += ',';
                    str += '[' + MSE.getDurationString(ranges.start(i)) + ',' + MSE.getDurationString(ranges.end(i)) + ']';
                }
                return str;
            } else {
                return '(empty)';
            }
        }

        /* Helper function to print a duration value in the form H:MM:SS.MS */

    }, {
        key: 'getDurationString',
        value: function getDurationString(duration, _timescale) {
            var neg = void 0;
            /* Helper function to print a number on a fixed number of digits */
            function pad(number, length) {
                var str = '' + number;
                var a = str.split('.');
                while (a[0].length < length) {
                    a[0] = '0' + a[0];
                }
                return a.join('.');
            }
            if (duration < 0) {
                neg = true;
                duration = -duration;
            } else {
                neg = false;
            }
            var timescale = _timescale || 1;
            var duration_sec = duration / timescale;
            var hours = Math.floor(duration_sec / 3600);
            duration_sec -= hours * 3600;
            var minutes = Math.floor(duration_sec / 60);
            duration_sec -= minutes * 60;
            var msec = duration_sec * 1000;
            duration_sec = Math.floor(duration_sec);
            msec -= duration_sec * 1000;
            msec = Math.floor(msec);
            return (neg ? '-' : '') + hours + ':' + pad(minutes, 2) + ':' + pad(duration_sec, 2) + '.' + pad(msec, 3);
        }
    }]);

    return MSE;
}();

/* harmony default export */ __webpack_exports__["a"] = (MSE);

/***/ }),

/***/ "UM2m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_css__ = __webpack_require__("obC0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_ejs__ = __webpack_require__("bS4S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_ejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main_ejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_f_core_event__ = __webpack_require__("gzOS");


/**
 * Error module.
 * @module video/Error
 */





/**
 * 播放失败提示
 */

var ErrorBox = function () {
  /**
   * Creates an instance of ErrorBox.
   */
  function ErrorBox() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ErrorBox);

    // this.title = title || '主...主播失联...搜寻中！';
    this.init();
  }

  /**
   * 初始化
   */


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ErrorBox, [{
    key: 'init',
    value: function init() {
      this.initDom();
      this.initEvent();
    }

    /**
     * 初始化dom
     */

  }, {
    key: 'initDom',
    value: function initDom() {
      this.el = $(__WEBPACK_IMPORTED_MODULE_3__main_ejs___default()())[0];
      this.replay = $(this.el).find('#js_videofail_replay');
    }

    /**
     * 初始化自定义事件
     */

  }, {
    key: 'initEvent',
    value: function initEvent() {
      var _this = this;
      this.replay.on('click', function () {
        _this.trigger('replay');
      });
    }

    /**
     * 隐藏组件
     */

  }, {
    key: 'hide',
    value: function hide() {
      this.el.style.display = 'none';
    }

    /**
     * 显示组件
     */

  }, {
    key: 'show',
    value: function show() {
      this.el.style.display = 'block';
    }

    /**
     * 渲染组件
     *
     * @param {HTMLELEMENT} parentNode
     */

  }, {
    key: 'renderTo',
    value: function renderTo(parentNode) {
      parentNode.appendChild(this.el);
    }

    /**
     * 销毁组件
     */

  }, {
    key: 'destory',
    value: function destory() {
      this.el.parentNode.removeChild(this.el);
    }
  }]);

  return ErrorBox;
}();

__WEBPACK_IMPORTED_MODULE_4_f_core_event__["a" /* default */].mixTo(ErrorBox);
/* harmony default export */ __webpack_exports__["a"] = (ErrorBox);

/***/ }),

/***/ "UuGF":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "X8DO":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "Yobk":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("77Pl");
var dPs = __webpack_require__("qio6");
var enumBugKeys = __webpack_require__("xnc9");
var IE_PROTO = __webpack_require__("ax3d")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("ON07")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("RPLV").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "Zrlr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ "ax3d":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("e8AB")('keys');
var uid = __webpack_require__("3Eo+");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "bRrM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("7KvD");
var core = __webpack_require__("FeBl");
var dP = __webpack_require__("evD5");
var DESCRIPTORS = __webpack_require__("+E39");
var SPECIES = __webpack_require__("dSzd")('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "bS4S":
/***/ (function(module, exports) {


if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"videofail\" id=\"js_video_fail\">\n    <div class=\"videofailLayout\">\n        <div class=\"videofailText\">亲，播放失败了</div>\n        <div class=\"videofailReplay\">\n            <div class=\"videofailReplayBtn\" id=\"js_videofail_replay\">\n                <i></i>\n                <span>重播</span>\n            </div>\n        </div>\n    </div>\n</div>")
  }
  return __output.join("");

}

/***/ }),

/***/ "c/Tr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("5zde"), __esModule: true };

/***/ }),

/***/ "c0Wv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VideoEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return videoPropertiesByGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return videoPropertiesBySet; });
/** video events
 * @static
 * @constant
 * @private
 * @memberof video/core
*/
var VideoEvents = ['loadstart', 'suspend', 'abort', 'error', 'emptied', 'stalled', 'loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough', 'playing', 'waiting', 'seeking', 'seeked', 'ended', 'durationchange', 'timeupdate', 'progress', 'play', 'pause', 'ratechange', 'volumechange'];

/** video 可以取值的属性
 * @static
 * @constant
 * @private
 * @memberof video/core
*/
var videoPropertiesByGet = [
/**
 * Paused for core tech
 *
 * @method Core.prototype.paused
 * @return {Boolean}
 */
'paused',
/**
 * Get current time
 *
 * @method Core.prototype.currentTime
 * @return {Number}
 */
'currentTime',
/**
 * Get a TimeRange object that represents the intersection
 * of the time ranges for which the user agent has all
 * relevant media
 *
 * @return {TimeRangeObject}
 * @method Core.prototype.buffered
 */
'buffered',
/**
 * Get volume level
 *
 * @return {Number}
 * @method Core.prototype.volume
 */
'volume',
/**
 * Get if muted
 *
 * @return {Boolean}
 * @method Core.prototype.muted
 */
'muted',
/**
 * Get poster
 *
 * @return {String}
 * @method Core.prototype.poster
 */
'poster',
/**
 * Get preload attribute
 *
 * @return {String}
 * @method Core.prototype.preload
 */
'preload',
/**
 * Get autoplay attribute
 *
 * @return {String}
 * @method Core.prototype.autoplay
 */
'autoplay',
/**
 * Get controls attribute
 *
 * @return {String}
 * @method Core.prototype.controls
 */
'controls',
/**
 * Get loop attribute
 *
 * @return {String}
 * @method Core.prototype.loop
 */
'loop',
/**
 * Get error value
 *
 * @return {String}
 * @method Core.prototype.error
 */
'error',
/**
 * Get whether or not the player is in the "seeking" state
 *
 * @return {Boolean}
 * @method Core.prototype.seeking
 */
'seeking',
/**
 * Get a TimeRanges object that represents the
 * ranges of the media resource to which it is possible
 * for the user agent to seek.
 *
 * @return {TimeRangeObject}
 * @method Core.prototype.seekable
 */
'seekable',
/**
 * Get if video ended
 *
 * @return {Boolean}
 * @method Core.prototype.ended
 */
'ended',
/**
 * Get the value of the muted content attribute
 * This attribute has no dynamic effect, it only
 * controls the default state of the element
 *
 * @return {Boolean}
 * @method Core.prototype.defaultMuted
 */
'defaultMuted',
/**
 * Get desired speed at which the media resource is to play
 *
 * @return {Number}
 * @method Core.prototype.playbackRate
 */
'playbackRate',
/**
 * Returns a TimeRanges object that represents the ranges of the
 * media resource that the user agent has played.
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-played
 *
 * @return {TimeRangeObject} the range of points on the media
 *                           timeline that has been reached through
 *                           normal playback
 * @method Core.prototype.played
 */
'played',
/**
 * Get the current state of network activity for the element, from
 * the list below
 * - NETWORK_EMPTY (numeric value 0)
 * - NETWORK_IDLE (numeric value 1)
 * - NETWORK_LOADING (numeric value 2)
 * - NETWORK_NO_SOURCE (numeric value 3)
 *
 * @return {Number}
 * @method Core.prototype.networkState
 */
'networkState',
/**
 * Get a value that expresses the current state of the element
 * with respect to rendering the current playback position, from
 * the codes in the list below
 * - HAVE_NOTHING (numeric value 0)
 * - HAVE_METADATA (numeric value 1)
 * - HAVE_CURRENT_DATA (numeric value 2)
 * - HAVE_FUTURE_DATA (numeric value 3)
 * - HAVE_ENOUGH_DATA (numeric value 4)
 *
 * @return {Number}
 * @method Core.prototype.readyState
 */
'readyState',
/**
 * Get width of video
 *
 * @return {Number}
 * @method Core.prototype.videoWidth
 */
'videoWidth',
/**
 * Get height of video
 *
 * @return {Number}
 * @method Core.prototype.videoHeight
 */
'videoHeight', 'duration'];

/** video 可以设置的属性
 * @static
 * @constant
 * @private
 * @memberof video/core
*/
var videoPropertiesBySet = [
/**
 * Set volume level
 *
 * @param {Number} percentAsDecimal Volume percent as a decimal
 * @method Core.prototype.setVolume
 */
'volume',
/**
 * Set muted
 *
 * @param {Boolean} muted If player is to be muted or note
 * @method Core.prototype.setMuted
 */
'muted',
/**
 * Set video source
 *
 * @param {Object} src Source object
 * @deprecated since version 5
 * @method Core.prototype.setSrc
 */
'poster',
/**
 * Set preload attribute
 *
 * @param {String} val Value for the preload attribute
 * @method Htm5.prototype.setPreload
 */
'preload',
/**
 * Set autoplay attribute
 *
 * @param {Boolean} autoplay Value for the autoplay attribute
 * @method setAutoplay
 */
'autoplay',
/**
 * Set loop attribute
 *
 * @param {Boolean} loop Value for the loop attribute
 * @method Core.prototype.setLoop
 */
'loop',
/**
 * Set desired speed at which the media resource is to play
 *
 * @param {Number} val Speed at which the media resource is to play
 * @method Core.prototype.setPlaybackRate
 */
'playbackRate'];

/***/ }),

/***/ "dNDb":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "dSzd":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("e8AB")('wks');
var uid = __webpack_require__("3Eo+");
var Symbol = __webpack_require__("7KvD").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "dY0y":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("dSzd")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "e65p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_mediaSource__ = __webpack_require__("UI+c");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__lib_mediaSource__["a" /* default */]);

/***/ }),

/***/ "e6n0":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("evD5").f;
var has = __webpack_require__("D2L2");
var TAG = __webpack_require__("dSzd")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "e8AB":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7KvD");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),

/***/ "eLxI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_core___ = __webpack_require__("3kBm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_recodeControl___ = __webpack_require__("QUAj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_title___ = __webpack_require__("+g5I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_list___ = __webpack_require__("BYgZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_recommend___ = __webpack_require__("eUcP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_error__ = __webpack_require__("UM2m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_f_component_video_vStat__ = __webpack_require__("NBD/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_version__ = __webpack_require__("oN26");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_f_core_event__ = __webpack_require__("gzOS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_f_core_util_pc__ = __webpack_require__("QZmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_f_core_util_pc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_f_core_util_pc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_f_component_video_auth__ = __webpack_require__("63mF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_f_component_mse__ = __webpack_require__("e65p");


/**
 * video module.
 * @module video
 */










// const vStat = new Stat(videoinfo);


var pcVideoUtil = new __WEBPACK_IMPORTED_MODULE_11_f_core_util_pc___default.a();



/**
 * Video 业务核心
 */

var Video = function () {
    /**
     * Creates an instance of Video.
     * @param {Object} obj - An object.
     * @param {Object} obj.videoinfo - 视频相关信息.
     * @param {Object} obj.playermsg - 视频地址.
     * @param {Object} obj.recommend - 后推荐数据.
     * @param {Object} obj.sedata - 相关列表数据.
     * @memberof Video
     */
    function Video(_ref) {
        var videoinfo = _ref.videoinfo,
            playermsg = _ref.playermsg,
            recommend = _ref.recommend,
            sedata = _ref.sedata,
            isAuth = _ref.isAuth,
            showTestInfo = _ref.showTestInfo;

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Video);

        /**
         * videoInfo
         *
         * @member {object}
         */
        this.videoinfo = videoinfo;

        /**
         * playermsg
         *
         * @member {object}
         */
        this.playermsg = playermsg;

        /**
         * 后推荐信息
         *
         * @member {object}
         */
        this.recommends = recommend;

        /**
         * 相关列表数据
         *
         * @member {object}
         */
        this.sedata = sedata;

        /**
         * 是否使用防盗链
         *
         * @member {object}
         */
        this.isAuth = isAuth || 'auth';

        /**
         * 统计类
         *
         * @member {object}
         */
        this.vStat = new __WEBPACK_IMPORTED_MODULE_8_f_component_video_vStat__["a" /* default */](videoinfo);

        /**
         * 是否为第一次播放 2.0 canplay
         *
         * @member {Boolean}
         */
        this.first_play = true;

        /**
         * 是否为第一次loadstart 2.0 loadstart
         *
         * @member {Boolean}
         */
        this.loadstartfirst = true;

        /**
         * 是否为第一次loadeddatafirst 2.0 loadeddata
         *
         * @member {Boolean}
         */
        this.loadeddatafirst = true;

        /**
         * 上一次时间，为了监测卡顿
         *
         * @member {number}
         */
        this.lastMonitor = 0;

        /**
         * 监测卡顿标志
         *
         * @member {number}
         */
        this.monitorFlag = 1;

        /**
         * 卡顿持续时间
         *
         * @member {number}
         */
        this.stopContinue = 0;

        /**
         * 卡顿次数
         *
         * @member {number}
         */
        this.stopTimes = 0;

        /**
         * 卡顿定时器
         *
         * @member {number}
         */
        this.monitorTimer = null;

        this.volumeValueTimer = null; // 音量提示框消失计时器

        /**
         * 文本提示框消失计时器
         *
         * @member {number}
         */
        this.VideoTextConTimer = null;

        /**
         * app推广定时器
         *
         * @member {number}
         */
        this.appTimer = null;

        /**
         * 是否全屏
         *
         * @member {Boolean}
         */
        this.isfull = false;

        /**
         * 第一次下载结束
         *
         * @member {Boolean}
         */
        this.end = true;

        /**
         * 点击播放 定时器
         *
         * @member {number}
         */
        this.conClickTimer == null;

        /**
         * 当前播放的时间
         *
         * @member {number}
         */
        this.currentTime = 0;

        /**
         * seek 次数
         */
        this.seekTime = 0;

        /**
         * mse模块
         */
        this.MSE = __WEBPACK_IMPORTED_MODULE_13_f_component_mse__["a" /* default */];

        /**
         * 是否显示mse测试信息
         */
        this.showTestInfo = showTestInfo;

        this.init();
    }

    /**
     * 初始化
     *
     */


    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Video, [{
        key: 'init',
        value: function init() {
            /**
             * 发送vv统计
             */
            this.vStat.sendMedia('vv');

            /**
             * 采样标识统计
             */
            this.vStat.sendVplayer('100000');

            this.initLayout();
            this.initCompontent();
            this.initEvent();
        }

        /**
         * 初始化布局
         *
         */

    }, {
        key: 'initLayout',
        value: function initLayout() {
            // this.el = document.createElement('div');
            // this.el.classList.add('c-video');
            // 播放器整体
            this.container = document.getElementById('playercontainer');
            this.videobox = document.getElementsByClassName('videobox')[0];
            this.player = document.getElementById('js_video_container');
        }

        /**
         * 初始化布局
         *
         */

    }, {
        key: 'initCompontent',
        value: function initCompontent() {
            var self = this;

            var __gid = window.gid;

            // 请求视频播放地址
            var _params = {
                container: this.container,
                sedata: this.sedata,
                videoinfo: this.videoinfo,
                recommend: this.recommends
            };

            var Mse = this.MSE;

            var playermsg = this.playermsg;

            var src = playermsg.gqSrc || playermsg.bqSrc;

            var authUrl = self.isAuth == 'auth' ? src + '?' + Object(__WEBPACK_IMPORTED_MODULE_12_f_component_video_auth__["a" /* default */])({ videoinfo: videoinfo, __gid: __gid, version: __WEBPACK_IMPORTED_MODULE_9_version__["a" /* default */] }) : src;

            this.mp4Data = playermsg;
            // this.updateSrcVideoUrl(authUrl);

            // video
            this.core = new __WEBPACK_IMPORTED_MODULE_2__modules_core___["a" /* default */]({
                src: src
                // poster: playermsg.videoLargePoster,
            });

            this.gqMse = new Mse({
                video: this.core.el,
                mp4Url: src,
                authUrl: authUrl,
                segmentSize: 1000,
                showTestInfo: this.showTestInfo
            });

            this.bqMse = null;

            this.gqMse.init();

            this.mse = this.gqMse;

            this.control = new __WEBPACK_IMPORTED_MODULE_3__modules_recodeControl___["a" /* default */](_params);

            this.title = new __WEBPACK_IMPORTED_MODULE_4__modules_title___["a" /* default */]({ title: this.videoinfo.name });

            this.list = new __WEBPACK_IMPORTED_MODULE_5__modules_list___["a" /* default */](_params);

            this.recommend = new __WEBPACK_IMPORTED_MODULE_6__modules_recommend___["a" /* default */](_params);

            this.error = new __WEBPACK_IMPORTED_MODULE_7__modules_error__["a" /* default */]();

            this.core.renderTo(this.player); // 将播放器放置到播放器的容器中

            // this.playButton.renderTo(this.el);
            this.control.renderTo(this.videobox);
            // this.recommend.renderTo(this.container);
            this.error.renderTo(this.container);

            this.title.renderTo(this.container);
            // this.list.renderTo(this.container);
        }

        /**
         * 渲染dom
         *
         * @param {HTMLELEMENT} parentNode
         * @memberof Video
         */

    }, {
        key: 'renderTo',
        value: function renderTo(parentNode) {
            parentNode.appendChild(this.el);
        }

        /**
         * 自定义事件列表
         * begin 每个视频开始播放时 一般用来发cv统计
         * ended 视频播放结束时
         * pause 视频暂停
         * play 视频播放
         * switch 视频切换
         * init 初始化视频 主要用于发vv统计
         */

    }, {
        key: 'initEvent',
        value: function initEvent() {
            var core = this.core;
            var control = this.control;
            // let recommend = this.recommend;
            var title = this.title;
            // let list = this.list;
            var error = this.error;
            var self = this;
            var initvolume = pcVideoUtil.playerGetCookie('videoVolume') || 0.5;

            core.on('timeupdate', function (e) {
                // console.log(self.first)
                var currentTime = core.getCurrentTime();
                var bufferedTime = core.getBuffered();
                var duration = core.getDuration();
                var video = core.el;
                var start = void 0;
                var end = void 0;
                var seekInfo = void 0;

                if (isNaN(duration)) {
                    duration = 0;
                }

                /** 视频资源下载完成 */
                if (self.end == true && bufferedTime == duration && duration != 0) {
                    self.vStat.sendVplayer(307000);
                    self.end = false;
                }

                control.setCurrentTime(currentTime);
                control.setTotalTime(duration);

                /** 更新进度条 */
                if (duration != 0) {
                    control.setCurrentProgress(currentTime / duration);
                    control.setBufferProgress(bufferedTime / duration);
                }

                if (video.lastSeekTime !== video.currentTime) {
                    for (var i = 0; i < video.buffered.length; i++) {
                        start = video.buffered.start(i);
                        end = video.buffered.end(i);
                        // self.mse.downloadObj.showTestInfo && console.log(`${duration}===========${video.currentTime}`);
                        if (duration - video.currentTime < 0.5) {
                            // self.mse.mp4box.flush();
                            self.mse.downloadObj.showTestInfo && console.log('\u64AD\u5B8C\u4E86==========>');

                            self.ended(core, self, control);

                            return;
                        }
                        if (video.currentTime >= start && video.currentTime <= end) {
                            // self.mse.downloadObj.showTestInfo &&
                            // console.log(`还差${end - video.currentTime}秒=======>播完`);
                            if (end - video.currentTime < 6) {
                                seekInfo = self.mse.mp4box.seek(end, true);
                                self.mse.downloadObj.getDataInterface(seekInfo.offset);
                                self.mse.downloadObj.showTestInfo && console.log('\u52A0\u8F7D\u65B0\u7684\u6570\u636E\u5757==========>' + seekInfo.offset);
                            }
                        }
                    }
                }

                self.trigger('timeupdate', currentTime);
                self.currentTime = currentTime;
            });

            core.on('play', function () {
                control.changePlayBtnState('play');
                self.trigger('play');
            });

            core.on('loadstart', function () {
                // 发送统计
                // console.log('loadstart');
                /** 开始加载 */
                if (self.loadstartfirst == true) {
                    self.vStat.sendVplayer(208000);
                    self.loadstartfirst = false;
                }

                clearInterval(self.timerhehe);
                var time = 0;

                // 超过10秒报error
                self.timerhehe = setInterval(function () {
                    time++;
                    if (time >= 10) {
                        self.trigger('error', '9', core.el.currentTime);
                        clearInterval(self.timerhehe);
                    }
                }, 1000);
            });

            /** 获取资源长度 */
            core.on('loadedmetadata', function () {
                // console.log('loadedmetadata');
                core.setVolume(initvolume);
                control.setCurrentVolume(initvolume);
                control.setVolumeWarn(initvolume);

                self.trigger('init');
            });

            core.on('loadeddata', function () {
                /**
                 * loadeddata时取消10秒超时定时器
                 */
                clearInterval(self.timerhehe);
                /**
                 * 首字节响应发送统计
                 */
                if (self.loadeddatafirst == true) {
                    self.vStat.sendVplayer('302000');
                    self.loadeddatafirst = false;
                }
            });

            core.on('canplay', function () {
                // console.log('canplay')
                /**
                 * 首画面呈现，发送统计
                 */
                if (self.first_play == true) {
                    self.showAppPopularize();

                    // 发送首画面呈现统计
                    self.vStat.sendVplayer('303000');
                    // 发送cv统计
                    self.vStat.sendMedia('cv'); // 正片

                    self.trigger('firstPlay');
                    self.first_play = false;
                }
                /**
                 * 判断是否正在切换清晰度，头部请求完成后请求进度条资源。进度条资源请求完成后，播放时视频。
                 */
                if (self.__rateChanging) {
                    var time = self.__currentTime;
                    console.log('play--------test', time);
                    if (time) {
                        // 设置新进度时间
                        core.setCurrentTime(time);
                        console.log('play--------', time);
                        // 获取新进度资源
                        var seekInfo = self.mse.mp4box.seek(time, true);
                        self.mse.downloadObj.seek(seekInfo.offset);
                        core.el.lastSeekTime = time;
                        self.__rateChanging = false;
                    }
                    return;
                }
                console.log('play------canplay');
                self.trigger('canplay');

                // changeVideoRate
            });

            core.on('loadedmetadata', function () {});

            // 视频暂停
            core.on('pause', function () {
                control.changePlayBtnState('pause');
            });

            /**
             * 视频播放完成
             */
            core.on('ended', function () {

                self.ended(core, self, control);
            });

            core.on('error', function (e) {
                console.log('error', core.el.error, 'code', core.el.error.code);

                clearInterval(self.timerhehe);
                self.trigger('error', core.el.error.code, core.el.currentTime);
            });

            core.on('playing', function (e) {
                console.log('playing===============>');
                // self.mse.downloadObj.stopVndDownAuto();
                self.trigger('playing');
            });

            core.on('seeked', function (e) {
                console.log('seeked=================>');
                self.trigger('seeked');
            });

            /**
             * 控制条播放
             */
            control.on('cplay', function () {
                /** 视频播放时发送统计 */
                self.vStat.sendVplayer('401000');
                self.play();
            });

            /**
             * 控制条暂停
             */
            control.on('cpause', function () {
                /** 视频暂停时发送统计 */
                self.vStat.sendVplayer('402000');
                self.pause();
            });

            /**
             * 静音
             */
            control.on('cmute', function () {
                core.setVolume(0.0);
                control.setCurrentVolume(0);
                control.setVolumeWarn(0);
                /** 视频静音时发送统计 */
                self.vStat.sendVplayer('405000');
            });

            /**
             * 取消静音
             */
            control.on('caloud', function () {
                var initVolume = pcVideoUtil.playerGetCookie('videoVolume');
                core.setVolume(initVolume);
                control.setCurrentVolume(initVolume);
                control.setVolumeWarn(initVolume);
            });

            /**
             * 控制条——进度seek
             */
            control.on('cprogress', function (percent) {
                var duration = core.getDuration();
                if (isNaN(duration)) {
                    return;
                }
                if (duration != 0) {
                    control.setCurrentProgress(percent);
                }
                // console.log(percent)
                core.setCurrentTime(duration * percent);

                var video = core.el;
                var start = void 0;
                var end = void 0;
                var seekInfo = void 0;
                if (video.lastSeekTime !== video.currentTime) {
                    for (var i = 0; i < video.buffered.length; i++) {
                        start = video.buffered.start(i);
                        end = video.buffered.end(i);
                        console.log('\u7F13\u51B2\u533A=============>' + start + '------' + end + '=========' + video.currentTime);
                        if (video.currentTime >= start && video.currentTime <= end) {
                            console.log('已缓冲===============>');
                            return;
                        }
                    }
                    /* Chrome fires twice the seeking event with the same value */
                    seekInfo = self.mse.mp4box.seek(video.currentTime, true);
                    self.mse.downloadObj.seek(seekInfo.offset);
                    console.log('\u5F00\u59CB\u4E0B\u8F7D\u65B0\u7684\u90E8\u5206===============>' + seekInfo.offset);
                    video.lastSeekTime = video.currentTime;
                }

                /** 视频seek统计，第一次发403001 */
                self.vStat.sendVplayer('403' + pcVideoUtil.formatNum(++self.seekTime));
            });

            control.on('cpdown', function () {});

            /**
             * 控制条——进度条读管——移动结束
             */
            control.on('cpend', function () {

                var video = core.el;
                var start = void 0;
                var end = void 0;
                var seekInfo = void 0;
                if (video.lastSeekTime !== video.currentTime) {
                    for (var i = 0; i < video.buffered.length; i++) {
                        start = video.buffered.start(i);
                        end = video.buffered.end(i);
                        console.log('\u7F13\u51B2\u533A=============>' + start + '------' + end + '=========' + video.currentTime);
                        if (video.currentTime >= start && video.currentTime <= end) {
                            console.log('已缓冲===============>');
                            return;
                        }
                    }
                    /* Chrome fires twice the seeking event with the same value */
                    seekInfo = self.mse.mp4box.seek(video.currentTime, true);
                    self.mse.downloadObj.seek(seekInfo.offset);
                    console.log('\u5F00\u59CB\u4E0B\u8F7D\u65B0\u7684\u90E8\u5206===============>' + seekInfo.offset);
                    video.lastSeekTime = video.currentTime;
                }
            });

            /**
             * 控制条——进度条读管——移动
             */
            control.on('cpmove', function (percent) {
                var duration = core.getDuration();
                if (isNaN(duration)) {
                    return;
                }
                // console.log(percent)
                control.setCurrentProgress(percent);

                core.setCurrentTime(duration * percent);
            });

            var yinliang = function yinliang(percent) {
                var _class = '';
                // 音量改变设置cookie
                pcVideoUtil.playerSetCookie('videoVolume', percent, {
                    domain: '.ifeng.com',
                    path: '/',
                    expires: 60 * 24 * 360
                });
                // console.log(percent)
                control.setCurrentVolume(percent);
                control.setVolumeWarn(percent);
                core.setVolume(percent);
                control.volumeTipShow();

                if (percent >= 0 && percent <= 0.3) {
                    _class = 'little';
                } else if (percent > 0.3 && percent <= 0.6) {
                    _class = 'middle';
                } else {
                    _class = 'large';
                }

                pcVideoUtil.removeClass(control.mute, 'little');
                pcVideoUtil.removeClass(control.mute, 'middle');
                pcVideoUtil.removeClass(control.mute, 'large');

                if (percent == 0) {
                    $(control.aloud).show();
                    $(control.mute).hide();
                } else {
                    $(control.aloud).hide();
                    $(control.mute).show();
                }

                pcVideoUtil.addClass(control.mute, _class);

                var sendCode = Math.round(percent * 100);

                /** 音量调节统计 例： 80发送080 */
                self.vStat.sendVplayer('406' + pcVideoUtil.formatNum(sendCode));
            };

            /**
             * 控制条进度seek
             */
            control.on('c_v_progress', yinliang);

            /**
             * 控制条移动
             */
            control.on('cvmove', yinliang);

            /**
             * 控制条——进度条时间显示——移动
             */
            control.on('cpseekmove', function (percent) {
                var duration = core.getDuration();

                control.seekTimeShow(); // 显示
                var elW = $(this.el).width();
                // let elL = $(this.el).offset().left;

                var seekW = $(this.seekTimeAll).width();
                // let seekL = $(this.seekTimeAll).offset().left;

                var bi = seekW / 2 / elW;
                var oo = null;
                if (percent > bi && percent < 1 - bi) {
                    oo = percent - seekW / (2 * elW);
                } else if (percent < bi) {
                    oo = 0;
                } else if (percent > 1 - bi) {
                    oo = 1 - bi - seekW / (2 * elW);
                }

                control.setSeekProgress(oo);
                control.setSeekTime(duration * percent);

                if (self.mp4Data.preview.path && percent) {
                    control.showImgPreview(duration * percent, self.mp4Data.preview);
                }
            });

            /**
             * 控制条——进度条时间显示——隐藏
             */
            control.on('cpseekout', function () {
                control.seekTimeHide();
            });

            /**
             * 修改video视频清晰度 - 高清、标清
             */
            control.on('changeVideoRate', function (ele) {
                if (!self.mp4Data.gqSrc || !self.mp4Data.bqSrc) return;

                var time = core.getCurrentTime();
                self.__currentTime = time; // 当前播放时间
                self.__rateChanging = true; // 正在切换画质
                console.log('play--------1', time);

                self.VideoTextConTimer = null;
                var __gid = window.gid;
                var tag = ele.getAttribute('data-tag');
                var src = tag == 'high' ? self.mp4Data.gqSrc : tag == 'middle' ? self.mp4Data.bqSrc : self.mp4Data.gqSrc;
                var authUrl = self.isAuth == 'auth' ? src + '?' + Object(__WEBPACK_IMPORTED_MODULE_12_f_component_video_auth__["a" /* default */])({ videoinfo: videoinfo, __gid: __gid, version: __WEBPACK_IMPORTED_MODULE_9_version__["a" /* default */] }) : src;
                var textstr = tag == 'high' ? '高清' : tag == 'middle' ? '标清' : '高清';
                self.mse.pause();
                // 切换mse对象
                // self.mse = new self.MSE({
                //     video: self.core.el,
                //     mp4Url: src,
                //     authUrl: authUrl,
                //     segmentSize: 1000,
                //     showTestInfo: self.showTestInfo,
                // });

                if (tag == 'middle') {
                    if (!self.bqMse) {
                        self.bqMse = new self.MSE({
                            video: self.core.el,
                            mp4Url: src,
                            authUrl: authUrl,
                            segmentSize: 1000,
                            showTestInfo: self.showTestInfo
                        });
                    }
                    self.mse = self.bqMse;
                    self.mse.reset();
                } else {
                    self.mse = self.gqMse;
                    self.mse.changeRate();
                }

                self.mse.load();

                // console.log(self.mse.mediaSource);

                self.mse.autoplay = true;

                $(ele).addClass('current').siblings().removeClass();
                $('.video_app_QRCode').hide();
                control.videoTextShow();
                control.setVideoTextCon('\u6B63\u5728\u5207\u6362\u5230\u201C' + textstr + '\u201D');
                // core.el.src = src;
                self.updateSrcVideoUrl(authUrl);
                //core.setCurrentTime(time);
                core.play();
                control.setVideoTextCon('\u5DF2\u7ECF\u5207\u6362\u5230\u201C' + textstr + '\u201D');
                control.setVideoRateTxt(textstr);
                /** 提示消失 */
                self.VideoTextConTimer = setTimeout(function () {
                    control.videoTextHide();
                }, 800);

                var sendCode = tag == 'high' ? 1 : 0;

                /** 视频清晰度统计 */
                self.vStat.sendVplayer('11200' + sendCode);

                self.trigger('changeVideoRate');
            });

            /**
             * 全屏
             */
            control.on('full', function () {
                control.launchFullscreen(self.container);
                self.fullChange(self.container, 'full');
                title.show();

                self.showTimer = setInterval(function () {
                    title.showTime();
                }, 1000);

                /**
                 * 全屏切换统计
                 */
                self.vStat.sendVplayer('404000');
            });

            /**
             * 退出全屏
             */
            control.on('exit', function () {
                control.exitFullscreen(self.container);
                self.fullChange(self.container, 'exit');
                title.hide();

                self.showTimer = null;

                /**
                 * 全屏切换统计
                 */
                self.vStat.sendVplayer('404000');
            });

            /**
             * esc快捷键 退出
             */
            pcVideoUtil.bind(document, ['webkitfullscreenchange', 'fullscreenchange', 'mozfullscreenchange', 'msfullscreenchange'], function (ev) {
                // 监听全屏、退出全屏切换 为了监测esc触发退出全屏
                if (self.isfull) {
                    self.fullChange(self.container, 'exit');
                    title.hide();
                    self.list.initShow();
                    self.list.hide();
                    control.changeFull('exit');
                    self.showTimer = null;
                }

                if (self.isfull) {
                    self.isfull = false;
                } else {
                    self.isfull = true;
                }
            });

            title.on('close', function () {
                self.trigger('qpClose');
            });

            title.on('open', function () {
                self.trigger('qpOpen');
            });

            /**
             * 全屏时，改变视频尺寸
             */
            title.on('changeVideoSize', function (ele) {
                var _type = ele.getAttribute('data-tag');
                var sendCode = _type == 'half' ? '1' : _type == 'all' ? '2' : '3';
                core.el.style.width = _type == 'half' ? '50%' : '100%';
                core.el.style.height = _type == 'half' ? '50%' : _type == 'all' ? '100%' : 'auto';
                $(ele).addClass('current').siblings().removeClass();
                /**
                 * 发送全屏时画面尺寸统计
                 */
                self.vStat.sendVplayer('40400' + sendCode);
            });

            /**
             * 换节目
             */
            title.on('listshow', function (type) {
                self.list.initShow();
                self.list[type].addClass('current').siblings().removeClass('current');
                // 发送统计
                var sendCode = null;

                /**
                 * 发送点击视频列表按钮统计
                 */
                if (type == 'list') {
                    sendCode = '502000';
                    self.vStat.sendVplayer(sendCode);
                } else if (type == 'share') {
                    /**
                     * 发送点击分享按钮统计
                     */
                    sendCode = '503000';
                    self.vStat.sendVplayer(sendCode);
                }
            });

            /**
             * 分享统计
             */
            self.list.on('sendVplayer', function (_sendcode) {
                // console.log(_sendcode)
                self.vStat.sendVplayer(_sendcode);
            });

            /**
             * 错误提示界面，重播按钮
             */
            error.on('replay', function () {
                error.hide();
                self.recommend.initShow();
                self.recommend.hide();
                self.trigger('replay');
                self.src(self.srcVideoUrl);
                core.load();
                self.show();
                self.play();
            });

            /**
             * 检测卡顿
             */
            self.monitorTimer = setInterval(function () {
                self.kadun(core);
            }, 1000);

            /**
             * 鼠标悬浮在播放器上方
             */
            $('#player').on('mousemove', function (e) {
                control.show();
                if (self.isfull) {
                    title.show();
                }
                clearTimeout(control.hideTimer);
                control.hideTimer = null;
                if (!control.hideTimer && control.playBtnstatus == 'play') {
                    control.hideTimer = setTimeout(function () {
                        control.hide();
                        title.hide();
                    }, 2000);
                }
            });

            /**
             * 点击player区域，添加键盘快捷键
             */
            $('#playercontainer').on('click', function (e) {
                // e.stopPropagation();

                $(document).bind('keydown', function (e) {
                    self.processChange(e);
                });
                // return false;
                // $(box).unbind('mousedown');
            });

            /**
             * 解绑键盘快捷键
             */
            $(document).bind('mousedown', function (e) {
                $(document).unbind('keydown');
            });

            /**
             * 视频点击播放暂停
             */
            $('#player').on('click', function (e) {
                clearTimeout(self.conClickTimer);
                self.conClickTimer = setTimeout(function () {
                    if (core.__isPlayed) {
                        /**
                         * 视频播放统计
                         */
                        self.vStat.sendVplayer('402000');
                        self.pause();
                    } else {
                        /**
                         * 视频暂停统计
                         */
                        self.vStat.sendVplayer('401000');
                        self.play();
                    }
                }, 300);
            });

            /**
             * 双击全屏，退出全屏
             */
            $('#player').on('dblclick', function (e) {
                clearTimeout(self.conClickTimer);

                if (control.fullStatus == 'exit' && !self.isfull) {
                    control.launchFullscreen(self.container);
                    control.changeFull('full');
                    self.fullChange(self.container, 'full');
                    title.show();

                    self.showTimer = setInterval(function () {
                        title.showTime();
                    }, 1000);
                    /**
                     * 发送全屏切换统计
                     */
                    self.vStat.sendVplayer('404000');
                } else if (control.fullStatus == 'full' && self.isfull) {
                    control.exitFullscreen(self.container);
                    control.changeFull('exit');
                    self.fullChange(self.container, 'exit');
                    title.hide();

                    self.showTimer = null;
                    /**
                     * 发送全屏切换统计
                     */
                    self.vStat.sendVplayer('404000');
                }
            });
        }

        /**
         * 缓存视频源地址
         *
         * @param {string} url
         */

    }, {
        key: 'updateSrcVideoUrl',
        value: function updateSrcVideoUrl(url) {
            this.srcVideoUrl = url;
            window.srcVideoUrl = url;
        }

        /**
         * 设置播放视频源地址
         *
         * @param {string} url
         */

    }, {
        key: 'src',
        value: function src(url) {
            core.el.src = url;
        }

        /**
         * 执行keydown的方法
         *
         * @param {object} e
         */

    }, {
        key: 'processChange',
        value: function processChange(e) {
            /**
             * 空格:32
             * 左:37
             * 上:38
             * 右:39
             * 下:40
             */
            if (!e) return;
            var _code = e.keyCode;
            var playBtnstatus = this.control.playBtnstatus;
            switch (_code) {
                /**
                 * 播放、暂停
                 */
                case 32:
                    if (playBtnstatus == 'pause') {
                        this.vStat.sendVplayer('401000');
                        this.play();
                    } else {
                        this.vStat.sendVplayer('402000');
                        this.pause();
                    }
                    e.preventDefault();

                    break;

                /**
                 * 快退
                 */
                case 37:
                    this.changeVideoFucntion('-');
                    e.preventDefault();

                    break;

                /**
                 * 声音加大
                 */
                case 38:
                    this.changeVolumeFucntion('+');
                    e.preventDefault();

                    break;

                /**
                 * 快进
                 */
                case 39:
                    this.changeVideoFucntion('+');
                    e.preventDefault();

                    break;

                /**
                 * 声音减小
                 */
                case 40:
                    this.changeVolumeFucntion('-');
                    e.preventDefault();

                    break;

                default:
                    break;
            }
        }

        /**
         * 全屏、退出全屏时的样式变化
         *
         * @param {HTMLELEMENT} ele
         * @param {string} type 状态
         */

    }, {
        key: 'fullChange',
        value: function fullChange(ele, type) {
            /**
             * 全屏时样式
             */
            if (type == 'full') {
                pcVideoUtil.addClass(ele, 'boxFullScreen');
            } else {
                /**
                 * 退出全屏时样式
                 */
                pcVideoUtil.removeClass(ele, 'boxFullScreen');
            }
            this.trigger('fullChange');
        }

        /**
         * 视频快退快进
         *
         * @param {string} tag 进退方向
         */

    }, {
        key: 'changeVideoFucntion',
        value: function changeVideoFucntion(tag) {
            var core = this.core;
            var duration = core.getDuration();
            var currentTime = null;
            if (isNaN(duration)) {
                duration = 0;
            }
            if (tag == '+') {
                currentTime = core.getCurrentTime() + 8;
                if (currentTime > duration) {
                    currentTime = duration;
                }
            } else {
                currentTime = core.getCurrentTime() - 8;
                if (currentTime < 0) {
                    currentTime = 0;
                }
            }
            core.setCurrentTime(currentTime);
            this.control.setCurrentTime(currentTime);
            this.control.setTotalTime(duration);
            if (duration != 0) {
                this.control.setCurrentProgress(currentTime / duration);
            }
        }

        /**
         * 音量增加减少
         *
         * @param {string} tag 增加减少方向
         */

    }, {
        key: 'changeVolumeFucntion',
        value: function changeVolumeFucntion(tag) {
            var core = this.core;
            var volume = core.getVolume();
            if (tag == '+') {
                volume += 0.1;
                if (volume > 1) {
                    volume = 1;
                }
                $(this.control.aloud).hide();
                $(this.control.mute).show();
            } else {
                volume -= 0.1;
                if (volume < 0) {
                    volume = 0;
                    $(this.control.aloud).show();
                    $(this.control.mute).hide();
                }
            }

            pcVideoUtil.playerSetCookie('videoVolume', volume, {
                domain: '.ifeng.com',
                path: '/',
                expires: 60 * 24 * 360
            });
            this.control.setCurrentVolume(volume);
            this.control.setVolumeWarn(volume);
            core.setVolume(volume);

            this.control.volumeTipShow();

            var _class = volume >= 0 && volume <= 0.3 ? 'little' : volume > 0.3 && volume <= 0.6 ? 'middle' : 'large';
            pcVideoUtil.removeClass(this.control.mute, 'little');
            pcVideoUtil.removeClass(this.control.mute, 'middle');
            pcVideoUtil.removeClass(this.control.mute, 'large');
            // if (percent == 0) {
            //     $(control.aloud).show();
            //     $(control.mute).hide();
            // } else {
            //     $(control.aloud).hide();
            //     $(control.mute).show();
            // }
            pcVideoUtil.addClass(this.control.mute, _class);
        }

        /**
         * 视频左下角 App 流行推广
         *
         * @memberof Video
         */

    }, {
        key: 'showAppPopularize',
        value: function showAppPopularize() {
            // body...
            var _this = this;
            var playtimes = pcVideoUtil.playerGetCookie('playtimes') || 1;
            pcVideoUtil.playerSetCookie('playtimes', ++playtimes, {
                domain: '.ifeng.com',
                path: '/',
                expires: 60 * 24 * 360
            });
            if (playtimes % 3 == 0) {
                $.ajax({
                    url: 'http://v.ifeng.com/flash/data/app/tuig.js',
                    type: 'get',
                    dataType: 'json',
                    success: function success(data) {
                        // var data = { "text": "[APP专享]野外发现红包袱 打开一看众人惊呆", "link": "http://v.ifeng.com/apps/index.shtml#_a_v1", "img": "http://p0.ifengimg.com/a/2016_23/6fb82450ea5e4c5_size14_w110_h110.jpg" };
                        document.getElementById('js_video_text').innerHTML = data.text + '<a id="js_show_code" href="javascript:void(0)">\u4E0B\u8F7D\u5BA2\u6237\u7AEF\u89C2\u770B</a>';

                        // _this.videoTextCon.html(data.text + '<a id="js_show_code" href="javascript:void(0)">下载客户端观看</a>');
                        pcVideoUtil.bind(document.getElementById('js_show_code'), 'click', function (e) {
                            clearTimeout(_this.appTimer);
                            this.appTimer = null;
                            // _this.videoPlay('pause', 'appClick');
                            pcVideoUtil.addClass(document.getElementsByClassName('video_app_QRCode')[0], 'video_app_QRCodeShow');
                        });

                        var appImgDom = document.createElement('img');
                        appImgDom.src = data.img;
                        document.getElementsByClassName('video_app_QRCode')[0].appendChild(appImgDom);

                        // pcVideoUtil.addClass(_this._textshow, 'videoTextShow');
                        _this.control.videoTextShow();
                        _this.appFlag = 1;
                        _this.appTimer = setTimeout(function () {
                            _this.control.videoTextHide();
                            $('.video_app_QRCode').hide();
                            // textBoxHide('click');
                        }, 30000);
                    }
                });
            }
        }

        /**
         * 卡顿测试函数
         *
         * @param {object} core
         */

    }, {
        key: 'kadun',
        value: function kadun(core) {
            // body...
            var _this = this;
            var tag = core.getPaused();

            if (tag) return;
            if (core.getCurrentTime() == 0) return;

            // console.log(tag)
            // console.log('lastMonitor:' + this.lastMonitor);
            // console.log(core.getCurrentTime());

            if (this.lastMonitor == core.getCurrentTime()) {
                if (this.monitorFlag) {
                    _this.vStat.sendVplayer('304' + pcVideoUtil.formatNum(++this.stopTimes)); //缓冲次数
                    // console.log('卡顿次数：' + pcVideoUtil.formatNum(this.stopTimes));
                }
                this.monitorFlag = 0;
                this.stopContinue++;
                console.log('this.stopContinue=====>', this.stopContinue);
                if (this.stopContinue > 5) {
                    // 卡顿时间超过5s，认为播放失败，显示后推荐
                    this.stopContinue = 0;
                    clearInterval(_this.monitorTimer);
                    _this.monitorTimer = null;
                    // videorecommendShow('error');显示后推荐
                }
            } else {
                this.monitorFlag = 1;
                if (this.stopContinue != 0) {
                    // console.log('卡顿持续时间：' + pcVideoUtil.formatNum(this.stopContinue));
                    _this.vStat.sendVplayer('309' + pcVideoUtil.formatNum(this.stopTimes) + pcVideoUtil.formatNum(this.stopContinue)); // 309xxxyyy x：卡的次数 y：卡几秒
                    this.stopContinue = 0;
                }
            }

            this.lastMonitor = core.getCurrentTime();
        }

        /**
         * 重新播放
         */

    }, {
        key: 'replay',
        value: function replay() {
            this.playList = this.originList.slice();
            var src = this.playList.shift();
            var core = this.core;
            core.src(src);
            core.play();
        }

        /**
         * 播放
         */

    }, {
        key: 'play',
        value: function play() {
            var core = this.core;
            core.play();
        }

        /**
         * 暂停播放
         */

    }, {
        key: 'pause',
        value: function pause() {
            var core = this.core;
            core.pause();
            this.trigger('pause');
            // vStat.sendVplayer('402000');
        }

        /**
         * 隐藏组件
         */

    }, {
        key: 'hide',
        value: function hide() {
            var core = this.core;
            core.hide();
            this.control.hideAll();
        }

        /**
         * 显示组件
         */

    }, {
        key: 'show',
        value: function show() {
            var core = this.core;
            core.show();
            this.control.showAll();
        }

        /**
         * 暂停视频播放
         */

    }, {
        key: 'stop',
        value: function stop() {
            var core = this.core;
            core.pause();
            this.control.setTime(0);
        }

        /**
         * 播放下一条视频
         *
         * @param {string} src
         */

    }, {
        key: 'next',
        value: function next(src) {
            var core = this.core;
            core.src(src);
            this.control.reset();
            this.playButton.changeState('pause');
        }

        /**
         * 得到当前播放时间
         *
         * @returns {number} 当前播放时间
         */

    }, {
        key: 'getCurrentTime',
        value: function getCurrentTime() {
            return this.currentTime;
        }

        /**
         * 销毁组件
         */

    }, {
        key: 'destory',
        value: function destory() {
            var core = this.core;
            this.off();
            this.title.destory();
            this.control.destory();
            this.poster.destory();
            this.playButton.destory();
            this.error.destory();
            core.destory();
        }
        /**
         * 播放结束
         */

    }, {
        key: 'ended',
        value: function ended(core, self, control) {

            core.el.currentTime = 0;

            /** 发送播放完毕统计 */
            self.vStat.sendVplayer('305000');

            var _sedataId = control.getInd();
            if (typeof window.sedata == 'undefined' || _sedataId < 0 || _sedataId > sedata.length) {
                self.recommend.initShow();
                core.hide();
                control.hide();
            } else {
                var link = window.sedata[_sedataId].link;

                window.location.href = link;
            }
        }
    }]);

    return Video;
}();

__WEBPACK_IMPORTED_MODULE_10_f_core_event__["a" /* default */].mixTo(Video);
/* unused harmony default export */ var _unused_webpack_default_export = (Video);

/***/ }),

/***/ "eUcP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_css__ = __webpack_require__("O6zL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_ejs__ = __webpack_require__("qO14");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_ejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__main_ejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_f_core_event__ = __webpack_require__("gzOS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_f_core_util_pc__ = __webpack_require__("QZmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_f_core_util_pc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_f_core_util_pc__);


/**
 * Recommend module.
 * @module video/Recommend
 */





var pcVideoUtil = new __WEBPACK_IMPORTED_MODULE_5_f_core_util_pc___default.a();

/**
 * 推荐组件
 */

var Recommend = function () {
    /**
     * Creates an instance of Recommend.
     * @param {object} recommend 推荐数据
     * @param {object} container 容器
     */
    function Recommend(_ref) {
        var recommend = _ref.recommend,
            container = _ref.container;

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Recommend);

        this.data = recommend || [];
        this.container = container;
        this.state = false;
    }

    /**
     * 初始化快捷方法
     */


    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Recommend, [{
        key: 'initShow',
        value: function initShow() {
            this.data = window.recommend || this.data;
            if (!this.state) {
                this.state = true;
                this.init();
                this.renderTo(this.container);
            }

            this.show();
        }

        /**
         * 初始化
         */

    }, {
        key: 'init',
        value: function init() {
            this.initDom();
            this.initCompontent();
            this.initEvent();
        }

        /**
         * 初始化dom
         */

    }, {
        key: 'initDom',
        value: function initDom() {
            this.el = $(__WEBPACK_IMPORTED_MODULE_3__main_ejs___default()())[0];
            this.list = $(this.el).find('#js_recommend_list');

            this.js_recommend_pageR = $(this.el).find('#js_recommend_pageR');
            this.js_recommend_pageL = $(this.el).find('#js_recommend_pageL');
            // this.title = $(this.el).find('#js_siderTop_title');
            // this.baifen = $(this.el).find('#js_siderTop_scale');
            // this.control = $(this.el).find('.siderTopControl');
            // this.time = $(this.el).find('#js_siderTop_time');
        }

        /**
         * 初始化component
         */

    }, {
        key: 'initCompontent',
        value: function initCompontent() {
            var recommendHtml = '';
            for (var i = 0, iLen = this.data.length; i < iLen; i++) {
                var item = this.data[i];
                if (i % 2 == 0) recommendHtml += '<li>';
                recommendHtml += '<div>\n                    <a href="' + item.pageUrl + '" target="_self">\n                        <img src="' + item.stills + '" />\n                        <i></i>\n                        <span class="time">' + pcVideoUtil.formatTime(item.duration) + '</span>\n                        <em>' + item.title + '</em>\n                    </a>\n                </div>\n            ';
                if (i % 2 == 1) recommendHtml += '</li>';
            }
            this.list.html(recommendHtml);
        }

        /**
         * 初始化自定义事件
         */

    }, {
        key: 'initEvent',
        value: function initEvent() {
            var _this = this;
            this.js_recommend_pageR.on('click', function () {
                _this.recommendRun('right');
            });
            this.js_recommend_pageL.on('click', function () {
                _this.recommendRun('left');
            });
        }

        /**
         * 推荐滚动
         *
         * @param {string} type 方向
         */

    }, {
        key: 'recommendRun',
        value: function recommendRun(type) {
            var containerRight = document.getElementsByClassName('containerRight')[0];
            var containerLeft = document.getElementsByClassName('containerLeft')[0];

            /**
             * 后推荐宽度
             */
            var recommendWidth = parseInt(pcVideoUtil.getStyle(document.getElementById('js_recommend_container')).width);
            var recommendMax = 180 * pcVideoUtil.delNodes(document.getElementById('js_recommend_list')).childNodes.length;

            var change = type == 'right' ? -1 : 1;
            var recommendList = document.getElementById('js_recommend_list');
            var _curLeft = parseInt(pcVideoUtil.getStyle(recommendList).left);
            var changeLeft = _curLeft + change * recommendWidth;

            if (type == 'left') {
                if (_curLeft == 0) return;
                changeLeft = Math.min(changeLeft, 0);
            } else if (type == 'right') {
                changeLeft = Math.max(changeLeft, -(recommendMax - recommendWidth));
            }

            recommendList.style.left = changeLeft + 'px';

            pcVideoUtil.addClass(containerRight, 'containerHover');
            pcVideoUtil.addClass(containerLeft, 'containerHover');

            if (changeLeft == 0) {
                pcVideoUtil.removeClass(containerLeft, 'containerHover');
            } else if (changeLeft == -(recommendMax - recommendWidth)) {
                pcVideoUtil.removeClass(containerRight, 'containerHover');
            }
        }

        /**
         * 隐藏组件
         */

    }, {
        key: 'hide',
        value: function hide() {
            this.el.style.display = 'none';
        }

        /**
         * 显示组件
         */

    }, {
        key: 'show',
        value: function show() {
            this.el.style.display = 'block';
        }

        /**
         * 渲染组件
         * @param {HTMLELEMENT} parentNode
         */

    }, {
        key: 'renderTo',
        value: function renderTo(parentNode) {
            parentNode.appendChild(this.el);
        }

        /**
         * 销毁组件
         */

    }, {
        key: 'destory',
        value: function destory() {
            this.el.parentNode.removeChild(this.el);
        }
    }]);

    return Recommend;
}();

__WEBPACK_IMPORTED_MODULE_4_f_core_event__["a" /* default */].mixTo(Recommend);
/* harmony default export */ __webpack_exports__["a"] = (Recommend);

/***/ }),

/***/ "evD5":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("77Pl");
var IE8_DOM_DEFINE = __webpack_require__("SfB7");
var toPrimitive = __webpack_require__("MmMw");
var dP = Object.defineProperty;

exports.f = __webpack_require__("+E39") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "f9Jw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fBQ2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__("evD5");
var createDesc = __webpack_require__("X8DO");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ "fJUb":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("77Pl");
var isObject = __webpack_require__("EqjI");
var newPromiseCapability = __webpack_require__("qARP");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "fZjL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("jFbC"), __esModule: true };

/***/ }),

/***/ "fkB2":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("UuGF");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "gzOS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

// Events
// -----------------
// Thanks to:
//  - https://github.com/documentcloud/backbone/blob/master/backbone.js
//  - https://github.com/joyent/node/blob/master/lib/events.js


// Regular expression used to split event strings
var eventSplitter = /\s+/;

// A module that can be mixed in to *any object* in order to provide it
// with custom events. You may bind with `on` or remove with `off` callback
// functions to an event; `trigger`-ing an event fires all callbacks in
// succession.
//
//     var object = new Events();
//     object.on('expand', function(){ alert('expanded'); });
//     object.trigger('expand');
//
function Events() {}

// Bind one or more space separated events, `events`, to a `callback`
// function. Passing `"all"` will bind the callback to all events fired.
Events.prototype.on = function (events, callback, context) {
    var cache, event, list, namespace, a;
    if (!callback) return this;

    cache = this.__events || (this.__events = {});
    events = events.split(eventSplitter);

    while (event = events.shift()) {
        a = event.split(':');
        event = a[0];
        namespace = a[1] || '';
        list = cache[event] || (cache[event] = []);
        list.push(callback, context, namespace);
    }

    return this;
};

Events.prototype.once = function (events, callback, context) {
    var that = this;
    var cb = function cb() {
        that.off(events, cb);
        callback.apply(this, arguments);
    };
    this.on(events, cb, context);
};

// Remove one or many callbacks. If `context` is null, removes all callbacks
// with that function. If `callback` is null, removes all callbacks for the
// event. If `events` is null, removes all bound callbacks for all events.
Events.prototype.off = function (events, callback, context) {
    var cache, event, list, i, namespace, a;

    // No events, or removing *all* events.
    if (!(cache = this.__events)) return this;
    if (!(events || callback || context)) {
        delete this.__events;
        return this;
    }

    events = events ? events.split(eventSplitter) : keys(cache);

    // Loop through the callback list, splicing where appropriate.
    while (event = events.shift()) {
        a = event.split(':');
        namespace = a[1] || '';
        event = a[0];
        list = cache[event];
        if (!list) continue;

        if (!(callback || context || namespace !== '')) {
            delete cache[event];
            continue;
        }

        for (i = list.length - 3; i >= 0; i -= 3) {
            if (!(callback && list[i] !== callback || context && list[i + 1] !== context || namespace !== '' && list[i + 2] !== namespace)) {
                list.splice(i, 3);
            }
        }
    }

    return this;
};

// Trigger one or many events, firing all bound callbacks. Callbacks are
// passed the same arguments as `trigger` is, apart from the event name
// (unless you're listening on `"all"`, which will cause your callback to
// receive the true name of the event as the first argument).
Events.prototype.trigger = function (events) {
    var cache,
        event,
        all,
        list,
        i,
        len,
        rest = [],
        args,
        returned = true;
    if (!(cache = this.__events)) return this;

    events = events.split(eventSplitter);

    // Fill up `rest` with the callback arguments.  Since we're only copying
    // the tail of `arguments`, a loop is much faster than Array#slice.
    for (i = 1, len = arguments.length; i < len; i++) {
        rest[i - 1] = arguments[i];
    }

    // For each event, walk through the list of callbacks twice, first to
    // trigger the event, then to trigger any `"all"` callbacks.
    while (event = events.shift()) {
        // Copy callback lists to prevent modification.
        if (all = cache.all) all = all.slice();
        if (list = cache[event]) list = list.slice();

        // Execute event callbacks.
        returned = triggerEvents(list, rest, this) && returned;

        // Execute "all" callbacks.
        returned = triggerEvents(all, [event].concat(rest), this) && returned;
    }

    return returned;
};

Events.prototype.emit = Events.prototype.trigger;

// Mix `Events` to object instance or Class function.
Events.mixTo = function (receiver) {
    receiver = isFunction(receiver) ? receiver.prototype : receiver;
    var proto = Events.prototype;

    for (var p in proto) {
        if (proto.hasOwnProperty(p)) {
            receiver[p] = proto[p];
        }
    }
};

// Helpers
// -------

var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default.a;

if (!keys) {
    keys = function keys(o) {
        var result = [];

        for (var name in o) {
            if (o.hasOwnProperty(name)) {
                result.push(name);
            }
        }
        return result;
    };
}

// Execute callbacks
function triggerEvents(list, args, context) {
    var pass = true;

    if (list) {
        var i = 0,
            l = list.length,
            a1 = args[0],
            a2 = args[1],
            a3 = args[2];
        // call is faster than apply, optimize less than 3 argu
        // http://blog.csdn.net/zhengyinhui100/article/details/7837127
        switch (args.length) {
            case 0:
                for (; i < l; i += 3) {
                    pass = list[i].call(list[i + 1] || context) !== false && pass;
                }
                break;
            case 1:
                for (; i < l; i += 3) {
                    pass = list[i].call(list[i + 1] || context, a1) !== false && pass;
                }
                break;
            case 2:
                for (; i < l; i += 3) {
                    pass = list[i].call(list[i + 1] || context, a1, a2) !== false && pass;
                }
                break;
            case 3:
                for (; i < l; i += 3) {
                    pass = list[i].call(list[i + 1] || context, a1, a2, a3) !== false && pass;
                }
                break;
            default:
                for (; i < l; i += 3) {
                    pass = list[i].apply(list[i + 1] || context, args) !== false && pass;
                }
                break;
        }
    }
    // trigger will return false if one of the callbacks return false
    return pass;
}

function isFunction(func) {
    return Object.prototype.toString.call(func) === '[object Function]';
}

/* harmony default export */ __webpack_exports__["a"] = (Events);

/***/ }),

/***/ "h65t":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("UuGF");
var defined = __webpack_require__("52gC");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "hJx8":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("evD5");
var createDesc = __webpack_require__("X8DO");
module.exports = __webpack_require__("+E39") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "i4xY":
/***/ (function(module, exports) {


if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"videosiderTop\" id=\"js_siderTop\">\n    <div class=\"videosiderTopBg\"></div>\n    <div class=\"videosiderTopContent\" id=\"js_siderTop_control\">\n        <div class=\"siderTopTitle\" id=\"js_siderTop_title\"></div>\n        <div class=\"siderTopScale\" id=\"js_siderTop_scale\">\n            <ul class=\"js_siderScale_trigger\">\n                <li data-tag=\"half\">50%</li>\n                <li class=\"current\" data-tag=\"all\">100%</li>\n                <li data-tag=\"full\">满屏</li>\n            </ul>\n        </div>\n        <div class=\"siderTopControl\">\n            <ul class=\"js_siderControl_trigger\">\n                <li class=\"btn1\" data-tag=\"menu\" id=\"js_siderTop_menu\"><span>换节目</span></li>\n                <li class=\"btn2\" data-tag=\"down\" id=\"js_siderTop_down\"><span>下载</span></li>\n                <li class=\"btn3\" data-tag=\"share\" id=\"js_siderTop_share\"><span>分享</span></li>\n                <li class=\"btn6\" data-tag=\"switch\" id=\"js_siderTop_switch\">\n                    <a class=\"v_switch v_switchon\" href=\"javascript:;\">\n                        <span><em>弹幕</em></span>\n                    </a>\n                </li>\n                <li class=\"btn5\" id=\"js_siderTop_time\"></li>\n            </ul>\n        </div>\n    </div>\n</div>")
  }
  return __output.join("");

}

/***/ }),

/***/ "jFbC":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Cdx3");
module.exports = __webpack_require__("FeBl").Object.keys;


/***/ }),

/***/ "jKW+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__("kM2E");
var newPromiseCapability = __webpack_require__("qARP");
var perform = __webpack_require__("dNDb");

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),

/***/ "kM2E":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7KvD");
var core = __webpack_require__("FeBl");
var ctx = __webpack_require__("+ZMJ");
var hide = __webpack_require__("hJx8");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "knuC":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "lOnJ":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "lktj":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("Ibhu");
var enumBugKeys = __webpack_require__("xnc9");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "mClu":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("kM2E");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("+E39"), 'Object', { defineProperty: __webpack_require__("evD5").f });


/***/ }),

/***/ "mDxz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import md5 from 'blueimp-md5';
var md5 = window.hex_md5;
var salt = 'ifeng';
/**
 * 防盗链sign计算函数
 * @param {Object} info
 * @param {string} info.gid - 视频Id
 * @param {string} info.pver - 播放器版本
 * @param {string} info.sver - APP版本
 * @param {string} info.tm - 时间戳
 * @param {string} info.uid - 用户id
 * @param {string} info.vid - 视频请求唯一ID
 * @return {object}
 */
var genSign = function genSign(_ref) {
  var _ref$gid = _ref.gid,
      gid = _ref$gid === undefined ? '' : _ref$gid,
      _ref$pver = _ref.pver,
      pver = _ref$pver === undefined ? '' : _ref$pver,
      _ref$sver = _ref.sver,
      sver = _ref$sver === undefined ? '' : _ref$sver,
      _ref$tm = _ref.tm,
      tm = _ref$tm === undefined ? Date.now() : _ref$tm,
      _ref$uid = _ref.uid,
      uid = _ref$uid === undefined ? '' : _ref$uid,
      _ref$vid = _ref.vid,
      vid = _ref$vid === undefined ? '' : _ref$vid;

  var paramArr = [];
  paramArr.push('gid=' + gid);
  paramArr.push('pver=' + pver);
  paramArr.push('sver=' + sver);
  paramArr.push('tm=' + tm);
  paramArr.push('uid=' + uid);
  paramArr.push('vid=' + vid);

  var md5String = paramArr.join('&') + salt;

  var sign = md5(md5String);

  return { sign: sign, tm: tm };
};

/* harmony default export */ __webpack_exports__["a"] = (genSign);

/***/ }),

/***/ "mT8d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "msXi":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("77Pl");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "mvHQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("qkKv"), __esModule: true };

/***/ }),

/***/ "oN26":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ('vHTML5Player_v2.0.0');

/***/ }),

/***/ "obC0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "or9+":
/***/ (function(module, exports) {


if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"videoControl\" id=\"js_video_control\">\n    <div class=\"videoControlBg\"></div>\n    <!-- 提示框 -->\n    <div class=\"videoText\">\n        <div class=\"videoTextCon\" id=\"js_video_text\"></div> <i class=\"js_closetext_trigger\"></i>\n        <div class=\"video_app_QRCode\">\n            <p>下载客户端观看</p>\n            <i class=\"js_closetext_trigger\"></i>\n        </div>\n    </div> <span class=\"videoHoverTime\" id=\"js_hover_time\">\n    <div><span>00:00</span></div></span>\n    <!--进度条-->\n    <div class=\"videoProgress js_progress_trigger\" data-tag=\"progress\">\n        <div class=\"videoBufferBg js_progress_trigger\" data-tag=\"buffered\"></div>\n        <div class=\"videoProgressBar js_progress_trigger\" data-tag=\"progressbar\" id=\"progressbar\"></div>\n        <div class=\"videoProgressIcon js_progress_trigger\" data-tag=\"progresicon\"></div>\n        <ul class=\"anchors js_video_anchors\"></ul>\n    </div>\n    <!--功能条-->\n    <div class=\"videoBtns\">\n        <div class=\"videoBtnsLeft\">\n            <div class=\"btn1 js_videobtn_trigger\" data-tag=\"play\" style=\"display:block;\"><span>播放</span>\n            </div>\n            <div class=\"btn2 js_videobtn_trigger\" data-tag=\"pause\" style=\"display:none\"><span>暂停</span>\n            </div>\n            <div class=\"btn3 js_videobtn_trigger\" data-tag=\"next\">\n                <div class=\"showNext\" id=\"js_videobtn_showNext\">\n                    <div class=\"nextVideoLeft\">\n                        <div id=\"js_videonext_img\"></div>\n                        <div class=\"nextVideoTime\" id=\"js_videonext_time\"></div>\n                    </div>\n                    <div class=\"nextVideoRight\">\n                        <p class=\"title\">下一个</p>\n                        <p class=\"content\" id=\"js_videonext_abstract\"></p>\n                    </div>\n                </div>\n            </div>\n            <div class=\"btn4\">\n                <div class=\"playTime\" id=\"js_video_ptime\">00:00</div>\n                <div class=\"split\">/</div>\n                <div class=\"totalTime\" id=\"js_video_ttime\">00:00</div>\n            </div>\n        </div>\n        <div class=\"videoBtnsRight\">\n            <div class=\"btn1 js_videobtn_trigger\" data-tag=\"fullscreen\"><span>全屏</span>\n            </div>\n            <div class=\"btn2 js_videobtn_trigger\" data-tag=\"adaptscreen\" style=\"display:none\"><span>退出全屏</span>\n            </div>\n            <div class=\"btn3 js_videobtn_trigger\" data-tag=\"rate\"> <span id=\"js_video_rateTxt\">高清</span>\n                <ul class=\"js_videorate_trigger\">\n                    <li data-tag=\"high\">高清</li>\n                    <li data-tag=\"middle\">标清</li>\n                    <li class=\"current\" data-tag=\"auto\">自动</li>\n                </ul>\n            </div>\n            <div class=\"btn4 js_volume_trigger\" data-tag=\"volume\" id=\"js_video_volume\"> <span class=\"volumeTip\" id=\"js_volume_tip\">50%</span>\n                <span class=\"volumeFullTip\" id=\"js_volume_fulltip\">\n                                            100% （按\n                                            <span style=\"color:red\">↑</span> 继续提升音量）\n                </span>\n                <div class=\"volumeProgress\">\n                    <div class=\"volumeProgressBar js_volume_trigger\" data-tag=\"volumebar\"></div>\n                    <div class=\"volumeProgressIcon js_volume_trigger\" data-tag=\"volumeicon\"></div>\n                </div>\n            </div>\n            <div class=\"btn5 js_videobtn_trigger middle\" data-tag=\"mute\"><span>静音</span>\n            </div>\n            <div class=\"btn6 js_videobtn_trigger\" data-tag=\"aloud\" style=\"display:none\"><span>声音</span>\n            </div>\n        </div>\n    </div>\n    <!-- 角标广告UI -->\n    <div class=\"connerAd connerAdHide\" id=\"js_conner_ad\"> <i class=\"connerClose\" id=\"js_conner_close\"></i>\n    </div>\n</div>\n")
  }
  return __output.join("");

}

/***/ }),

/***/ "pYFB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return nativeRTCSessionDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PeerConnection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return nativeRTCIceCandidate; });
var nativeRTCSessionDescription = window.RTCSessionDescription || window.mozRTCSessionDescription || window.webkitRTCSessionDescription;

var PeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection || window.PeerConnection || window.webkitPeerConnection00;

var nativeRTCIceCandidate = window.RTCIceCandidate || window.mozRTCIceCandidate || window.webkitRTCSessionDescription;



/***/ }),

/***/ "qARP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__("lOnJ");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "qO14":
/***/ (function(module, exports) {


if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"videorecommend\" id=\"js_video_recommend\">\n    <div class=\"videoRecommendLayout\">\n        <div class=\"videoRecommendPosition\">\n            <div class=\"containerLeft\">\n                <div class=\"recommendLeft disabled\" id=\"js_recommend_pageL\"></div>\n            </div>\n            <div class=\"containerRight\">\n                <div class=\"recommendRight\" id=\"js_recommend_pageR\"></div>\n            </div>\n            <div class=\"containerList\" id=\"js_recommend_container\">\n                <ul id=\"js_recommend_list\">\n                </ul>\n            </div>\n        </div>\n    </div>\n</div>")
  }
  return __output.join("");

}

/***/ }),

/***/ "qio6":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("evD5");
var anObject = __webpack_require__("77Pl");
var getKeys = __webpack_require__("lktj");

module.exports = __webpack_require__("+E39") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "qkKv":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("FeBl");
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ "qyJz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__("+ZMJ");
var $export = __webpack_require__("kM2E");
var toObject = __webpack_require__("sB3e");
var call = __webpack_require__("msXi");
var isArrayIter = __webpack_require__("Mhyx");
var toLength = __webpack_require__("QRG4");
var createProperty = __webpack_require__("fBQ2");
var getIterFn = __webpack_require__("3fs2");

$export($export.S + $export.F * !__webpack_require__("dY0y")(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ "rahC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_core___ = __webpack_require__("3kBm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_recodeControl___ = __webpack_require__("QUAj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_title___ = __webpack_require__("+g5I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_list___ = __webpack_require__("BYgZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_recommend___ = __webpack_require__("eUcP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_error__ = __webpack_require__("UM2m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_f_component_video_vStat__ = __webpack_require__("NBD/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_version__ = __webpack_require__("oN26");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_f_core_event__ = __webpack_require__("gzOS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_f_core_util_pc__ = __webpack_require__("QZmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_f_core_util_pc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_f_core_util_pc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_f_component_video_auth__ = __webpack_require__("63mF");


/**
 * video module.
 * @module video
 */










// const vStat = new Stat(videoinfo);


var pcVideoUtil = new __WEBPACK_IMPORTED_MODULE_11_f_core_util_pc___default.a();


/**
 * Video 业务核心
 */

var Video = function () {
    /**
     * Creates an instance of Video.
     * @param {Object} obj - An object.
     * @param {Object} obj.videoinfo - 视频相关信息.
     * @param {Object} obj.playermsg - 视频地址.
     * @param {Object} obj.recommend - 后推荐数据.
     * @param {Object} obj.sedata - 相关列表数据.
     * @memberof Video
     */
    function Video(_ref) {
        var videoinfo = _ref.videoinfo,
            playermsg = _ref.playermsg,
            recommend = _ref.recommend,
            sedata = _ref.sedata,
            isAuth = _ref.isAuth;

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Video);

        /**
         * videoInfo
         *
         * @member {object}
         */
        this.videoinfo = videoinfo;

        /**
         * playermsg
         *
         * @member {object}
         */
        this.playermsg = playermsg;

        /**
         * 后推荐信息
         *
         * @member {object}
         */
        this.recommends = recommend;

        /**
         * 相关列表数据
         *
         * @member {object}
         */
        this.sedata = sedata;

        /**
         * 是否使用防盗链
         *
         * @member {object}
         */
        this.isAuth = isAuth || 'auth';

        /**
         * 统计类
         *
         * @member {object}
         */
        this.vStat = new __WEBPACK_IMPORTED_MODULE_8_f_component_video_vStat__["a" /* default */](videoinfo);

        /**
         * 是否为第一次播放 2.0 canplay
         *
         * @member {Boolean}
         */
        this.first_play = true;

        /**
         * 是否为第一次loadstart 2.0 loadstart
         *
         * @member {Boolean}
         */
        this.loadstartfirst = true;

        /**
         * 是否为第一次loadeddatafirst 2.0 loadeddata
         *
         * @member {Boolean}
         */
        this.loadeddatafirst = true;

        /**
         * 上一次时间，为了监测卡顿
         *
         * @member {number}
         */
        this.lastMonitor = 0;

        /**
         * 监测卡顿标志
         *
         * @member {number}
         */
        this.monitorFlag = 1;

        /**
         * 卡顿持续时间
         *
         * @member {number}
         */
        this.stopContinue = 0;

        /**
         * 卡顿次数
         *
         * @member {number}
         */
        this.stopTimes = 0;

        /**
         * 卡顿定时器
         *
         * @member {number}
         */
        this.monitorTimer = null;

        this.volumeValueTimer = null; // 音量提示框消失计时器

        /**
         * 文本提示框消失计时器
         *
         * @member {number}
         */
        this.VideoTextConTimer = null;

        /**
         * app推广定时器
         *
         * @member {number}
         */
        this.appTimer = null;

        /**
         * 是否全屏
         *
         * @member {Boolean}
         */
        this.isfull = false;

        /**
         * 第一次下载结束
         *
         * @member {Boolean}
         */
        this.end = true;

        /**
         * 点击播放 定时器
         *
         * @member {number}
         */
        this.conClickTimer == null;

        /**
         * 当前播放的时间
         *
         * @member {number}
         */
        this.currentTime = 0;

        /**
         * seek 次数
         */
        this.seekTime = 0;

        this.init();
    }

    /**
     * 初始化
     *
     */


    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Video, [{
        key: 'init',
        value: function init() {
            /**
             * 发送vv统计
             */
            this.vStat.sendMedia('vv');

            /**
             * 采样标识统计
             */
            this.vStat.sendVplayer('100000');

            this.initLayout();
            this.initCompontent();
            this.initEvent();
        }

        /**
         * 初始化布局
         *
         */

    }, {
        key: 'initLayout',
        value: function initLayout() {
            // this.el = document.createElement('div');
            // this.el.classList.add('c-video');
            // 播放器整体
            this.container = document.getElementById('playercontainer');
            this.videobox = document.getElementsByClassName('videobox')[0];
            this.player = document.getElementById('js_video_container');
        }

        /**
         * 初始化布局
         *
         */

    }, {
        key: 'initCompontent',
        value: function initCompontent() {
            // 请求视频播放地址
            var _params = {
                container: this.container,
                sedata: this.sedata,
                videoinfo: this.videoinfo,
                recommend: this.recommends
            };

            var playermsg = this.playermsg;

            var src = playermsg.gqSrc || playermsg.bqSrc;
            this.mp4Data = playermsg;
            this.updateSrcVideoUrl(src);

            // video
            this.core = new __WEBPACK_IMPORTED_MODULE_2__modules_core___["a" /* default */]({
                src: src,
                poster: playermsg.videoLargePoster
            });

            // this.core = Promise.resolve(this.__core);

            this.control = new __WEBPACK_IMPORTED_MODULE_3__modules_recodeControl___["a" /* default */](_params);

            this.title = new __WEBPACK_IMPORTED_MODULE_4__modules_title___["a" /* default */]({ title: this.videoinfo.name });

            this.list = new __WEBPACK_IMPORTED_MODULE_5__modules_list___["a" /* default */](_params);

            this.recommend = new __WEBPACK_IMPORTED_MODULE_6__modules_recommend___["a" /* default */](_params);

            this.error = new __WEBPACK_IMPORTED_MODULE_7__modules_error__["a" /* default */]();

            this.core.renderTo(this.player); // 将播放器放置到播放器的容器中

            // this.playButton.renderTo(this.el);
            this.control.renderTo(this.videobox);
            // this.recommend.renderTo(this.container);
            this.error.renderTo(this.container);

            this.title.renderTo(this.container);
            // this.list.renderTo(this.container);
        }

        /**
         * 渲染dom
         *
         * @param {HTMLELEMENT} parentNode
         * @memberof Video
         */

    }, {
        key: 'renderTo',
        value: function renderTo(parentNode) {
            parentNode.appendChild(this.el);
        }

        /**
         * 自定义事件列表
         * begin 每个视频开始播放时 一般用来发cv统计
         * ended 视频播放结束时
         * pause 视频暂停
         * play 视频播放
         * switch 视频切换
         * init 初始化视频 主要用于发vv统计
         */

    }, {
        key: 'initEvent',
        value: function initEvent() {
            var core = this.core;
            var control = this.control;
            // let recommend = this.recommend;
            var title = this.title;
            // let list = this.list;
            var error = this.error;
            var self = this;
            var initvolume = pcVideoUtil.playerGetCookie('videoVolume') || 0.5;

            core.on('timeupdate', function (e) {
                // console.log(self.first)
                var currentTime = core.getCurrentTime();
                var bufferedTime = core.getBuffered();
                var duration = core.getDuration();

                if (isNaN(duration)) {
                    duration = 0;
                }

                /** 视频资源下载完成 */
                if (self.end == true && bufferedTime == duration && duration != 0) {
                    self.vStat.sendVplayer(307000);
                    self.end = false;
                }

                control.setCurrentTime(currentTime);
                control.setTotalTime(duration);

                /** 更新进度条 */
                if (duration != 0) {
                    control.setCurrentProgress(currentTime / duration);
                    control.setBufferProgress(bufferedTime / duration);
                }

                self.trigger('timeupdate', currentTime);
                self.currentTime = currentTime;
            });

            core.on('play', function () {
                control.changePlayBtnState('play');
                self.trigger('play');
            });

            core.on('loadstart', function () {
                // 发送统计
                // console.log('loadstart');
                /** 开始加载 */
                if (self.loadstartfirst == true) {
                    self.vStat.sendVplayer(208000);
                    self.loadstartfirst = false;
                }
                var time = 0;
                // 超过10秒报error
                self.timerhehe = setInterval(function () {
                    time++;
                    // console.log(time);
                    if (time >= 10) {
                        self.trigger('error', '9', core.el.currentTime);
                        clearInterval(self.timerhehe);
                    }
                }, 1000);
            });

            /** 获取资源长度 */
            core.on('loadedmetadata', function () {
                // console.log('loadedmetadata');
                core.setVolume(initvolume);
                control.setCurrentVolume(initvolume);
                control.setVolumeWarn(initvolume);

                self.trigger('init');
            });

            core.on('loadeddata', function () {
                /**
                 * loadeddata时取消10秒超时定时器
                 */
                clearInterval(self.timerhehe);

                /**
                 * 首字节响应发送统计
                 */
                if (self.loadeddatafirst == true) {
                    self.vStat.sendVplayer('302000');
                    self.loadeddatafirst = false;
                }
            });

            core.on('canplay', function () {
                // console.log('canplay')
                /**
                 * 首画面呈现，发送统计
                 */
                if (self.first_play == true) {
                    // self.showAppPopularize();

                    // 发送首画面呈现统计
                    self.vStat.sendVplayer('303000');
                    // 发送cv统计
                    self.vStat.sendMedia('cv'); // 正片

                    self.trigger('firstPlay');
                    self.first_play = false;
                }
                // core.el.play();
                self.trigger('canplay');
            });

            // 视频暂停
            core.on('pause', function () {
                control.changePlayBtnState('pause');
            });

            /**
             * 视频播放完成
             */
            core.on('ended', function () {
                self.ended(core, self, control);
            });

            core.on('error', function (e) {
                console.log('error', core.el.error, 'code', core.el.error.code);

                clearInterval(self.timerhehe);
                self.trigger('error', core.el.error.code, core.el.currentTime);
            });

            /**
             * 控制条播放
             */
            control.on('cplay', function () {
                /** 视频播放时发送统计 */
                self.vStat.sendVplayer('401000');
                self.play();
            });

            /**
             * 控制条暂停
             */
            control.on('cpause', function () {
                /** 视频暂停时发送统计 */
                self.vStat.sendVplayer('402000');
                self.pause();
            });

            /**
             * 静音
             */
            control.on('cmute', function () {
                core.setVolume(0.0);
                control.setCurrentVolume(0);
                control.setVolumeWarn(0);
                /** 视频静音时发送统计 */
                self.vStat.sendVplayer('405000');
            });

            /**
             * 取消静音
             */
            control.on('caloud', function () {
                var initVolume = pcVideoUtil.playerGetCookie('videoVolume');
                core.setVolume(initVolume);
                control.setCurrentVolume(initVolume);
                control.setVolumeWarn(initVolume);
            });

            /**
             * 控制条——进度seek
             */
            control.on('cprogress', function (percent) {
                var duration = core.getDuration();
                if (isNaN(duration)) {
                    return;
                }
                if (duration != 0) {
                    control.setCurrentProgress(percent);
                }
                // console.log(percent)
                core.setCurrentTime(duration * percent);

                /** 视频seek统计，第一次发403001 */
                self.vStat.sendVplayer('403' + pcVideoUtil.formatNum(++self.seekTime));
            });

            control.on('cpdown', function () {});

            /**
             * 控制条——进度条读管——移动
             */
            control.on('cpmove', function (percent) {
                var duration = core.getDuration();
                if (isNaN(duration)) {
                    return;
                }
                // console.log(percent)
                control.setCurrentProgress(percent);

                core.setCurrentTime(duration * percent);
            });

            var yinliang = function yinliang(percent) {
                var _class = '';
                // 音量改变设置cookie
                pcVideoUtil.playerSetCookie('videoVolume', percent, {
                    domain: '.ifeng.com',
                    path: '/',
                    expires: 60 * 24 * 360
                });
                // console.log(percent)
                control.setCurrentVolume(percent);
                control.setVolumeWarn(percent);
                core.setVolume(percent);
                control.volumeTipShow();

                if (percent >= 0 && percent <= 0.3) {
                    _class = 'little';
                } else if (percent > 0.3 && percent <= 0.6) {
                    _class = 'middle';
                } else {
                    _class = 'large';
                }

                pcVideoUtil.removeClass(control.mute, 'little');
                pcVideoUtil.removeClass(control.mute, 'middle');
                pcVideoUtil.removeClass(control.mute, 'large');

                if (percent == 0) {
                    $(control.aloud).show();
                    $(control.mute).hide();
                } else {
                    $(control.aloud).hide();
                    $(control.mute).show();
                }

                pcVideoUtil.addClass(control.mute, _class);

                var sendCode = Math.round(percent * 100);

                /** 音量调节统计 例： 80发送080 */
                self.vStat.sendVplayer('406' + pcVideoUtil.formatNum(sendCode));
            };

            /**
             * 控制条进度seek
             */
            control.on('c_v_progress', yinliang);

            /**
             * 控制条移动
             */
            control.on('cvmove', yinliang);

            /**
             * 控制条——进度条时间显示——移动
             */
            control.on('cpseekmove', function (percent) {
                var duration = core.getDuration();

                control.seekTimeShow(); // 显示
                var elW = $(this.el).width();
                // let elL = $(this.el).offset().left;

                var seekW = $(this.seekTimeAll).width();
                // let seekL = $(this.seekTimeAll).offset().left;

                var bi = seekW / 2 / elW;
                var oo = null;
                if (percent > bi && percent < 1 - bi) {
                    oo = percent - seekW / (2 * elW);
                } else if (percent < bi) {
                    oo = 0;
                } else if (percent > 1 - bi) {
                    oo = 1 - bi - seekW / (2 * elW);
                }

                control.setSeekProgress(oo);
                control.setSeekTime(duration * percent);

                if (self.mp4Data.preview.path && percent) {
                    control.showImgPreview(duration * percent, self.mp4Data.preview);
                }
            });

            /**
             * 控制条——进度条时间显示——隐藏
             */
            control.on('cpseekout', function () {
                control.seekTimeHide();
            });

            /**
             * 修改video视频清晰度 - 高清、标清
             */
            control.on('changeVideoRate', function (ele) {
                if (!self.mp4Data.gqSrc || !self.mp4Data.bqSrc) return;

                var time = core.getCurrentTime();
                // console.log(time)
                self.VideoTextConTimer = null;
                var __gid = window.gid;
                var tag = ele.getAttribute('data-tag');
                var src = tag == 'high' ? self.mp4Data.gqSrc : tag == 'middle' ? self.mp4Data.bqSrc : self.mp4Data.gqSrc;
                src = self.isAuth == 'auth' ? src + '?' + Object(__WEBPACK_IMPORTED_MODULE_12_f_component_video_auth__["a" /* default */])({ videoinfo: videoinfo, __gid: __gid, version: __WEBPACK_IMPORTED_MODULE_9_version__["a" /* default */] }) : src;
                var textstr = tag == 'high' ? '高清' : tag == 'middle' ? '标清' : '高清';
                $(ele).addClass('current').siblings().removeClass();
                $('.video_app_QRCode').hide();
                control.videoTextShow();
                control.setVideoTextCon('\u6B63\u5728\u5207\u6362\u5230\u201C' + textstr + '\u201D');
                core.el.src = src;
                self.updateSrcVideoUrl(src);
                core.setCurrentTime(time);
                core.play();
                control.setVideoTextCon('\u5DF2\u7ECF\u5207\u6362\u5230\u201C' + textstr + '\u201D');
                control.setVideoRateTxt(textstr);

                /** 提示消失 */
                self.VideoTextConTimer = setTimeout(function () {
                    control.videoTextHide();
                }, 800);

                var sendCode = tag == 'high' ? 1 : 0;

                /** 视频清晰度统计 */
                self.vStat.sendVplayer('11200' + sendCode);
            });

            /**
             * 全屏
             */
            control.on('full', function () {
                control.launchFullscreen(self.container);
                self.fullChange(self.container, 'full');
                title.show();

                self.showTimer = setInterval(function () {
                    title.showTime();
                }, 1000);

                /**
                 * 全屏切换统计
                 */
                self.vStat.sendVplayer('404000');
            });

            /**
             * 退出全屏
             */
            control.on('exit', function () {
                control.exitFullscreen(self.container);
                self.fullChange(self.container, 'exit');
                title.hide();

                self.showTimer = null;

                /**
                 * 全屏切换统计
                 */
                self.vStat.sendVplayer('404000');
            });

            /**
             * esc快捷键 退出
             */
            pcVideoUtil.bind(document, ['webkitfullscreenchange', 'fullscreenchange', 'mozfullscreenchange', 'msfullscreenchange'], function (ev) {
                // 监听全屏、退出全屏切换 为了监测esc触发退出全屏
                if (self.isfull) {
                    self.fullChange(self.container, 'exit');
                    title.hide();
                    self.list.initShow();
                    self.list.hide();
                    control.changeFull('exit');
                    self.showTimer = null;
                }

                if (self.isfull) {
                    self.isfull = false;
                } else {
                    self.isfull = true;
                }
            });

            title.on('close', function () {
                self.trigger('qpClose');
            });

            title.on('open', function () {
                self.trigger('qpOpen');
            });

            /**
             * 全屏时，改变视频尺寸
             */
            title.on('changeVideoSize', function (ele) {
                var _type = ele.getAttribute('data-tag');
                var sendCode = _type == 'half' ? '1' : _type == 'all' ? '2' : '3';
                core.el.style.width = _type == 'half' ? '50%' : '100%';
                core.el.style.height = _type == 'half' ? '50%' : _type == 'all' ? '100%' : 'auto';
                $(ele).addClass('current').siblings().removeClass();
                /**
                 * 发送全屏时画面尺寸统计
                 */
                self.vStat.sendVplayer('40400' + sendCode);
            });

            /**
             * 换节目
             */
            title.on('listshow', function (type) {
                self.list.initShow();
                self.list[type].addClass('current').siblings().removeClass('current');
                // 发送统计
                var sendCode = null;

                /**
                 * 发送点击视频列表按钮统计
                 */
                if (type == 'list') {
                    sendCode = '502000';
                    self.vStat.sendVplayer(sendCode);
                } else if (type == 'share') {
                    /**
                     * 发送点击分享按钮统计
                     */
                    sendCode = '503000';
                    self.vStat.sendVplayer(sendCode);
                }
            });

            /**
             * 分享统计
             */
            self.list.on('sendVplayer', function (_sendcode) {
                // console.log(_sendcode)
                self.vStat.sendVplayer(_sendcode);
            });

            /**
             * 错误提示界面，重播按钮
             */
            error.on('replay', function () {
                error.hide();
                self.recommend.initShow();
                self.recommend.hide();
                self.trigger('replay');
                self.src(self.srcVideoUrl);
                core.load();
                self.show();
                self.play();
            });

            /**
             * 检测卡顿
             */
            self.monitorTimer = setInterval(function () {
                self.kadun(core);
            }, 1000);

            /**
             * 鼠标悬浮在播放器上方
             */
            $('#player').on('mousemove', function (e) {
                control.show();
                if (self.isfull) {
                    title.show();
                }
                clearTimeout(control.hideTimer);
                control.hideTimer = null;
                if (!control.hideTimer && control.playBtnstatus == 'play') {
                    control.hideTimer = setTimeout(function () {
                        control.hide();
                        title.hide();
                    }, 2000);
                }
            });

            /**
             * 点击player区域，添加键盘快捷键
             */
            $('#playercontainer').on('click', function (e) {
                // e.stopPropagation();

                $(document).bind('keydown', function (e) {
                    self.processChange(e);
                });
                // return false;
                // $(box).unbind('mousedown');
            });

            /**
             * 解绑键盘快捷键
             */
            $(document).bind('mousedown', function (e) {
                $(document).unbind('keydown');
            });

            /**
             * 视频点击播放暂停
             */
            $('#player').on('click', function (e) {
                clearTimeout(self.conClickTimer);
                self.conClickTimer = setTimeout(function () {
                    if (core.__isPlayed) {
                        /**
                         * 视频播放统计
                         */
                        self.vStat.sendVplayer('402000');
                        self.pause();
                    } else {
                        /**
                         * 视频暂停统计
                         */
                        self.vStat.sendVplayer('401000');
                        self.play();
                    }
                }, 300);
            });

            /**
             * 双击全屏，退出全屏
             */
            $('#player').on('dblclick', function (e) {
                clearTimeout(self.conClickTimer);

                if (control.fullStatus == 'exit' && !self.isfull) {
                    control.launchFullscreen(self.container);
                    control.changeFull('full');
                    self.fullChange(self.container, 'full');
                    title.show();

                    self.showTimer = setInterval(function () {
                        title.showTime();
                    }, 1000);
                    /**
                     * 发送全屏切换统计
                     */
                    self.vStat.sendVplayer('404000');
                } else if (control.fullStatus == 'full' && self.isfull) {
                    control.exitFullscreen(self.container);
                    control.changeFull('exit');
                    self.fullChange(self.container, 'exit');
                    title.hide();

                    self.showTimer = null;
                    /**
                     * 发送全屏切换统计
                     */
                    self.vStat.sendVplayer('404000');
                }
            });
        }

        /**
         * 缓存视频源地址
         *
         * @param {string} url
         */

    }, {
        key: 'updateSrcVideoUrl',
        value: function updateSrcVideoUrl(url) {
            this.srcVideoUrl = url;
            window.srcVideoUrl = url;
        }

        /**
         * 设置播放视频源地址
         *
         * @param {string} url
         */

    }, {
        key: 'src',
        value: function src(url) {
            var core = this.core;
            core.el.src = url;
        }

        /**
         * 执行keydown的方法
         *
         * @param {object} e
         */

    }, {
        key: 'processChange',
        value: function processChange(e) {
            /**
             * 空格:32
             * 左:37
             * 上:38
             * 右:39
             * 下:40
             */
            if (!e) return;
            var _code = e.keyCode;
            var playBtnstatus = this.control.playBtnstatus;
            switch (_code) {
                /**
                 * 播放、暂停
                 */
                case 32:
                    if (playBtnstatus == 'pause') {
                        this.vStat.sendVplayer('401000');
                        this.play();
                    } else {
                        this.vStat.sendVplayer('402000');
                        this.pause();
                    }
                    e.preventDefault();

                    break;

                /**
                 * 快退
                 */
                case 37:
                    this.changeVideoFucntion('-');
                    e.preventDefault();

                    break;

                /**
                 * 声音加大
                 */
                case 38:
                    this.changeVolumeFucntion('+');
                    e.preventDefault();

                    break;

                /**
                 * 快进
                 */
                case 39:
                    this.changeVideoFucntion('+');
                    e.preventDefault();

                    break;

                /**
                 * 声音减小
                 */
                case 40:
                    this.changeVolumeFucntion('-');
                    e.preventDefault();

                    break;

                default:
                    break;
            }
        }

        /**
         * 全屏、退出全屏时的样式变化
         *
         * @param {HTMLELEMENT} ele
         * @param {string} type 状态
         */

    }, {
        key: 'fullChange',
        value: function fullChange(ele, type) {
            /**
             * 全屏时样式
             */
            if (type == 'full') {
                pcVideoUtil.addClass(ele, 'boxFullScreen');
            } else {
                /**
                 * 退出全屏时样式
                 */
                pcVideoUtil.removeClass(ele, 'boxFullScreen');
            }
            this.trigger('fullChange');
        }

        /**
         * 视频快退快进
         *
         * @param {string} tag 进退方向
         */

    }, {
        key: 'changeVideoFucntion',
        value: function changeVideoFucntion(tag) {
            var core = this.core;
            var duration = core.getDuration();
            var currentTime = null;
            if (isNaN(duration)) {
                duration = 0;
            }
            if (tag == '+') {
                currentTime = core.getCurrentTime() + 8;
                if (currentTime > duration) {
                    currentTime = duration;
                }
            } else {
                currentTime = core.getCurrentTime() - 8;
                if (currentTime < 0) {
                    currentTime = 0;
                }
            }
            core.setCurrentTime(currentTime);
            this.control.setCurrentTime(currentTime);
            this.control.setTotalTime(duration);
            if (duration != 0) {
                this.control.setCurrentProgress(currentTime / duration);
            }
        }

        /**
         * 音量增加减少
         *
         * @param {string} tag 增加减少方向
         */

    }, {
        key: 'changeVolumeFucntion',
        value: function changeVolumeFucntion(tag) {
            var core = this.core;
            var volume = core.getVolume();
            if (tag == '+') {
                volume += 0.1;
                if (volume > 1) {
                    volume = 1;
                }
                $(this.control.aloud).hide();
                $(this.control.mute).show();
            } else {
                volume -= 0.1;
                if (volume < 0) {
                    volume = 0;
                    $(this.control.aloud).show();
                    $(this.control.mute).hide();
                }
            }

            pcVideoUtil.playerSetCookie('videoVolume', volume, {
                domain: '.ifeng.com',
                path: '/',
                expires: 60 * 24 * 360
            });
            this.control.setCurrentVolume(volume);
            this.control.setVolumeWarn(volume);
            core.setVolume(volume);

            this.control.volumeTipShow();

            var _class = volume >= 0 && volume <= 0.3 ? 'little' : volume > 0.3 && volume <= 0.6 ? 'middle' : 'large';
            pcVideoUtil.removeClass(this.control.mute, 'little');
            pcVideoUtil.removeClass(this.control.mute, 'middle');
            pcVideoUtil.removeClass(this.control.mute, 'large');
            // if (percent == 0) {
            //     $(control.aloud).show();
            //     $(control.mute).hide();
            // } else {
            //     $(control.aloud).hide();
            //     $(control.mute).show();
            // }
            pcVideoUtil.addClass(this.control.mute, _class);
        }

        /**
         * 视频左下角 App 流行推广
         *
         * @memberof Video
         */

    }, {
        key: 'showAppPopularize',
        value: function showAppPopularize() {
            // body...
            var _this = this;
            var playtimes = pcVideoUtil.playerGetCookie('playtimes') || 1;
            pcVideoUtil.playerSetCookie('playtimes', ++playtimes, {
                domain: '.ifeng.com',
                path: '/',
                expires: 60 * 24 * 360
            });
            if (playtimes % 3 == 0) {
                $.ajax({
                    url: 'http://v.ifeng.com/flash/data/app/tuig.js',
                    type: 'get',
                    dataType: 'json',
                    success: function success(data) {
                        // var data = { "text": "[APP专享]野外发现红包袱 打开一看众人惊呆", "link": "http://v.ifeng.com/apps/index.shtml#_a_v1", "img": "http://p0.ifengimg.com/a/2016_23/6fb82450ea5e4c5_size14_w110_h110.jpg" };
                        document.getElementById('js_video_text').innerHTML = data.text + '<a id="js_show_code" href="javascript:void(0)">\u4E0B\u8F7D\u5BA2\u6237\u7AEF\u89C2\u770B</a>';

                        // _this.videoTextCon.html(data.text + '<a id="js_show_code" href="javascript:void(0)">下载客户端观看</a>');
                        pcVideoUtil.bind(document.getElementById('js_show_code'), 'click', function (e) {
                            clearTimeout(_this.appTimer);
                            this.appTimer = null;
                            // _this.videoPlay('pause', 'appClick');
                            pcVideoUtil.addClass(document.getElementsByClassName('video_app_QRCode')[0], 'video_app_QRCodeShow');
                        });

                        var appImgDom = document.createElement('img');
                        appImgDom.src = data.img;
                        document.getElementsByClassName('video_app_QRCode')[0].appendChild(appImgDom);

                        // pcVideoUtil.addClass(_this._textshow, 'videoTextShow');
                        _this.control.videoTextShow();
                        _this.appFlag = 1;
                        _this.appTimer = setTimeout(function () {
                            _this.control.videoTextHide();
                            $('.video_app_QRCode').hide();
                            // textBoxHide('click');
                        }, 30000);
                    },
                    error: function error(e) {
                        console.log(e);
                    }
                });
            }
        }

        /**
         * 卡顿测试函数
         *
         * @param {object} core
         */

    }, {
        key: 'kadun',
        value: function kadun(core) {
            // body...
            var _this = this;
            var tag = core.getPaused();

            if (tag) return;
            if (core.getCurrentTime() == 0) return;

            // console.log(tag)
            // console.log('lastMonitor:' + this.lastMonitor);
            // console.log(core.getCurrentTime());

            if (this.lastMonitor == core.getCurrentTime()) {
                if (this.monitorFlag) {
                    _this.vStat.sendVplayer('304' + pcVideoUtil.formatNum(++this.stopTimes)); //缓冲次数
                    // console.log('卡顿次数：' + pcVideoUtil.formatNum(this.stopTimes));
                }
                this.monitorFlag = 0;
                this.stopContinue++;
                console.log('this.stopContinue=====>', this.stopContinue);
                if (this.stopContinue > 5) {
                    // 卡顿时间超过5s，认为播放失败，显示后推荐
                    this.stopContinue = 0;
                    clearInterval(_this.monitorTimer);
                    _this.monitorTimer = null;
                    // videorecommendShow('error');显示后推荐
                }
            } else {
                this.monitorFlag = 1;
                if (this.stopContinue != 0) {
                    // console.log('卡顿持续时间：' + pcVideoUtil.formatNum(this.stopContinue));
                    _this.vStat.sendVplayer('309' + pcVideoUtil.formatNum(this.stopTimes) + pcVideoUtil.formatNum(this.stopContinue)); // 309xxxyyy x：卡的次数 y：卡几秒
                    this.stopContinue = 0;
                }
            }

            this.lastMonitor = core.getCurrentTime();
        }

        /**
         * 重新播放
         */

    }, {
        key: 'replay',
        value: function replay() {
            this.playList = this.originList.slice();
            var src = this.playList.shift();
            var core = this.core;
            core.src(src);
            core.play();
        }

        /**
         * 播放
         */

    }, {
        key: 'play',
        value: function play() {
            var core = this.core;
            core.play();
        }

        /**
         * 暂停播放
         */

    }, {
        key: 'pause',
        value: function pause() {
            var core = this.core;
            core.pause();
            this.trigger('pause');
            // vStat.sendVplayer('402000');
        }

        /**
         * 隐藏组件
         */

    }, {
        key: 'hide',
        value: function hide() {
            var core = this.core;
            core.hide();
            this.control.hideAll();
        }

        /**
         * 显示组件
         */

    }, {
        key: 'show',
        value: function show() {
            var core = this.core;
            core.show();
            this.control.showAll();
        }

        /**
         * 暂停视频播放
         */

    }, {
        key: 'stop',
        value: function stop() {
            var core = this.core;
            core.pause();
            this.control.setTime(0);
        }

        /**
         * 播放下一条视频
         *
         * @param {string} src
         */

    }, {
        key: 'next',
        value: function next(src) {
            var core = this.core;
            core.src(src);
            this.control.reset();
            this.playButton.changeState('pause');
        }

        /**
         * 得到当前播放时间
         *
         * @returns {number} 当前播放时间
         */

    }, {
        key: 'getCurrentTime',
        value: function getCurrentTime() {
            return this.currentTime;
        }

        /**
         * 销毁组件
         */

    }, {
        key: 'destory',
        value: function destory() {
            var core = this.core;
            this.off();
            this.title.destory();
            this.control.destory();
            this.poster.destory();
            this.playButton.destory();
            this.error.destory();
            core.destory();
        }
        /**
         * 播放结束
         */

    }, {
        key: 'ended',
        value: function ended(core, self, control) {

            core.el.currentTime = 0;

            /** 发送播放完毕统计 */
            self.vStat.sendVplayer('305000');

            var _sedataId = control.getInd();
            if (typeof window.sedata == 'undefined' || _sedataId < 0 || _sedataId > sedata.length) {
                self.recommend.initShow();
                core.hide();
                control.hide();
            } else {
                var link = window.sedata[_sedataId].link;

                window.location.href = link;
            }
        }
    }]);

    return Video;
}();

__WEBPACK_IMPORTED_MODULE_10_f_core_event__["a" /* default */].mixTo(Video);
/* harmony default export */ __webpack_exports__["a"] = (Video);

/***/ }),

/***/ "sB3e":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("52gC");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "sozY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 返回uid
 * @return {string} uid字符串
 */
function getRandomUid() {
    var tn = new Date().getTime() + (Math.round((1 << 12) * Math.random()) << 24);
    var sn = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZXX";
    var uuid = "";

    var fn1 = sn.charAt(parseInt(tn & 63));
    tn = tn >> 6;
    var fn2 = sn.charAt(parseInt(tn & 63));
    tn = tn >> 6;
    var fn3 = sn.charAt(parseInt(tn & 63));
    tn = tn >> 6;
    var fn4 = sn.charAt(parseInt(tn & 63));
    tn = tn >> 6;
    var fn5 = sn.charAt(parseInt(tn & 63));
    tn = tn >> 6;
    var fn6 = sn.charAt(parseInt(tn & 63));
    uuid += fn6 + fn5 + fn4 + fn3 + fn2 + fn1;

    return uuid;
}

/* harmony default export */ __webpack_exports__["a"] = (getRandomUid);

/***/ }),

/***/ "sq16":
/***/ (function(module, exports) {


if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div id=\"test-box\">\n    <div class=\"demo-info\" style=\"display:flex;justify-content: center;\">\n        <span class=\"item\" style=\"color: rgb(255, 0, 0);\">VDN</span>\n        <span class=\"item\" style=\"color: rgb(0, 255, 0);margin-left:10px;\">P2P</span>\n        <span class=\"item\" style=\"color: rgb(15, 11, 230);margin-left:10px;\">playing</span>\n        <span class=\"item\" style=\"color: rgb(230, 117, 11);margin-left:10px;\">P2P trying</span>\n    </div>\n    <ul class=\"clearfix\" id=\"info-container\">\n    </ul>\n</div>\n<div style=\"display:flex;margin-top:10px;width:100%;flex-wrap:wrap;justify-content: space-around;\">\n    <div class=\"videoInfo\" id=\"videoInfo\">\n    </div>\n    <div class=\"canvas-box\">\n        <canvas id=\"show-rate-box\" width=\"400\" height=\"100\"></canvas>\n        <div class=\"downspeed-box\">\n            <div class=\"http-speed-show item\" style=\"color: rgb(255, 0, 0);\">\n                VDN Speed\n                <span class=\"http-speed-number\" id=\"http-speed-number\">\n                    <span> 0 Kbps</span>\n                </span>\n            </div>\n            <div class=\"p2p-speed-show item\" style=\"color: rgb(0, 255, 0);\">\n                P2P Speed\n                <span class=\"p2p-speed-number\" id=\"p2p-speed-number\">\n                    <span> 0 Kbps</span>\n                </span>\n            </div>\n        </div>\n    </div>\n    <div class=\"flow-rate\">\n        <h3 class=\"flow-title\">流量统计：</h3>\n        <p id=\"download-info\">\n            <span class=\"cdn\">cdn下载量：0</span>\n            <span class=\"p2p\">p2p下载量：0</span>\n        </p>\n        <div class=\"p2pshare-rate\"></div>\n    </div>\n</div>\n<div class=\"support-c\">\n    <h3>此浏览器支持的特性：</h3>\n    <ul>\n        <li>HTMLVideoElement:\n            ")
    ; __append(escape(s.video?'是':'否'))
    ; __append("\n        </li>\n        <li>Media Source Extensions:\n            ")
    ; __append(escape(s.MSE?'是':'否'))
    ; __append("\n        </li>\n        <li>WebSocket:\n            ")
    ; __append(escape(s.websocket?'是':'否'))
    ; __append("\n        </li>\n        <li>WebRTC:getUserMedia:\n            ")
    ; __append(escape(s.getUserMedeia?'是':'否'))
    ; __append("\n        </li>\n        <li>WebRTC:webkitRTCPeerConnection:\n            ")
    ; __append(escape(s.connection?'是':'否'))
    ; __append("\n        </li>\n        <li>WebRTC:RTCIceCandidate:\n            ")
    ; __append(escape(s.candidate?'是':'否'))
    ; __append("\n        </li>\n        <li>WebRTC:RTCSessionDescription:\n            ")
    ; __append(escape(s.session?'是':'否'))
    ; __append("\n        </li>\n    </ul>\n</div>\n<div id=\"buffer-info\"></div>\n\n<style>\n    @viewport {\n        width: device-width;\n    }\n    html{\n        font-size: 100%;\n    }\n\n    ul,\n    li {\n        margin: 0;\n        padding: 0;\n    }\n\n    #ifeng-test-info-container {\n        max-width: 1000px;\n        margin: 0 auto;\n    }\n\n    #ifeng-test-info-container #test-box {\n        width: 100%;\n        /* background: rgba(0, 0, 0, 0.3); */\n        padding: 5px;\n        margin-top: 10px;\n    }\n\n    #ifeng-test-info-container #test-box ul li {\n        text-decoration: none;\n        float: left;\n        width: 20px;\n        height: 20px;\n        border-radius: 5px;\n        background: rgba(0, 0, 0, 0.3);\n        margin: 10px;\n        list-style: none;\n        position: relative;\n    }\n\n    #ifeng-test-info-container #test-box ul .vdn {\n        background: red;\n    }\n\n    #ifeng-test-info-container #test-box ul .peer {\n        background: green;\n    }\n\n    #ifeng-test-info-container #test-box ul .peertring {\n        background: orange;\n    }\n    #ifeng-test-info-container .flow-title{\n        margin:0;\n    }\n    #ifeng-test-info-container #test-box .info-box {\n        display: none;\n        position: absolute;\n        bottom: 20px;\n        left: 0;\n        width: 200px;\n        background: rgba(0, 0, 0, 0.5);\n        color: #fff;\n        padding-left: 10px;\n        box-sizing: border-box;\n    }\n\n    #ifeng-test-info-container #test-box .left {\n        float: left;\n        /*width:20%;*/\n        height: 100%;\n    }\n\n    #ifeng-test-info-container #test-box .right {\n        float: left;\n        /*width:80%;*/\n        height: 100%;\n    }\n\n    #ifeng-test-info-container .clearfix:after {\n        content: \".\";\n        display: block;\n        height: 0;\n        clear: both;\n        visibility: hidden;\n    }\n\n    #ifeng-test-info-container #test-box .playing {\n        display: none;\n        position: absolute;\n        left: 0;\n        top: 0;\n        width: 100%;\n        height: 100%;\n        background: blue;\n    }\n\n    #ifeng-test-info-container .p2p {\n        margin-left: 10px;\n    }\n\n    #ifeng-test-info-container table {\n        border-collapse: collapse;\n    }\n\n    #ifeng-test-info-container .canvas-box {\n        position: relative;\n        width: 400px;\n        height: 100px;\n    }\n\n    #ifeng-test-info-container .downspeed-box {\n        position: absolute;\n        left: 0;\n        top: 0;\n        z-index: 99;\n        height: 36px;\n        width: 380px;\n        text-align: left;\n        padding: 4px;\n        font-size: 10px;\n    }\n\n    #ifeng-test-info-container .item::before {\n        content: \"\";\n        border-style: solid;\n        border-width: 0 10px;\n        margin-right: 5px;\n    }\n\n    #ifeng-test-info-container .downspeed-box .p2p-speed-show {\n        margin-top: 5px;\n    }\n\n    #ifeng-test-info-container .flow-rate {\n        margin-left: 10px;\n    }\n\n    #ifeng-test-info-container #download-info{\n        margin:10px 0;\n    }\n\n    #ifeng-test-info-container .demo-info {\n        font-size: 12px;\n    }\n</style>")
  }
  return __output.join("");

}

/***/ }),

/***/ "t8x9":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("77Pl");
var aFunction = __webpack_require__("lOnJ");
var SPECIES = __webpack_require__("dSzd")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "tHOs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_recodeVideo__ = __webpack_require__("rahC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_recodeVideoMse__ = __webpack_require__("eLxI");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__lib_recodeVideo__["a"]; });
/* unused harmony reexport recodeVideoMse */





/***/ }),

/***/ "ttlt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u+wB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uqUo":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("kM2E");
var core = __webpack_require__("FeBl");
var fails = __webpack_require__("S82l");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "vFc/":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("TcQ7");
var toLength = __webpack_require__("QRG4");
var toAbsoluteIndex = __webpack_require__("fkB2");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "vIB/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("O4g8");
var $export = __webpack_require__("kM2E");
var redefine = __webpack_require__("880/");
var hide = __webpack_require__("hJx8");
var has = __webpack_require__("D2L2");
var Iterators = __webpack_require__("/bQp");
var $iterCreate = __webpack_require__("94VQ");
var setToStringTag = __webpack_require__("e6n0");
var getPrototypeOf = __webpack_require__("PzxK");
var ITERATOR = __webpack_require__("dSzd")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "vNqB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 返回gid 视频请求唯一id
 * @return {string}
 */
function createGid() {
    var key = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';
    // 28
    var ramStr = parseInt(Math.random() * 268435455).toString(2);
    // 44
    var mtimeStr = new Date().getTime().toString(2);

    while (ramStr.length < 28) {
        ramStr = '0' + ramStr;
    }

    while (mtimeStr.length < 44) {
        mtimeStr = '0' + mtimeStr;
    }

    var binaryStr = ramStr + mtimeStr;

    var outStr = '';

    for (var i = 0; i < 12; i++) {
        outStr += key.charAt(parseInt(binaryStr.substr(i * 6, 6), 2));
    }
    return outStr;
}

/* harmony default export */ __webpack_exports__["a"] = (createGid);

/***/ }),

/***/ "wxAW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("C4MV");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ "xGkn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("4mcu");
var step = __webpack_require__("EGZi");
var Iterators = __webpack_require__("/bQp");
var toIObject = __webpack_require__("TcQ7");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("vIB/")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "xH/j":
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__("hJx8");
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),

/***/ "xnc9":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "zQR9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("h65t")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("vIB/")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ })

/******/ });


// WEBPACK FOOTER //
// js/simple.bundle.js